import React from "react"
// old code base *****************************************
export const AddContactNew = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.229 18.3319L16.911 17.5339C16.75 17.1289 16.501 16.7659 16.181 16.4699L16.123 16.4159C15.62 15.9499 14.96 15.6899 14.274 15.6899H9.72402C9.03802 15.6899 8.37702 15.9499 7.87402 16.4149L7.81602 16.4689C7.49702 16.7649 7.24802 17.1279 7.08602 17.5329L6.77002 18.3319"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.2461 7.93001C15.4861 9.17001 15.4861 11.181 14.2461 12.422C13.0061 13.663 10.9951 13.662 9.75411 12.422C8.51311 11.182 8.51411 9.17101 9.75411 7.93001C10.9941 6.68901 13.0051 6.69001 14.2461 7.93001"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconRefreshTable = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props} fill="none">
        <path
            d="M5.625 6.875H2.5V3.75"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5 10C17.5 5.8575 14.1425 2.5 10 2.5C6.97502 2.5 4.37419 4.295 3.18835 6.875"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.375 13.125H17.5V16.25"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.5 10C2.5 14.1425 5.8575 17.5 10 17.5C13.025 17.5 15.6258 15.705 16.8117 13.125"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconColRange = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V15.8333C17.5 16.7542 16.7542 17.5 15.8333 17.5H4.16667C3.24583 17.5 2.5 16.7542 2.5 15.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5Z"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.49998 2.5V17.5" stroke="black" strokeOpacity="0.7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 2.5V17.5" stroke="black" strokeOpacity="0.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const SendIconSubTable = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.74708 6.4265L5.94063 11.7972C6.08958 12.4664 6.97851 12.6106 7.33098 12.0229L12.8904 2.75688C13.1943 2.25142 12.8304 1.60847 12.2407 1.60847H1.76016C1.08419 1.60847 0.745869 2.4253 1.2237 2.90312L4.74708 6.4265Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.74708 6.4265L5.94063 11.7972C6.08958 12.4664 6.97851 12.6106 7.33098 12.0229L12.8904 2.75688C13.1943 2.25142 12.8304 1.60847 12.2407 1.60847H1.76016C1.08419 1.60847 0.745869 2.4253 1.2237 2.90312L4.74708 6.4265Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.74708 6.4265L5.94063 11.7972C6.08958 12.4664 6.97851 12.6106 7.33098 12.0229L12.8904 2.75688C13.1943 2.25142 12.8304 1.60847 12.2407 1.60847H1.76016C1.08419 1.60847 0.745869 2.4253 1.2237 2.90312L4.74708 6.4265Z"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8926 1.98578L4.74456 6.42707L12.8926 1.98578Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8926 1.98578L4.74456 6.42707L12.8926 1.98578Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M12.8926 1.98578L4.74456 6.42707"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CheckIconSubTable = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3334 7.58334L10.5 20.4167L4.66669 14.5833"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AddSendIcon = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 15H4.5C3.67125 15 3 14.3287 3 13.5V4.5C3 3.67125 3.67125 3 4.5 3H13.5C14.3287 3 15 3.67125 15 4.5V13.5C15 14.3287 14.3287 15 13.5 15Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9 6V12" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 9H6" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ContactSendIconItem = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0503 10.6936L9.8648 10.2281C9.77089 9.99188 9.62564 9.78013 9.43897 9.60747L9.40514 9.57597C9.11172 9.30413 8.72672 9.15247 8.32655 9.15247H5.67239C5.27222 9.15247 4.88664 9.30413 4.59322 9.57538L4.55939 9.60688C4.3733 9.77955 4.22805 9.9913 4.13355 10.2275L3.94922 10.6936"
            fill="#9747FF"
            fillOpacity="0.3"
        />
        <path
            d="M10.0503 10.6936L9.8648 10.2281C9.77089 9.99188 9.62564 9.78013 9.43897 9.60747L9.40514 9.57597C9.11172 9.30413 8.72672 9.15247 8.32655 9.15247H5.67239C5.27222 9.15247 4.88664 9.30413 4.59322 9.57538L4.55939 9.60688C4.3733 9.77955 4.22805 9.9913 4.13355 10.2275L3.94922 10.6936"
            stroke="#9747FF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.31015 4.62585C9.03348 5.34918 9.03348 6.52227 8.31015 7.24618C7.58681 7.9701 6.41373 7.96952 5.68981 7.24618C4.9659 6.52285 4.96648 5.34977 5.68981 4.62585C6.41315 3.90193 7.58623 3.90252 8.31015 4.62585"
            fill="#9747FF"
            fillOpacity="0.3"
        />
        <path
            d="M8.31015 4.62585C9.03348 5.34918 9.03348 6.52227 8.31015 7.24618C7.58681 7.9701 6.41373 7.96952 5.68981 7.24618C4.9659 6.52285 4.96648 5.34977 5.68981 4.62585C6.41315 3.90193 7.58623 3.90252 8.31015 4.62585"
            stroke="#9747FF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0833 12.25H2.91667C2.27208 12.25 1.75 11.7279 1.75 11.0833V2.91667C1.75 2.27208 2.27208 1.75 2.91667 1.75H11.0833C11.7279 1.75 12.25 2.27208 12.25 2.91667V11.0833C12.25 11.7279 11.7279 12.25 11.0833 12.25Z"
            fill="#9747FF"
            fillOpacity="0.3"
            stroke="#9747FF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ThirdPartiSendIconItem = (props: any) => (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.16711 4.66571V2.33141C8.16719 2.14006 8.26106 1.9609 8.41835 1.85193C8.57563 1.74296 8.77635 1.71802 8.95553 1.78518L11.8734 2.87939C12.1013 2.96483 12.2523 3.18277 12.2521 3.4262V12.2522"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M8.16711 4.66571V2.33141C8.16719 2.14006 8.26106 1.9609 8.41835 1.85193C8.57563 1.74296 8.77635 1.71802 8.95553 1.78518L11.8734 2.87939C12.1013 2.96483 12.2523 3.18277 12.2521 3.4262V12.2522"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.36594 4.66565H8.63397C9.02073 4.66565 9.33426 4.97918 9.33426 5.36594V12.2521H4.66565V5.36594C4.66565 4.97918 4.97918 4.66565 5.36594 4.66565Z"
            fill="#307ADE"
            fillOpacity="0.3"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.41638 4.66565V3.49849C6.41638 3.17619 6.1551 2.91492 5.8328 2.91492H3.49849C3.17619 2.91492 2.91492 3.17619 2.91492 3.49849V6.41638"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M6.41638 4.66565V3.49849C6.41638 3.17619 6.1551 2.91492 5.8328 2.91492H3.49849C3.17619 2.91492 2.91492 3.17619 2.91492 3.49849V6.41638"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.66569 1.7478V2.91496" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.8357 12.2521H1.16418" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 7.99211H7.87536" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 6.41642H7.87536" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 9.56767H7.87536" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.7478 12.2521V6.99996C1.7478 6.67766 2.00908 6.41638 2.33138 6.41638H4.66568"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ThirdPartiSendIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.16711 4.66571V2.33141C8.16719 2.14006 8.26106 1.9609 8.41835 1.85193C8.57563 1.74296 8.77635 1.71802 8.95553 1.78518L11.8734 2.87939C12.1013 2.96483 12.2523 3.18277 12.2521 3.4262V12.2522"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.36594 4.66565H8.63397C9.02073 4.66565 9.33426 4.97918 9.33426 5.36594V12.2521H4.66565V5.36594C4.66565 4.97918 4.97918 4.66565 5.36594 4.66565Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.41638 4.66565V3.49849C6.41638 3.17619 6.1551 2.91492 5.8328 2.91492H3.49849C3.17619 2.91492 2.91492 3.17619 2.91492 3.49849V6.41638"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.66569 1.7478V2.91496" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.8357 12.2521H1.16418" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 7.99211H7.87536" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 6.41642H7.87536" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.12463 9.56767H7.87536" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.7478 12.2521V6.99996C1.7478 6.67766 2.00908 6.41638 2.33138 6.41638H4.66568"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ContactSendIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0503 10.6936L9.8648 10.2281C9.77089 9.99188 9.62564 9.78013 9.43897 9.60747L9.40514 9.57597C9.11172 9.30413 8.72672 9.15247 8.32655 9.15247H5.67239C5.27222 9.15247 4.88664 9.30413 4.59322 9.57538L4.55939 9.60688C4.3733 9.77955 4.22805 9.9913 4.13355 10.2275L3.94922 10.6936"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.31015 4.62585C9.03348 5.34918 9.03348 6.52227 8.31015 7.24618C7.58681 7.9701 6.41373 7.96952 5.68981 7.24618C4.9659 6.52285 4.96648 5.34977 5.68981 4.62585C6.41315 3.90193 7.58623 3.90252 8.31015 4.62585"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0833 12.25H2.91667C2.27208 12.25 1.75 11.7279 1.75 11.0833V2.91667C1.75 2.27208 2.27208 1.75 2.91667 1.75H11.0833C11.7279 1.75 12.25 2.27208 12.25 2.91667V11.0833C12.25 11.7279 11.7279 12.25 11.0833 12.25Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PublicPersonne = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.33335 15V7.5V15Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M3.33335 15V7.5" stroke="#CE8E5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.6667 7.5V15V7.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M16.6667 7.5V15" stroke="#CE8E5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 7.5V15V7.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M6.66667 7.5V15" stroke="#CE8E5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M10 7.5V15V7.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M10 7.5V15" stroke="#CE8E5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M13.3334 7.5V15V7.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M13.3334 7.5V15" stroke="#CE8E5F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 5.22916C9.94251 5.22916 9.89584 5.27582 9.89667 5.33332C9.89667 5.39082 9.94334 5.43749 10.0008 5.43749C10.0583 5.43749 10.105 5.39082 10.105 5.33332C10.1042 5.27582 10.0575 5.22916 10 5.22916Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
        />
        <path
            d="M10 5.22916C9.94251 5.22916 9.89584 5.27582 9.89667 5.33332C9.89667 5.39082 9.94334 5.43749 10.0008 5.43749C10.0583 5.43749 10.105 5.39082 10.105 5.33332C10.1042 5.27582 10.0575 5.22916 10 5.22916"
            stroke="#CE8E5F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9167 7.5H2.08337V5.30083L10 2.5L17.9167 5.30083V7.5Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
            stroke="#CE8E5F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5 15H2.50002L1.66669 15.8333V17.5H18.3334V15.8333L17.5 15Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
            stroke="#CE8E5F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ParicularPersonne = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.3575 15.2767L14.0925 14.6117C13.9583 14.2742 13.7508 13.9717 13.4842 13.725L13.4358 13.68C13.0167 13.2917 12.4667 13.075 11.895 13.075H8.10333C7.53166 13.075 6.98083 13.2917 6.56166 13.6792L6.51333 13.7242C6.2475 13.9708 6.04 14.2733 5.905 14.6108L5.64166 15.2767"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.8717 6.60832C12.905 7.64165 12.905 9.31749 11.8717 10.3517C10.8383 11.3858 9.16251 11.385 8.12834 10.3517C7.09417 9.31832 7.09501 7.64249 8.12834 6.60832C9.16167 5.57415 10.8375 5.57499 11.8717 6.60832"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8333 17.5H4.16667C3.24583 17.5 2.5 16.7542 2.5 15.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V15.8333C17.5 16.7542 16.7542 17.5 15.8333 17.5Z"
            fill="#9747FF"
            fillOpacity="0.3"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PrivatePersonne = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6674 6.66529V3.33056C11.6675 3.05721 11.8016 2.80127 12.0263 2.6456C12.251 2.48992 12.5377 2.45429 12.7937 2.55024L16.9621 4.11339C17.2877 4.23545 17.5033 4.5468 17.5031 4.89455V17.5031"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M11.6674 6.66529V3.33056C11.6675 3.05721 11.8016 2.80127 12.0263 2.6456C12.251 2.48992 12.5377 2.45429 12.7937 2.55024L16.9621 4.11339C17.2877 4.23545 17.5033 4.5468 17.5031 4.89455V17.5031"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.6657 6.66528H12.3343C12.8868 6.66528 13.3347 7.11318 13.3347 7.6657V17.5031H6.66528V7.6657C6.66528 7.11318 7.11319 6.66528 7.6657 6.66528Z"
            fill="#307ADE"
            fillOpacity="0.3"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.16633 6.66529V4.99793C9.16633 4.5375 8.79308 4.16425 8.33265 4.16425H4.99793C4.5375 4.16425 4.16425 4.5375 4.16425 4.99793V9.16633"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M9.16633 6.66529V4.99793C9.16633 4.5375 8.79308 4.16425 8.33265 4.16425H4.99793C4.5375 4.16425 4.16425 4.5375 4.16425 4.99793V9.16633"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.66531 2.49689V4.16425V2.49689Z"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M6.66531 2.49689V4.16425"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3368 17.5031H1.66321H18.3368Z"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M18.3368 17.5031H1.66321"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74951 11.4173H11.2506H8.74951Z"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M8.74951 11.4173H11.2506"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74951 9.16635H11.2506H8.74951Z"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M8.74951 9.16635H11.2506"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.74951 13.6682H11.2506H8.74951Z"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M8.74951 13.6682H11.2506"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.49689 17.5031V10C2.49689 9.53957 2.87014 9.16632 3.33057 9.16632H6.66529"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M2.49689 17.5031V10C2.49689 9.53957 2.87014 9.16632 3.33057 9.16632H6.66529"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const BillingHistry = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.24718 5.99875H15.7528" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.12421 9.00003H5.24843" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.7521 12.7516C15.7522 14.4089 14.4088 15.7526 12.7515 15.7528C11.1038 15.7285 9.77393 14.3986 9.74956 12.7509C9.74974 11.0934 11.0936 9.74982 12.7511 9.75C14.4087 9.75018 15.7522 11.094 15.7521 12.7516"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.6721 11.6271V12.9297L13.6965 13.5546"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.49936 13.5019H4.49811C3.25496 13.5019 2.24718 12.4941 2.24718 11.2509V5.24844C2.24718 4.00528 3.25496 2.9975 4.49811 2.9975H13.5019C14.745 2.9975 15.7528 4.00528 15.7528 5.24844V8.24969"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PostCharusIcon = (props: any) => (
    <svg width="21" height="20" viewBox="0 0 21 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 17.5V5.41667C18 3.80584 16.6942 2.5 15.0833 2.5V2.5C13.4725 2.5 12.1667 3.80584 12.1667 5.41667V17.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.33333 2.5V2.5C4.49238 2.5 3 3.99238 3 5.83333V17.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.33333 2.50004H14.6667"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M18 16.6667H3" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="5.5"
            y="10.8334"
            width="4.16667"
            height="2.5"
            rx="0.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.91667 8.33329H9.25"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ClickEventIcon = (props: any) => (
    <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.49561 15H7.99706" stroke="#154492" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 4.49561V7.99706" stroke="#154492" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.0979 10.0979L7.53021 7.53021"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.902 10.0979L22.4697 7.53021"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.0979 19.902L7.53021 22.4698"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.471 23.6231L21.564 21.0234C21.6821 20.7424 21.9057 20.5188 22.1867 20.4006L24.7904 19.3055C25.2451 19.1141 25.5302 18.6574 25.5024 18.1648C25.4746 17.6723 25.14 17.2505 24.6667 17.1114L17.6639 15.0503C17.2545 14.9297 16.8119 15.0425 16.5101 15.3443C16.2083 15.6461 16.0955 16.0887 16.2161 16.4981L18.2768 23.4996C18.4159 23.9729 18.8378 24.3075 19.3303 24.3352C19.8229 24.363 20.2796 24.0778 20.471 23.6231Z"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PostalIconStat = (props: any) => (
    <svg width="28" {...props} height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24.5 24.5V7.58333C24.5 5.32817 22.6719 3.5 20.4167 3.5V3.5C18.1615 3.5 16.3334 5.32817 16.3334 7.58333V24.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16667 3.5V3.5C5.58934 3.5 3.5 5.58934 3.5 8.16667V24.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16663 3.50002H19.8333"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M24.5 23.3333H3.5" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="7"
            y="15.1667"
            width="5.83333"
            height="3.5"
            rx="0.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.58337 11.6666H12.25"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EnvelopeWarnIconStat = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3333 15.7582V7.03851"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.1666 21H5.83331C3.90015 21 2.33331 19.4332 2.33331 17.5V7.03851"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6586 12.8544L3.59915 9.13619C2.82098 8.72552 2.33331 7.91819 2.33331 7.03852V7.00002C2.33331 5.71085 3.37748 4.66669 4.66665 4.66669H20.9615C22.2716 4.66669 23.3333 5.72835 23.3333 7.03852V7.06185C23.3333 7.92752 22.8538 8.72319 22.0873 9.12685L15.008 12.8555C13.6465 13.5719 12.0201 13.5719 10.6586 12.8544Z"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3996 24.983L15.8503 23.4337C15.4128 22.9962 15.1666 22.4024 15.1666 21.784V19.0505C15.1666 18.4322 15.4128 17.8384 15.8503 17.4009L17.3996 15.8515C17.8371 15.4129 18.431 15.1667 19.0493 15.1667H21.7828C22.4011 15.1667 22.995 15.4129 23.4325 15.8504L24.983 17.4009C25.4205 17.8384 25.6666 18.431 25.6666 19.0505V21.7829C25.6666 22.4012 25.4205 22.995 24.983 23.4325L23.4325 24.983C22.9961 25.4205 22.4023 25.6667 21.7828 25.6667H19.0493C18.431 25.6667 17.8371 25.4205 17.3996 24.983V24.983Z"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.4178 20.2102V18.1638"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.4166 22.4665C20.3606 22.4665 20.3151 22.512 20.3163 22.568C20.3163 22.624 20.3618 22.6695 20.4178 22.6695C20.4738 22.6695 20.5181 22.624 20.5181 22.568C20.5181 22.512 20.4726 22.4665 20.4166 22.4665"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EnvelopeCloseWarnIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3333 15.7582V7.03851"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.1666 21H5.83331C3.90015 21 2.33331 19.4332 2.33331 17.5V7.03851"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6586 12.8544L3.59915 9.13619C2.82098 8.72552 2.33331 7.91819 2.33331 7.03852V7.00002C2.33331 5.71085 3.37748 4.66669 4.66665 4.66669H20.9615C22.2716 4.66669 23.3333 5.72835 23.3333 7.03852V7.06185C23.3333 7.92752 22.8538 8.72319 22.0873 9.12685L15.008 12.8555C13.6465 13.5719 12.0201 13.5719 10.6586 12.8544Z"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3996 24.983L15.8503 23.4337C15.4128 22.9962 15.1666 22.4024 15.1666 21.784V19.0505C15.1666 18.4322 15.4128 17.8384 15.8503 17.4009L17.3996 15.8515C17.8371 15.4129 18.431 15.1667 19.0493 15.1667H21.7828C22.4011 15.1667 22.995 15.4129 23.4325 15.8504L24.983 17.4009C25.4205 17.8384 25.6666 18.431 25.6666 19.0505V21.7829C25.6666 22.4012 25.4205 22.995 24.983 23.4325L23.4325 24.983C22.9961 25.4205 22.4023 25.6667 21.7828 25.6667H19.0493C18.431 25.6667 17.8371 25.4205 17.3996 24.983V24.983Z"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.4178 20.2102V18.1638"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.4166 22.4665C20.3606 22.4665 20.3151 22.512 20.3163 22.568C20.3163 22.624 20.3618 22.6695 20.4178 22.6695C20.4738 22.6695 20.5181 22.624 20.5181 22.568C20.5181 22.512 20.4726 22.4665 20.4166 22.4665"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ProcessingIconStat = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.28003 6.75135H20.72"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.52002 3.39136H18.48"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.84 10.08H6.15998C4.92238 10.08 3.91998 11.0824 3.91998 12.32V21.28C3.91998 22.5176 4.92238 23.52 6.15998 23.52H21.84C23.0776 23.52 24.08 22.5176 24.08 21.28V12.32C24.08 11.0824 23.0776 10.08 21.84 10.08Z"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="16.24"
            y="13.44"
            width="4.48"
            height="3.36"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.28003 16.8H10.64" stroke="#154492" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.28003 20.16H12.88"
            stroke="#154492"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EnvelopeOpenStat = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.49884 10.5V21C3.49884 22.9332 5.06567 24.5 6.99884 24.5H20.9988C22.932 24.5 24.4988 22.9332 24.4988 21V10.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.13098 7.89251L11.9688 2.98901C13.188 2.11401 14.8295 2.11518 16.0486 2.99018L22.8573 7.87968C25.0378 9.44534 25.0366 12.0062 22.855 13.5695L16.03 18.4637C14.8108 19.3387 13.1693 19.3375 11.9501 18.4625L5.12864 13.5637C2.95631 12.0027 2.95748 9.45118 5.13098 7.89251Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.0023 14.8983V12.8333C21.0023 11.5442 19.9582 10.5 18.669 10.5H9.33565C8.04649 10.5 7.00232 11.5442 7.00232 12.8333V14.8458"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const UserDecline = (props: any) => (
    <svg width="28" {...props} height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="14"
            cy="9.62318"
            r="4.9604"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66278 23.3372C4.66278 20.4368 7.01459 18.085 9.91497 18.085H12.9297"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3558 23.0664L22.4829 18.9394"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3558 18.9394L22.4829 23.0664"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ContactOperation = (props: any) => (
    <svg width="21" height="21" {...props} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.0754 16.0405L14.7971 15.3423C14.6563 14.9879 14.4384 14.6703 14.1584 14.4113L14.1076 14.364C13.6675 13.9563 13.09 13.7288 12.4898 13.7288H8.50852C7.90827 13.7288 7.32989 13.9563 6.88977 14.3631L6.83902 14.4104C6.55989 14.6694 6.34202 14.987 6.20027 15.3414L5.92377 16.0405"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.4652 6.93877C13.5502 8.02377 13.5502 9.7834 12.4652 10.8693C11.3802 11.9551 9.6206 11.9543 8.53472 10.8693C7.44885 9.78427 7.44972 8.02465 8.53472 6.93877C9.61972 5.8529 11.3793 5.85377 12.4652 6.93877"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.625 18.375H4.375C3.40812 18.375 2.625 17.5919 2.625 16.625V4.375C2.625 3.40812 3.40812 2.625 4.375 2.625H16.625C17.5919 2.625 18.375 3.40812 18.375 4.375V16.625C18.375 17.5919 17.5919 18.375 16.625 18.375Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const MailCharusIcon = (props: any) => (
    <svg width="21" height="20" viewBox="0 0 21 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3117 10.5983L17.0667 8.05246C17.6508 7.65746 18 6.99829 18 6.29329V6.29329C18 5.11829 17.0483 4.16663 15.8742 4.16663H5.13833C3.96416 4.16663 3.0125 5.11829 3.0125 6.29246V6.29246C3.0125 6.99746 3.36166 7.65663 3.94583 8.05246L7.70083 10.5983C9.395 11.7466 11.6175 11.7466 13.3117 10.5983V10.5983Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.29248V14.1666C3 15.5475 4.11917 16.6666 5.5 16.6666H15.5C16.8808 16.6666 18 15.5475 18 14.1666V6.29331"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const WaringIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 2.5V2.5C14.6425 2.5 18 5.8575 18 10V10C18 14.1425 14.6425 17.5 10.5 17.5V17.5C6.3575 17.5 3 14.1425 3 10V10C3 5.8575 6.3575 2.5 10.5 2.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 10.4167V6.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4992 13.3333C10.3842 13.3333 10.2908 13.4267 10.2917 13.5417C10.2917 13.6567 10.385 13.75 10.5 13.75C10.615 13.75 10.7083 13.6567 10.7083 13.5417C10.7083 13.4267 10.615 13.3333 10.4992 13.3333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PostalMediaType = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.838 13V3.59463C12.838 2.34079 11.8216 1.32436 10.5677 1.32436V1.32436C9.3139 1.32436 8.29746 2.34079 8.29746 3.59463V13"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.838 13V3.59463C12.838 2.34079 11.8216 1.32436 10.5677 1.32436V1.32436C9.3139 1.32436 8.29746 2.34079 8.29746 3.59463V13"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M12.838 13V3.59463C12.838 2.34079 11.8216 1.32436 10.5677 1.32436V1.32436C9.3139 1.32436 8.29746 2.34079 8.29746 3.59463V13"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75659 1.32436V1.32436C2.32364 1.32436 1.162 2.486 1.162 3.91895V13"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75659 1.32436V1.32436C2.32364 1.32436 1.162 2.486 1.162 3.91895V13"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M3.75659 1.32436V1.32436C2.32364 1.32436 1.162 2.486 1.162 3.91895V13"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.75644 1.32432H10.2429"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8377 12.3512H1.162"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="3.10815"
            y="7.81068"
            width="3.24324"
            height="1.94595"
            rx="0.5"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.43209 5.86471H6.02668"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendHoverIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29501 10.1242L8.77084 16.765C8.95501 17.5925 10.0542 17.7708 10.49 17.0442L17.3642 5.58667C17.74 4.96167 17.29 4.16667 16.5608 4.16667H3.60168C2.76584 4.16667 2.34751 5.17667 2.93834 5.7675L7.29501 10.1242Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.3667 4.63333L7.29169 10.125"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CloseMenuIcon = (props: any) => (
    <svg width="32" height="32" {...props} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.6667 10.6667L21.3334 21.3334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.3334 10.6667L10.6667 21.3334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EyeMenuIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.7683 8.23333C12.7442 9.20917 12.7442 10.7933 11.7683 11.7708C10.7925 12.7467 9.20834 12.7467 8.23084 11.7708C7.255 10.795 7.255 9.21083 8.23084 8.23333C9.20834 7.25583 10.7917 7.25583 11.7683 8.23333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 10C2.5 9.45083 2.62667 8.9075 2.87167 8.40667V8.40667C4.13417 5.82583 6.92417 4.16667 10 4.16667C13.0758 4.16667 15.8658 5.82583 17.1283 8.40667V8.40667C17.3733 8.9075 17.5 9.45083 17.5 10C17.5 10.5492 17.3733 11.0925 17.1283 11.5933V11.5933C15.8658 14.1742 13.0758 15.8333 10 15.8333C6.92417 15.8333 4.13417 14.1742 2.87167 11.5933V11.5933C2.62667 11.0925 2.5 10.5492 2.5 10Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendMenuIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.75401 12.149L10.525 20.118C10.746 21.111 12.065 21.325 12.588 20.453L20.837 6.704C21.288 5.954 20.748 5 19.873 5H4.32201C3.31901 5 2.81701 6.212 3.52601 6.921L8.75401 12.149Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.84 5.56006L8.75 12.1501"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChorusReadIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.74942 5.25V10.5C1.74942 11.4666 2.53284 12.25 3.49942 12.25H10.4994C11.466 12.25 12.2494 11.4666 12.2494 10.5V5.25"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5655 3.94626L5.98442 1.49451C6.594 1.05701 7.41475 1.05759 8.02434 1.49509L11.4287 3.93984C12.5189 4.72267 12.5183 6.00309 11.4275 6.78476L8.015 9.23184C7.40542 9.66934 6.58467 9.66876 5.97509 9.23126L2.56434 6.78184C1.47817 6.00134 1.47875 4.72559 2.5655 3.94626Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5012 7.44917V6.41667C10.5012 5.77208 9.97909 5.25 9.33451 5.25H4.66784C4.02326 5.25 3.50117 5.77208 3.50117 6.41667V7.42292"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DataFileMediaType = (props: any) => (
    <svg width="16" {...props} height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.222 5.44444H11.6665C11.1756 5.44444 10.7776 5.04648 10.7776 4.55556V1"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.77795 14.3333V15.2222C2.77795 16.2041 3.57389 17 4.55573 17H13.4446C14.4265 17 15.2224 16.2041 15.2224 15.2222V5.29156C15.2224 4.8201 15.0349 4.36799 14.7015 4.03467L12.1877 1.52089C11.8544 1.18747 11.4023 1 10.9308 1H4.55573C3.57389 1 2.77795 1.79594 2.77795 2.77778V5.44444"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.77778 11.6668L1 9.88898L2.77778 8.11121"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.44434 8.11121L7.22211 9.88898L5.44434 11.6668"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DocumentMediaType = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.345 5.345L12.9884 2.98833C12.6759 2.67583 12.2517 2.5 11.81 2.5H5.83335C4.91252 2.5 4.16669 3.24583 4.16669 4.16667V15.8333C4.16669 16.7542 4.91252 17.5 5.83335 17.5H14.1667C15.0875 17.5 15.8334 16.7542 15.8334 15.8333V6.52333C15.8334 6.08167 15.6575 5.6575 15.345 5.345V5.345Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.8334 6.66667H12.5C12.04 6.66667 11.6667 6.29333 11.6667 5.83333V2.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EmailMediaType = (props: any) => (
    <svg width="14" height="12" {...props} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 2.70074V8.99994C1 10.1046 1.89531 10.9999 2.99996 10.9999H10.9998C12.1044 10.9999 12.9997 10.1046 12.9997 8.99994V2.70141"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 2.70074V8.99994C1 10.1046 1.89531 10.9999 2.99996 10.9999H10.9998C12.1044 10.9999 12.9997 10.1046 12.9997 8.99994V2.70141"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M1 2.70074V8.99994C1 10.1046 1.89531 10.9999 2.99996 10.9999H10.9998C12.1044 10.9999 12.9997 10.1046 12.9997 8.99994V2.70141"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.24921 6.14532L12.2531 4.1087C12.7205 3.79271 12.9998 3.26538 12.9998 2.7014V2.7014C12.9998 1.76142 12.2385 1.0001 11.2992 1.0001H2.71068C1.77137 1.0001 1.01005 1.76142 1.01005 2.70073V2.70073C1.01005 3.26472 1.28938 3.79204 1.7567 4.1087L4.76063 6.14532C6.11594 7.06397 7.8939 7.06397 9.24921 6.14532V6.14532Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.24921 6.14532L12.2531 4.1087C12.7205 3.79271 12.9998 3.26538 12.9998 2.7014V2.7014C12.9998 1.76142 12.2385 1.0001 11.2992 1.0001H2.71068C1.77137 1.0001 1.01005 1.76142 1.01005 2.70073V2.70073C1.01005 3.26472 1.28938 3.79204 1.7567 4.1087L4.76063 6.14532C6.11594 7.06397 7.8939 7.06397 9.24921 6.14532V6.14532Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.24921 6.14532L12.2531 4.1087C12.7205 3.79271 12.9998 3.26538 12.9998 2.7014V2.7014C12.9998 1.76142 12.2385 1.0001 11.2992 1.0001H2.71068C1.77137 1.0001 1.01005 1.76142 1.01005 2.70073V2.70073C1.01005 3.26472 1.28938 3.79204 1.7567 4.1087L4.76063 6.14532C6.11594 7.06397 7.8939 7.06397 9.24921 6.14532V6.14532Z"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const OpenMail = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.74942 5.25V10.5C1.74942 11.4666 2.53283 12.25 3.49942 12.25H10.4994C11.466 12.25 12.2494 11.4666 12.2494 10.5V5.25"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5655 3.94621L5.98442 1.49446C6.594 1.05696 7.41475 1.05754 8.02433 1.49504L11.4287 3.93979C12.5189 4.72263 12.5183 6.00304 11.4275 6.78471L8.015 9.23179C7.40542 9.66929 6.58467 9.66871 5.97508 9.23121L2.56433 6.78179C1.47817 6.00129 1.47875 4.72554 2.5655 3.94621Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5012 7.44917V6.41667C10.5012 5.77208 9.97908 5.25 9.3345 5.25H4.66783C4.02325 5.25 3.50117 5.77208 3.50117 6.41667V7.42292"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const Processing = (props: any) => (
    <svg width="14" height="14" viewBox="0 0 19 19" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.94 4.58128H14.06" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.45999 2.30128H12.54" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.82 6.84H4.18C3.3402 6.84 2.66 7.5202 2.66 8.36V14.44C2.66 15.2798 3.3402 15.96 4.18 15.96H14.82C15.6598 15.96 16.34 15.2798 16.34 14.44V8.36C16.34 7.5202 15.6598 6.84 14.82 6.84Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="11.02"
            y="9.12"
            width="3.04"
            height="2.28"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.94 11.4H7.22" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.94 13.68H8.74" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ServiceInfoIcon = (props: any) => (
    <svg width="21" height="21" {...props} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="10.9971"
            cy="10.9971"
            r="7.5022"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1635 13.9146H12.0885"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.1296 13.9146V10.3719H10.171"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.0804 7.86888C11.0804 7.98397 10.9871 8.07727 10.872 8.07727C10.757 8.07727 10.6637 7.98397 10.6637 7.86888C10.6637 7.75378 10.757 7.66048 10.872 7.66048"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.872 7.66049C10.9871 7.66049 11.0804 7.75379 11.0804 7.86889"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CompleteChorusB2gIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.4167 21.5833L11.4665 23.5335C10.8476 24.1524 10.0083 24.5 9.13315 24.5C8.25798 24.5 7.41865 24.1524 6.79981 23.5335V23.5335C6.18097 22.9147 5.83331 22.0754 5.83331 21.2002C5.83331 20.325 6.18097 19.4857 6.79981 18.8669L16.3333 9.33337"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.642 13.358V13.358C23.8971 11.1028 23.8971 7.44653 21.642 5.19139V5.19139C20.559 4.10841 19.0902 3.5 17.5587 3.5C16.0271 3.5 14.5583 4.10841 13.4753 5.19139L3.5 15.1667"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.1667 17.5H19.8334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5 15.1666V19.8333"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const MetaDeteEditIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 14H17.5" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 9.33333H8.16669" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M19.8333 9.33333H17.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.16669 14H10.5" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.16669 18.6667H14" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.3418 24.1583L25.325 20.1752C25.7806 19.7196 25.7806 18.9809 25.325 18.5253L23.4748 16.6751C23.0192 16.2195 22.2805 16.2195 21.8249 16.6751L17.8417 20.6582C17.6229 20.877 17.5 21.1737 17.5 21.4832V23.9167C17.5 24.2389 17.7612 24.5 18.0833 24.5H20.5169C20.8263 24.5 21.123 24.3771 21.3418 24.1583Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.5 12.8333V7C24.5 5.067 22.933 3.5 21 3.5H7C5.067 3.5 3.5 5.067 3.5 7V21C3.5 22.933 5.067 24.5 7 24.5H12.8333"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const JobLaunchedIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.213 14.1738L12.2792 23.471C12.537 24.6295 14.0758 24.8792 14.686 23.8618L24.3098 7.82134C24.836 6.94634 24.206 5.83334 23.1852 5.83334H5.04235C3.87218 5.83334 3.28651 7.24734 4.11368 8.07451L10.213 14.1738Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.3134 6.48666L10.2084 14.175"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const JobProcessingIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.27997 6.75141H20.72"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.52002 3.39142H18.48"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.84 10.08H6.15998C4.92238 10.08 3.91998 11.0824 3.91998 12.32V21.28C3.91998 22.5176 4.92238 23.52 6.15998 23.52H21.84C23.0776 23.52 24.08 22.5176 24.08 21.28V12.32C24.08 11.0824 23.0776 10.08 21.84 10.08Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="16.24"
            y="13.4399"
            width="4.48"
            height="3.36"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.27997 16.8H10.64" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.27997 20.16H12.88"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendChorusB2gIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.4985 24.5044H5.82991C4.54071 24.5044 3.49561 23.4592 3.49561 22.17V5.82991C3.49561 4.54071 4.54071 3.49561 5.82991 3.49561H19.8357C21.1249 3.49561 22.17 4.54071 22.17 5.82991V10.4985"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16418 9.33138H15.1671"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.16418 14H10.4985" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.1671 24.5044H24.5043"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.3343 24.5044V19.1588"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.8357 24.5044V19.1588"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M23.3372 24.5044V19.1588"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1671 19.1588H24.5043V17.0777L19.8357 15.1671L15.1671 17.0777V19.1588Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChangeStatusChorusB2gIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.75 13.125L24.5 11.375L26.25 13.125"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.25 14.875L3.5 16.625L1.75 14.875"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.5 18.0833V12.74" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 18.0833V12.74" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 18.0833V12.74" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.33331 18.0833H18.6666"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.33331 10.6598V12.74H18.6666V10.6598L14 8.75L9.33331 10.6598Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.76483 16.3193C3.59683 15.5727 3.5 14.798 3.5 14C3.5 8.20167 8.20167 3.5 14 3.5C17.5292 3.5 20.6383 5.25117 22.5423 7.92167"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.2398 11.676C24.4078 12.4227 24.5047 13.1974 24.5047 13.9954C24.5047 19.7937 19.803 24.4954 14.0047 24.4954C10.4743 24.4954 7.36517 22.7442 5.46234 20.0737"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PrincipalContact = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M13.3334 2.5V8.95V2.5Z" fill="#307ADE" fillOpacity="0.3" />
        <path d="M13.3334 2.5V8.95" stroke="#307ADE" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 8.95V2.5V8.95Z" fill="#307ADE" fillOpacity="0.3" />
        <path d="M6.66667 8.95V2.5" stroke="#307ADE" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99919 16.105L12.5059 17.4225C12.9942 17.6792 13.5642 17.2642 13.4709 16.7208L12.9917 13.93L15.02 11.9542C15.415 11.5692 15.1975 10.8983 14.6517 10.8192L11.8492 10.4117L10.5959 7.87082C10.3517 7.37582 9.64669 7.37582 9.40252 7.87082L8.15002 10.4117L5.34752 10.8192C4.80169 10.8983 4.58419 11.5692 4.97919 11.9542L7.00752 13.93L6.52835 16.7208C6.43502 17.2642 7.00502 17.6783 7.49335 17.4225L10 16.105"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M9.99919 16.105L12.5059 17.4225C12.9942 17.6792 13.5642 17.2642 13.4709 16.7208L12.9917 13.93L15.02 11.9542C15.415 11.5692 15.1975 10.8983 14.6517 10.8192L11.8492 10.4117L10.5959 7.87082C10.3517 7.37582 9.64669 7.37582 9.40252 7.87082L8.15002 10.4117L5.34752 10.8192C4.80169 10.8983 4.58419 11.5692 4.97919 11.9542L7.00752 13.93L6.52835 16.7208C6.43502 17.2642 7.00502 17.6783 7.49335 17.4225L10 16.105"
            stroke="#307ADE"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.38508 9.935L5.00425 7.99667C4.48675 7.7 4.16675 7.14833 4.16675 6.55083V4.16667C4.16675 3.24583 4.91258 2.5 5.83341 2.5H14.1667C15.0876 2.5 15.8334 3.24583 15.8334 4.16667V6.55083C15.8334 7.14833 15.5142 7.7 14.9959 7.99667L11.6151 9.935"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M8.38508 9.935L5.00425 7.99667C4.48675 7.7 4.16675 7.14833 4.16675 6.55083V4.16667C4.16675 3.24583 4.91258 2.5 5.83341 2.5H14.1667C15.0876 2.5 15.8334 3.24583 15.8334 4.16667V6.55083C15.8334 7.14833 15.5142 7.7 14.9959 7.99667L11.6151 9.935"
            stroke="#307ADE"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SentIconChorus = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29501 10.1242L8.77084 16.765C8.95501 17.5925 10.0542 17.7708 10.49 17.0442L17.3642 5.58667C17.74 4.96167 17.29 4.16667 16.5608 4.16667H3.60168C2.76584 4.16667 2.34751 5.17667 2.93834 5.7675L7.29501 10.1242Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M17.3667 4.63333L7.29169 10.125" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const DotIcon = (props: any) => (
    <svg width="3" height="4" {...props} viewBox="0 0 3 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="3" height="3" rx="1.5" fill="currentColor" fillOpacity="0.7" />
        <rect y="0.5" width="3" height="3" rx="1.5" fill="currentColor" fillOpacity="0.2" />
    </svg>
)
export const StarsIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2021_136500)">
            <path
                d="M17.5763 11.6666C17.1359 11.6666 16.7474 11.3786 16.6195 10.9573L14.9568 5.48338C14.6695 4.53757 13.3304 4.53756 13.0431 5.48338L11.3804 10.9573C11.2524 11.3786 10.8639 11.6666 10.4236 11.6666H5.45619C4.48311 11.6666 4.08324 12.9154 4.87532 13.4806L8.95518 16.392C9.30622 16.6425 9.45713 17.0898 9.32958 17.5018L7.72398 22.6875C7.4363 23.6167 8.51003 24.368 9.28439 23.7794L13.3953 20.6546C13.7527 20.3829 14.2473 20.3827 14.6049 20.6541L18.729 23.7839C19.5035 24.3716 20.5763 23.6203 20.2888 22.6915L18.6818 17.5012C18.5543 17.0895 18.7049 16.6425 19.0555 16.3919L23.1293 13.4802C23.9206 12.9146 23.5204 11.6666 22.5478 11.6666H17.5763Z"
                fill="#307ADE"
            />
        </g>
        <defs>
            <clipPath id="clip0_2021_136500">
                <rect width="28" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export const Resend = (props: any) => (
    <svg width="30" height="30" viewBox="0 0 30 30" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.295 15.1241L13.7708 21.765C13.955 22.5925 15.0542 22.7708 15.49 22.0441L22.3642 10.5866C22.74 9.96163 22.29 9.16663 21.5608 9.16663H8.60168C7.76584 9.16663 7.34751 10.1766 7.93834 10.7675L12.295 15.1241Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.3667 9.6333L12.2917 15.125"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AttachmentIconSubMenu = (props: any) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.04401 3.9866L3.99645 7.03416C3.53759 7.49302 3.53759 8.23741 3.99645 8.69627V8.69627C4.4553 9.15513 5.1997 9.15513 5.65855 8.69627L9.67605 4.67877C10.5177 3.83716 10.5177 2.47281 9.67605 1.63121V1.63121C8.83445 0.789598 7.4701 0.789598 6.62849 1.63121L2.61099 5.64871C1.38663 6.87306 1.38663 8.85737 2.61099 10.0817V10.0817C3.83535 11.3061 5.81965 11.3061 7.04401 10.0817L9.48218 7.64357"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.04401 3.9866L3.99645 7.03416C3.53759 7.49302 3.53759 8.23741 3.99645 8.69627V8.69627C4.4553 9.15513 5.1997 9.15513 5.65855 8.69627L9.67605 4.67877C10.5177 3.83716 10.5177 2.47281 9.67605 1.63121V1.63121C8.83445 0.789598 7.4701 0.789598 6.62849 1.63121L2.61099 5.64871C1.38663 6.87306 1.38663 8.85737 2.61099 10.0817V10.0817C3.83535 11.3061 5.81965 11.3061 7.04401 10.0817L9.48218 7.64357"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AttachmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.04403 3.9866L3.99646 7.03416C3.53761 7.49302 3.53761 8.23741 3.99646 8.69627V8.69627C4.45532 9.15513 5.19971 9.15513 5.65857 8.69627L9.67607 4.67877C10.5177 3.83716 10.5177 2.47281 9.67607 1.63121V1.63121C8.83446 0.789598 7.47011 0.789598 6.6285 1.63121L2.611 5.64871C1.38664 6.87306 1.38664 8.85737 2.611 10.0817V10.0817C3.83536 11.3061 5.81967 11.3061 7.04403 10.0817L9.48219 7.64357"
            stroke="currentColor"
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChorusIcon = (props: any) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect width="20" height="20" fill="url(#pattern0_5963_19661)" />
        <defs>
            <pattern id="pattern0_5963_19661" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlinkHref="#image0_5963_19661" transform="matrix(0.0105263 0 0 0.01 0.136842 -0.486381)" />
            </pattern>
            <image
                id="image0_5963_19661"
                width="450"
                height="200"
                xlinkHref="data:image/png;base64,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"
            />
        </defs>
    </svg>
)
export const CloseIconBtn = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L12 12" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 6L6 12" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const SendIconBtn = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.56551 9.11175L7.89376 15.0885C8.05951 15.8333 9.04876 15.9938 9.44101 15.3398L15.6278 5.028C15.966 4.4655 15.561 3.75 14.9048 3.75H3.24151C2.48926 3.75 2.11276 4.659 2.64451 5.19075L6.56551 9.11175Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.63 4.17004L6.5625 9.11254"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AccordionOpen = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 14L12 10L8 6"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 14L12 10L8 6"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SignedIcon = (props: any) => (
    <svg width="16" height="23" viewBox="0 0 16 23" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.3334 13.2066V21.9998L8.00007 19.6664L12.6667 21.9998V13.2066"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.3334 13.2066V21.9998L8.00007 19.6664L12.6667 21.9998V13.2066"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M3.3334 13.2066V21.9998L8.00007 19.6664L12.6667 21.9998V13.2066"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9497 3.05026C15.6834 5.78393 15.6834 10.2161 12.9497 12.9497C10.2161 15.6834 5.78392 15.6834 3.05026 12.9497C0.316582 10.2161 0.316582 5.78392 3.05026 3.05026C5.78393 0.316582 10.2161 0.316582 12.9497 3.05026"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9497 3.05026C15.6834 5.78393 15.6834 10.2161 12.9497 12.9497C10.2161 15.6834 5.78392 15.6834 3.05026 12.9497C0.316582 10.2161 0.316582 5.78392 3.05026 3.05026C5.78393 0.316582 10.2161 0.316582 12.9497 3.05026"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M12.9497 3.05026C15.6834 5.78393 15.6834 10.2161 12.9497 12.9497C10.2161 15.6834 5.78392 15.6834 3.05026 12.9497C0.316582 10.2161 0.316582 5.78392 3.05026 3.05026C5.78393 0.316582 10.2161 0.316582 12.9497 3.05026"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ConformDetailIcon = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 12.8168H3.07467C3.389 12.817 3.69052 12.6923 3.91289 12.4701V12.4701C4.13505 12.2478 4.25976 11.9462 4.25956 11.6319V6.89058C4.25976 6.57625 4.13505 6.27472 3.91289 6.05236V6.05236C3.69052 5.83019 3.389 5.70549 3.07467 5.70569H1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17 5.70569H14.9262C14.6119 5.70549 14.3104 5.83019 14.088 6.05236V6.05236C13.8658 6.27472 13.7411 6.57625 13.7413 6.89058V11.6319C13.7411 11.9462 13.8658 12.2478 14.088 12.4701V12.4701C14.3104 12.6923 14.6119 12.817 14.9262 12.8168H17"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.7591 11.8363H12.9946C12.7404 11.8361 12.489 11.8907 12.2577 11.9963L8.51819 13.6994"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.79554 6.52172C7.34531 6.25508 6.80005 6.2017 6.30665 6.37594L4.26221 7.11283"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.8836 6.31549L11.3271 5.19016C10.7793 4.94905 10.1468 4.99983 9.64446 5.32527L7.32446 6.82838C6.97582 7.05435 6.75185 7.42939 6.71826 7.8435C6.68466 8.2576 6.84525 8.66384 7.15291 8.94305V8.94305C7.55226 9.30471 8.12942 9.39191 8.6178 9.16438L10.0009 8.51905"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.0009 8.51807L10.7032 9.1554C11.0739 9.49128 11.2859 9.96781 11.2873 10.4681C11.2886 10.9683 11.0792 11.446 10.7103 11.7838L8.91739 13.4247C8.24061 14.0442 7.20361 14.0469 6.52361 13.431L5.29161 12.3136C4.99902 12.0535 4.62875 11.8973 4.23828 11.8692"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1"
            y="1.00256"
            width="16"
            height="16"
            rx="4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ArchiveDetailIcon = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9336 4.55563V15.2223C15.9336 16.2045 15.2176 17.0001 14.3336 17.0001H3.66641C2.78241 17.0001 2.06641 16.2045 2.06641 15.2223V4.55563"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9336 4.55563V15.2223C15.9336 16.2045 15.2176 17.0001 14.3336 17.0001H3.66641C2.78241 17.0001 2.06641 16.2045 2.06641 15.2223V4.55563"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M15.9336 4.55563V15.2223C15.9336 16.2045 15.2176 17.0001 14.3336 17.0001H3.66641C2.78241 17.0001 2.06641 16.2045 2.06641 15.2223V4.55563"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M6.5999 8.1111H11.3999Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M6.5999 8.1111H11.3999Z" fill="#307ADE" fillOpacity="0.1" />
        <path
            d="M6.5999 8.1111H11.3999"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2 4.55555H1.8C1.3584 4.55555 1 4.15733 1 3.66667V1.88889C1 1.39822 1.3584 1 1.8 1H16.2C16.6416 1 17 1.39822 17 1.88889V3.66667C17 4.15733 16.6416 4.55555 16.2 4.55555Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2 4.55555H1.8C1.3584 4.55555 1 4.15733 1 3.66667V1.88889C1 1.39822 1.3584 1 1.8 1H16.2C16.6416 1 17 1.39822 17 1.88889V3.66667C17 4.15733 16.6416 4.55555 16.2 4.55555Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2 4.55555H1.8C1.3584 4.55555 1 4.15733 1 3.66667V1.88889C1 1.39822 1.3584 1 1.8 1H16.2C16.6416 1 17 1.39822 17 1.88889V3.66667C17 4.15733 16.6416 4.55555 16.2 4.55555Z"
            stroke="#307ADE"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AccordionClose = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 8L10 12L14 8"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 8L10 12L14 8"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CguIcon = (props: any) => (
    <svg width="18" {...props} height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 6.75V3.75C15 2.92157 14.3284 2.25 13.5 2.25H3.75C2.92157 2.25 2.25 2.92157 2.25 3.75V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H9"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 12.7101V10.6979C10.4981 10.5259 10.6291 10.3814 10.8004 10.3665C11.6316 10.3107 12.4283 10.0132 13.0926 9.51049C13.3342 9.32984 13.6659 9.32984 13.9074 9.51049C14.5717 10.0132 15.3684 10.3107 16.1996 10.3665C16.3709 10.3815 16.5019 10.5259 16.5 10.6979V12.7101"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 12.75C10.5 14.1791 12.281 15.2405 13.1 15.6532C13.351 15.7823 13.649 15.7823 13.9 15.6532C14.719 15.2405 16.5 14.1813 16.5 12.75"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.25 6H12" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 9H8.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 12H6.75" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const AccountAdminSmall = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.2405 13.9755L7.635 14.8628C7.87459 15.4023 8.40961 15.75 9 15.75V15.75C9.59039 15.75 10.1254 15.4023 10.365 14.8628L10.7595 13.9755C10.8999 13.6607 11.1361 13.3982 11.4345 13.2255V13.2255C11.7347 13.0523 12.082 12.9785 12.4267 13.0148L13.392 13.1175C13.979 13.1796 14.5475 12.8901 14.8425 12.3788V12.3788C15.1379 11.8678 15.1043 11.2307 14.757 10.7535L14.1855 9.96825C13.982 9.68656 13.8733 9.3475 13.875 9V9C13.8749 8.65345 13.9847 8.31579 14.1885 8.0355L14.76 7.25025C15.1073 6.77306 15.1409 6.136 14.8455 5.625V5.625C14.5505 5.1137 13.982 4.82416 13.395 4.88625L12.4297 4.989C12.085 5.0252 11.7377 4.95143 11.4375 4.77825V4.77825C11.1386 4.60457 10.9023 4.34072 10.7625 4.0245L10.365 3.13725C10.1254 2.59766 9.59039 2.25 9 2.25V2.25C8.40961 2.25 7.87459 2.59766 7.635 3.13725L7.2405 4.0245C7.10072 4.34072 6.86444 4.60457 6.5655 4.77825V4.77825C6.26527 4.95143 5.91795 5.0252 5.57325 4.989L4.605 4.88625C4.01798 4.82416 3.44948 5.1137 3.1545 5.625V5.625C2.85913 6.136 2.89264 6.77306 3.24 7.25025L3.8115 8.0355C4.01531 8.31579 4.12506 8.65345 4.125 9V9C4.12506 9.34655 4.01531 9.68421 3.8115 9.9645L3.24 10.7498C2.89264 11.2269 2.85913 11.864 3.1545 12.375V12.375C3.44976 12.886 4.01805 13.1754 4.605 13.1138L5.57025 13.011C5.91495 12.9748 6.26227 13.0486 6.5625 13.2218V13.2218C6.86255 13.3949 7.09994 13.6588 7.2405 13.9755V13.9755Z"
            stroke="black"
        />
        <circle cx="9.00001" cy="9.00002" r="1.98525" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ApiIcon = (props: any) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.52681 9.82501H7.12725" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.35 10.5L6.2565 7.125H5.406L4.3125 10.5"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.1875 7.125H10.5C11.0178 7.125 11.4375 7.54473 11.4375 8.0625V8.0625C11.4375 8.31114 11.3387 8.5496 11.1629 8.72541C10.9871 8.90123 10.7486 9 10.5 9H9.1875V7.125Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.1875 7.125V10.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3125 7.125V10.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="1.5"
            y="1.5"
            width="15"
            height="15"
            rx="5.5"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const UsageGuideIcon = (props: any) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.49938 15.7528H3.74782C2.91905 15.7528 2.24719 15.081 2.24719 14.2522V3.74782C2.24719 2.91905 2.91905 2.24719 3.74782 2.24719H7.49938C8.32815 2.24719 9 2.91905 9 3.74782V14.2522C9 15.081 8.32815 15.7528 7.49938 15.7528Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.41967 11.5803C6.85899 12.0199 6.85884 12.7324 6.41933 13.1718C5.97983 13.6112 5.26735 13.6112 4.82785 13.1718C4.38835 12.7324 4.38819 12.0199 4.82751 11.5803C5.0386 11.3691 5.32497 11.2504 5.62359 11.2504C5.92221 11.2504 6.20859 11.3691 6.41967 11.5803"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.74906 9H4.49812" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.74906 6.74906H4.49812" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2522 15.7528H10.5006C9.67185 15.7528 9 15.081 9 14.2522V3.74782C9 2.91905 9.67185 2.24719 10.5006 2.24719H14.2522C15.081 2.24719 15.7528 2.91905 15.7528 3.74782V14.2522C15.7528 15.081 15.081 15.7528 14.2522 15.7528Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.1725 11.5803C13.6118 12.0199 13.6117 12.7324 13.1722 13.1718C12.7327 13.6112 12.0202 13.6112 11.5807 13.1718C11.1412 12.7324 11.141 12.0199 11.5803 11.5803C11.7914 11.3691 12.0778 11.2504 12.3764 11.2504C12.675 11.2504 12.9614 11.3691 13.1725 11.5803"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.5019 9H11.2509" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.5019 6.74906H11.2509" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const MyTicketIcon = (props: any) => (
    <svg width="18" {...props} height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.25 13.875V13.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.24996 11.4375L5.25004 11.0625" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 9V8.625" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="13.5"
            y="15.75"
            width="11.25"
            height="9"
            rx="2.5"
            transform="rotate(-180 13.5 15.75)"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5 11.25H14.625C15.6605 11.25 16.5 10.4105 16.5 9.375V4.125C16.5 3.08947 15.6605 2.25 14.625 2.25H7.125C6.08947 2.25 5.25 3.08947 5.25 4.125V6.75"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const HelpCenterSmall = (props: any) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.25 12.75H13.5C13.086 12.75 12.75 12.414 12.75 12V8.25C12.75 7.836 13.086 7.5 13.5 7.5H14.25C15.0788 7.5 15.75 8.17125 15.75 9V11.25C15.75 12.0788 15.0788 12.75 14.25 12.75Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 12.75H3.75C2.92125 12.75 2.25 12.0788 2.25 11.25V9C2.25 8.17125 2.92125 7.5 3.75 7.5H4.5C4.914 7.5 5.25 7.836 5.25 8.25V12C5.25 12.414 4.914 12.75 4.5 12.75Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.875 7.5V7.125C13.875 4.4325 11.6925 2.25 9 2.25V2.25C6.3075 2.25 4.125 4.4325 4.125 7.125V7.5"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.46875 15.9375H8.53125C8.01375 15.9375 7.59375 15.5175 7.59375 15V15C7.59375 14.4825 8.01375 14.0625 8.53125 14.0625H9.46875C9.98625 14.0625 10.4062 14.4825 10.4062 15V15C10.4062 15.5175 9.98625 15.9375 9.46875 15.9375Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4062 15H12C12.8288 15 13.5 14.3288 13.5 13.5V12.75"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChangeRole = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5 3.75H13.5C14.3287 3.75 15 4.42125 15 5.25V15C15 15.8288 14.3287 16.5 13.5 16.5H4.5C3.67125 16.5 3 15.8288 3 15V5.25C3 4.42125 3.67125 3.75 4.5 3.75H7.5"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1933 7.99426C10.8523 8.65327 10.8523 9.72173 10.1933 10.3807C9.53425 11.0398 8.46578 11.0398 7.80677 10.3807C7.14776 9.72173 7.14776 8.65327 7.80677 7.99426C8.46578 7.33525 9.53425 7.33525 10.1933 7.99426"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.6963 14.25C11.565 13.9207 11.3625 13.6253 11.1023 13.3845V13.3845C10.662 12.9765 10.0845 12.75 9.48451 12.75H8.51551C7.91551 12.75 7.33801 12.9765 6.89776 13.3845V13.3845C6.63751 13.6253 6.43501 13.9207 6.30376 14.25"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.75 5.25H8.25C7.836 5.25 7.5 4.914 7.5 4.5V2.25C7.5 1.836 7.836 1.5 8.25 1.5H9.75C10.164 1.5 10.5 1.836 10.5 2.25V4.5C10.5 4.914 10.164 5.25 9.75 5.25Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ValidateEdit = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.6667 3.79199L5.25004 10.2087L2.33337 7.29199"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CloseEdit = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.66663 4.66699L9.33329 9.33366"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33329 4.66699L4.66663 9.33366"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EmptyUserIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.7235 22.0617L20.3152 21.0362C20.1087 20.5159 19.7878 20.0492 19.3772 19.6689L19.3025 19.6C18.6562 19.0004 17.8068 18.6667 16.9248 18.6667H11.0752C10.1932 18.6667 9.34383 19.0004 8.69633 19.5989L8.62166 19.6689C8.211 20.0492 7.89133 20.5159 7.68366 21.0362L7.27533 22.0617"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.8874 8.68829C18.482 10.2829 18.482 12.8684 16.8874 14.463C15.2927 16.0576 12.7073 16.0576 11.1127 14.463C9.51803 12.8684 9.51803 10.2829 11.1127 8.68829C12.7073 7.09365 15.2927 7.09365 16.8874 8.68829"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.4247 6.57538C25.5252 10.6759 25.5252 17.3241 21.4247 21.4246C17.3242 25.5251 10.6759 25.5251 6.57544 21.4246C2.47493 17.3241 2.47493 10.6759 6.57544 6.57538C10.6759 2.47487 17.3242 2.47487 21.4247 6.57538"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const WorkInProgressIcon = (props: any) => (
    <svg width="38" {...props} height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5928 12.8252L12.5984 9.83077C11.6063 8.83862 11.6063 7.23002 12.5984 6.23787V6.23787C13.5907 5.24672 15.1985 5.2472 16.1902 6.23893L19.1847 9.23336L15.5928 12.8252Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.7019 8.95955L29.0392 14.2969C30.2113 15.4689 30.2113 17.3692 29.0392 18.5413L22.6005 24.9801C22.0144 25.5661 21.0643 25.5661 20.4783 24.9801L13.0187 17.5205C12.4327 16.9345 12.4327 15.9843 13.0187 15.3983L19.4575 8.95955C20.0203 8.3967 20.7837 8.0805 21.5797 8.0805C22.3757 8.0805 23.1391 8.3967 23.7019 8.95955Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.1683 25.4038L25.1739 22.4094L28.7668 18.8165L31.7612 21.8109C32.7533 22.8031 32.7533 24.4117 31.7612 25.4038V25.4038C30.769 26.396 29.1605 26.396 28.1683 25.4038Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7547 18.2556L19.7436 24.2445L17.0527 26.9354C16.7712 27.2169 16.3895 27.375 15.9915 27.375C15.5936 27.375 15.2119 27.2169 14.9304 26.9354L11.0638 23.0688C10.4778 22.4827 10.4778 21.5326 11.0638 20.9466L13.7547 18.2556Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.3933 23.3983L6.42776 28.3639C6.19113 28.5998 6.02976 28.9006 5.96407 29.2282L5.51388 31.4927C5.45891 31.7702 5.546 32.0569 5.74606 32.2569C5.94611 32.457 6.23277 32.5441 6.51029 32.4891L8.77474 32.0389C9.10237 31.9732 9.40316 31.8119 9.6391 31.5752L14.6047 26.6097"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.2644 13.1431L18.2632 16.1443"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.8569 16.7355L21.8557 19.7368"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SentSmallIcon = (props: any) => (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.10651 7.08692L6.13959 11.7355C6.26851 12.3148 7.03792 12.4396 7.34301 11.9309L12.1549 3.91067C12.418 3.47317 12.103 2.91667 11.5926 2.91667H2.52117C1.93609 2.91667 1.64326 3.62367 2.05684 4.03725L5.10651 7.08692Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.1567 3.24333L5.10419 7.0875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const BATIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.5868 16.3343H6.41382C5.44691 16.3343 4.66309 15.5505 4.66309 14.5836V5.82991C4.66309 4.54071 5.70819 3.49561 6.99739 3.49561H10.4989"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.169 24.5044H5.83108C5.09871 24.5044 4.40881 24.1606 3.96777 23.5759C3.52673 22.9913 3.3857 22.2335 3.58686 21.5293L4.82908 17.1808C4.97222 16.6798 5.43022 16.3343 5.95136 16.3343H22.0487C22.5699 16.3343 23.0278 16.6798 23.171 17.1808L24.4132 21.5293C24.6144 22.2335 24.4734 22.9913 24.0323 23.5759C23.5913 24.1606 22.9014 24.5044 22.169 24.5044Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33105 11.6657H10.4982"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16406 8.1642H10.4984"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="14"
            y="3.49561"
            width="10.5044"
            height="8.17007"
            rx="2"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.918 6.41345L18.6756 7.42607C19.0325 7.63212 19.4722 7.63212 19.829 7.42607L21.5866 6.41345"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.666 21.0029H16.3346"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DeleteIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.83331 8.16665H22.1666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21 8.16669V21C21 22.2892 19.9558 23.3334 18.6667 23.3334H9.33333C8.04417 23.3334 7 22.2892 7 21V8.16669"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5 4.37502H10.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.6666 12.8333V18.6666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.3333 12.8333V18.6666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DeleteIconSmall = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.75 5.25H14.25" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M13.5 5.25V13.5C13.5 14.3288 12.8288 15 12 15H6C5.17125 15 4.5 14.3288 4.5 13.5V5.25"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.25 2.8125H6.75" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 8.25V12" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 8.25V12" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const DefaultActicityIcon = (props: any) => (
    <svg width="28" {...props} height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="3.5"
            y="3.5"
            width="21"
            height="21"
            rx="3"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="8.16669"
            y="8.16663"
            width="4.66667"
            height="4.66667"
            rx="1"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16669 16.3333H19.8334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16669 19.8333H16.3334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ErrorStatIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 3.5V3.5C19.7995 3.5 24.5 8.2005 24.5 14V14C24.5 19.7995 19.7995 24.5 14 24.5V24.5C8.2005 24.5 3.5 19.7995 3.5 14V14C3.5 8.2005 8.2005 3.5 14 3.5Z"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M14 14.5833V8.75" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M13.9988 18.6667C13.8378 18.6667 13.7071 18.7973 13.7083 18.9583C13.7083 19.1193 13.839 19.25 14 19.25C14.161 19.25 14.2916 19.1193 14.2916 18.9583C14.2916 18.7973 14.161 18.6667 13.9988 18.6667"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ErrorIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1.75V1.75C9.89975 1.75 12.25 4.10025 12.25 7V7C12.25 9.89975 9.89975 12.25 7 12.25V12.25C4.10025 12.25 1.75 9.89975 1.75 7V7C1.75 4.10025 4.10025 1.75 7 1.75Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.00001 7.29167V4.375" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M6.99943 9.33333C6.91893 9.33333 6.8536 9.39867 6.85418 9.47917C6.85418 9.55967 6.91951 9.625 7.00001 9.625C7.08051 9.625 7.14585 9.55967 7.14585 9.47917C7.14585 9.39867 7.08051 9.33333 6.99943 9.33333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ReadIconJM = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.74942 5.25V10.5C1.74942 11.4666 2.53284 12.25 3.49942 12.25H10.4994C11.466 12.25 12.2494 11.4666 12.2494 10.5V5.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.56549 3.94625L5.9844 1.4945C6.59399 1.057 7.41474 1.05758 8.02432 1.49508L11.4287 3.93983C12.5189 4.72267 12.5183 6.00308 11.4275 6.78475L8.01499 9.23183C7.4054 9.66933 6.58465 9.66875 5.97507 9.23125L2.56432 6.78183C1.47815 6.00133 1.47874 4.72558 2.56549 3.94625Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5012 7.44917V6.41667C10.5012 5.77208 9.97908 5.25 9.33449 5.25H4.66783C4.02324 5.25 3.50116 5.77208 3.50116 6.41667V7.42292"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ClearField = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.66666 6.66666L13.3333 13.3333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.3333 6.66666L6.66666 13.3333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ExportIcon = (props: any) => (
    <svg width="24" {...props} height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.11133 7.55556V5.77778C7.11133 4.79594 7.90727 4 8.88911 4H17.778C18.7598 4 19.5558 4.79594 19.5558 5.77778V18.2222C19.5558 19.2041 18.7598 20 17.778 20H8.88911C7.90727 20 7.11133 19.2041 7.11133 18.2222V16.4444"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="4.44446"
            y="7.55559"
            width="8.88889"
            height="8.88889"
            rx="2"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M19.5558 9.40441H13.3336" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.5558 14.6667H13.3336" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3333 4V20" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.2817 13.5555L7.61499 10.4444" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.61499 13.5555L10.2817 10.4444" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const DownloadIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.0117 5.26166V22.7383"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.02686 15.7582L14 22.7302L20.9732 15.7582"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SearchIconHeader = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.919 4.51539C13.9593 6.5359 13.9593 9.81181 11.919 11.8323C9.87864 13.8528 6.57059 13.8528 4.53025 11.8323C2.48992 9.81181 2.48992 6.5359 4.53025 4.51539C6.57059 2.49487 9.87864 2.49487 11.919 4.51539"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.919 4.51539C13.9593 6.5359 13.9593 9.81181 11.919 11.8323C9.87864 13.8528 6.57059 13.8528 4.53025 11.8323C2.48992 9.81181 2.48992 6.5359 4.53025 4.51539C6.57059 2.49487 9.87864 2.49487 11.919 4.51539"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.8811 11.8617L16.9999 17"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.8811 11.8617L16.9999 17"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ClearHeader = (props: any) => (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="3" fill="white" />
        <rect
            x="0.3"
            y="0.3"
            width="15.4"
            height="15.4"
            rx="2.7"
            stroke="black"
            strokeOpacity="0.1"
            strokeWidth="0.6"
        />
        <path
            d="M10 4.5L6 8L10 11.5"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 4.5L6 8L10 11.5"
            stroke="black"
            strokeOpacity="0.2"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SearchIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5586 6.51221C19.2791 9.23266 19.2791 13.6434 16.5586 16.3639C13.8382 19.0843 9.42743 19.0843 6.70697 16.3639C3.98651 13.6434 3.98651 9.23266 6.70697 6.51221C9.42743 3.79175 13.8382 3.79175 16.5586 6.51221"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5083 16.4033L23.3333 23.3217"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const UploadFileIcon = (props: any) => (
    <svg width="52" {...props} height="52" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 14.4045L12 4.26448" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M19.981 13.4005L20 17.5685C20.006 18.7635 19.048 19.7355 17.865 19.7355L6.135 19.7355C4.956 19.7355 4 18.7705 4 17.5785L4 13.2645"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16 8.26447L12 4.26447L8 8.26447" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ArrowTop = (props: any) => (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <rect width="52" height="52" fill="white" />
        <rect width="52" height="52" rx="6" fill="white" />
        <path
            d="M26.0149 14.7649V37.2499"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.0344 23.7709L25.9999 14.7469L34.9654 23.7709"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CalendarIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.832 20.4166H18.9587"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.3947 20.4166V14.5833L15.6914 16.1233"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M24.5 10.5H3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.33333 3.35999V5.97332"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.6663 3.35999V5.97332"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 24.5H7C5.06683 24.5 3.5 22.9331 3.5 21V8.16663C3.5 6.23346 5.06683 4.66663 7 4.66663H21C22.9332 4.66663 24.5 6.23346 24.5 8.16663V21C24.5 22.9331 22.9332 24.5 21 24.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.625 15.7033C9.8105 15.0616 10.3775 14.5833 11.0787 14.5833C11.928 14.5833 12.6175 15.2716 12.6175 16.1221C12.6175 16.8828 12.0003 17.5 11.2397 17.5C12.0003 17.5 12.6175 18.1171 12.6175 18.8778C12.6175 19.7271 11.9292 20.4166 11.0787 20.4166C10.3775 20.4166 9.8105 19.9383 9.625 19.2966"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const WarningIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1V1C10.314 1 13 3.686 13 7V7C13 10.314 10.314 13 7 13V13C3.686 13 1 10.314 1 7V7C1 3.686 3.686 1 7 1Z"
            fill="currentColor"
            fillOpacity="0.1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1V1C10.314 1 13 3.686 13 7V7C13 10.314 10.314 13 7 13V13C3.686 13 1 10.314 1 7V7C1 3.686 3.686 1 7 1Z"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.99993 7.33333V4"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.99926 9.66657C6.90726 9.66657 6.8326 9.74123 6.83326 9.83323C6.83326 9.92523 6.90793 9.9999 6.99993 9.9999C7.09193 9.9999 7.1666 9.92523 7.1666 9.83323C7.1666 9.74123 7.09193 9.66657 6.99926 9.66657"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendIngBtnIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.29538 10.1242L8.77121 16.765C8.95538 17.5925 10.0545 17.7709 10.4904 17.0442L17.3645 5.58669C17.7404 4.96169 17.2904 4.16669 16.5612 4.16669H3.60204C2.76621 4.16669 2.34788 5.17669 2.93871 5.76752L7.29538 10.1242Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.367 4.63336L7.29199 10.125"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SettingIcon = (props: any) => (
    <svg width="18" {...props} height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.24056 13.9755L7.63506 14.8628C7.87465 15.4023 8.40967 15.75 9.00006 15.75V15.75C9.59045 15.75 10.1255 15.4023 10.3651 14.8628L10.7596 13.9755C10.9 13.6607 11.1362 13.3982 11.4346 13.2255V13.2255C11.7348 13.0523 12.0821 12.9785 12.4268 13.0148L13.3921 13.1175C13.9791 13.1796 14.5476 12.8901 14.8426 12.3788V12.3788C15.1379 11.8678 15.1044 11.2307 14.7571 10.7535L14.1856 9.96825C13.9821 9.68656 13.8733 9.3475 13.8751 9V9C13.875 8.65345 13.9847 8.31579 14.1886 8.0355L14.7601 7.25025C15.1074 6.77306 15.1409 6.136 14.8456 5.625V5.625C14.5506 5.1137 13.9821 4.82416 13.3951 4.88625L12.4298 4.989C12.0851 5.0252 11.7378 4.95143 11.4376 4.77825V4.77825C11.1386 4.60457 10.9023 4.34072 10.7626 4.0245L10.3651 3.13725C10.1255 2.59766 9.59045 2.25 9.00006 2.25V2.25C8.40967 2.25 7.87465 2.59766 7.63506 3.13725L7.24056 4.0245C7.10078 4.34072 6.8645 4.60457 6.56556 4.77825V4.77825C6.26533 4.95143 5.91801 5.0252 5.57331 4.989L4.60506 4.88625C4.01804 4.82416 3.44954 5.1137 3.15456 5.625V5.625C2.85919 6.136 2.89271 6.77306 3.24006 7.25025L3.81156 8.0355C4.01537 8.31579 4.12512 8.65345 4.12506 9V9C4.12512 9.34655 4.01537 9.68421 3.81156 9.9645L3.24006 10.7498C2.89271 11.2269 2.85919 11.864 3.15456 12.375V12.375C3.44982 12.886 4.01811 13.1754 4.60506 13.1138L5.57031 13.011C5.91501 12.9748 6.26233 13.0486 6.56256 13.2218V13.2218C6.86261 13.3949 7.1 13.6588 7.24056 13.9755V13.9755Z"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="1.5"
        />
        <circle
            cx="9.00002"
            cy="9.00002"
            r="1.98525"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AttachementEye = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5915 7.41C11.4697 8.28825 11.4697 9.714 10.5915 10.5938C9.71321 11.472 8.28746 11.472 7.40771 10.5938C6.52946 9.7155 6.52946 8.28975 7.40771 7.41C8.28746 6.53025 9.71246 6.53025 10.5915 7.41"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.25 9C2.25 8.50575 2.364 8.01675 2.5845 7.566V7.566C3.72075 5.24325 6.23175 3.75 9 3.75C11.7682 3.75 14.2793 5.24325 15.4155 7.566V7.566C15.636 8.01675 15.75 8.50575 15.75 9C15.75 9.49425 15.636 9.98325 15.4155 10.434V10.434C14.2793 12.7568 11.7682 14.25 9 14.25C6.23175 14.25 3.72075 12.7568 2.5845 10.434V10.434C2.364 9.98325 2.25 9.49425 2.25 9Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const AttachementDown = (props: any) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00745 3.3825V14.6175" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M4.51721 10.1302L8.99996 14.6122L13.4827 10.1302"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const TrashDoc = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.16699 9.83341H19.8337"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 9.83325V18.9999C19 19.9208 18.2542 20.6666 17.3333 20.6666H10.6667C9.74583 20.6666 9 19.9208 9 18.9999V9.83325"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.5 7.12492H11.5" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M12.3337 13.1667V17.3334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.6667 13.1667V17.3334"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const EditGed = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 13.9999H16.5" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M13.9997 10.6667H9.83301"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.1667 10.6667H16.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.83301 13.9999H11.4997"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.83301 17.3334H13.9997"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2442 21.256L22.0893 18.4109C22.4147 18.0855 22.4147 17.5578 22.0893 17.2324L20.7677 15.9108C20.4423 15.5854 19.9146 15.5854 19.5892 15.9108L16.7441 18.7559C16.5878 18.9122 16.5 19.1242 16.5 19.3452V21.0834C16.5 21.3135 16.6865 21.5001 16.9167 21.5001H18.6549C18.8759 21.5001 19.0879 21.4123 19.2442 21.256Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.5 13.1667V9C21.5 7.61929 20.3807 6.5 19 6.5H9C7.61929 6.5 6.5 7.61929 6.5 9V19C6.5 20.3807 7.61929 21.5 9 21.5H13.1667"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CheckDoc = (props: any) => (
    <svg width="30" {...props} height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6668 18.1111L9.55566 15L12.6668 11.8889"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.3334 11.8889L20.4445 15L17.3334 18.1111"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect x="1" y="1" width="28" height="28" rx="4" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const SendIngIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2131 14.1739L12.2793 23.471C12.5371 24.6295 14.076 24.8792 14.6861 23.8619L24.31 7.82137C24.8361 6.94637 24.2061 5.83337 23.1853 5.83337H5.04247C3.8723 5.83337 3.28664 7.24737 4.1138 8.07454L10.2131 14.1739Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.313 6.48669L10.208 14.175"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const JobPrecessingIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.64 3.37567H10.36" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.75999 1.69571H9.23999" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.92 5.04001H3.07999C2.46119 5.04001 1.95999 5.54121 1.95999 6.16001V10.64C1.95999 11.2588 2.46119 11.76 3.07999 11.76H10.92C11.5388 11.76 12.04 11.2588 12.04 10.64V6.16001C12.04 5.54121 11.5388 5.04001 10.92 5.04001Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="8.12"
            y="6.72"
            width="2.24"
            height="1.68"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.64 8.4H5.32" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.64 10.08H6.44" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const JobDataPrecessingIcon = (props: any) => (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.96014 1C8.72181 1 10.9601 3.23833 10.9601 6C10.9601 8.76167 8.72181 11 5.96014 11"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.25203 10.6938C3.6987 10.4922 3.18981 10.1999 2.74759 9.82883"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.74759 2.17106C3.18981 1.79939 3.6987 1.50717 4.25203 1.30606"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.04001 5.13229C1.14279 4.54729 1.34612 3.99785 1.63279 3.50174"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.04001 6.8674C1.14279 7.4524 1.34612 8.00185 1.63279 8.49796"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.80353 3.77011V6.354L7.83464 7.59233"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const JobDataCompletedIcon = (props: any) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.92083 5.56778L6.01917 7.66667L10.2831 3.40278C9.40528 1.96389 7.82528 1 6.01639 1C3.25472 1 1.01639 3.23833 1.01639 6C1.01639 8.76167 3.25472 11 6.01639 11C8.58972 11 10.7069 9.05556 10.9836 6.55556"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const JobCompletedIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.10651 7.08691L6.13959 11.7355C6.26851 12.3147 7.03792 12.4396 7.34301 11.9309L12.1549 3.91066C12.418 3.47316 12.103 2.91666 11.5926 2.91666H2.52117C1.93609 2.91666 1.64326 3.62366 2.05684 4.03724L5.10651 7.08691Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.1567 3.24332L5.10417 7.08748" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const JobMessageErrorIcon = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1.75V1.75C9.89975 1.75 12.25 4.10025 12.25 7V7C12.25 9.89975 9.89975 12.25 7 12.25V12.25C4.10025 12.25 1.75 9.89975 1.75 7V7C1.75 4.10025 4.10025 1.75 7 1.75Z"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.99999 7.29167V4.375" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M6.99941 9.33333C6.91891 9.33333 6.85358 9.39867 6.85416 9.47917C6.85416 9.55967 6.9195 9.625 7 9.625C7.0805 9.625 7.14583 9.55967 7.14583 9.47917C7.14583 9.39867 7.0805 9.33333 6.99941 9.33333"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const JobMessageDeliveryIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.16422 8.16715L2.65265 5.68643C2.82396 5.40092 3.07313 5.17018 3.37093 5.02127L3.71244 4.85053C3.95553 4.72898 4.22359 4.6657 4.49539 4.6657H5.24925"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.96121 7.45519C5.52381 7.24545 5.24656 6.8023 5.24923 6.31722V2.91497C5.24923 2.27037 5.7718 1.74782 6.4164 1.74782H11.6686C12.3132 1.74782 12.8357 2.27037 12.8357 2.91497V6.41643C12.8357 7.06103 12.3132 7.58358 11.6686 7.58358H8.54538"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.26187 2.78984L8.10947 4.43165C8.6507 4.7437 9.3172 4.7437 9.85842 4.43165L12.8167 2.72601"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.33139 12.2522L5.69388 11.0372C6.1632 10.8676 6.56581 10.5521 6.84268 10.1369L8.58924 7.51786C8.84328 7.13693 8.79308 6.62964 8.46932 6.30588V6.30588C8.09431 5.93087 7.48631 5.93081 7.11123 6.30574L5.83285 7.58358H4.6657"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
// export const JobReadIcon = (props: any) => (
// <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M1.74942 5.25V10.5C1.74942 11.4666 2.53284 12.25 3.49942 12.25H10.4994C11.466 12.25 12.2494 11.4666 12.2494 10.5V5.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
// <path fillRule="evenodd" clipRule="evenodd" d="M2.5655 3.94626L5.98442 1.49451C6.594 1.05701 7.41475 1.05759 8.02434 1.49509L11.4287 3.93984C12.5189 4.72267 12.5183 6.00309 11.4275 6.78476L8.015 9.23184C7.40542 9.66934 6.58467 9.66876 5.97509 9.23126L2.56434 6.78184C1.47817 6.00134 1.47875 4.72559 2.5655 3.94626Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
// <path d="M10.5012 7.44917V6.41667C10.5012 5.77208 9.97909 5.25 9.33451 5.25H4.66784C4.02326 5.25 3.50117 5.77208 3.50117 6.41667V7.42292" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
// </svg>

// )
export const JobCanceledIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 1.75V1.75C9.89975 1.75 12.25 4.10025 12.25 7V7C12.25 9.89975 9.89975 12.25 7 12.25V12.25C4.10025 12.25 1.75 9.89975 1.75 7V7C1.75 4.10025 4.10025 1.75 7 1.75Z"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.99999 7.29167V4.375" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M6.99941 9.33333C6.91891 9.33333 6.85358 9.39867 6.85416 9.47917C6.85416 9.55967 6.9195 9.625 7 9.625C7.0805 9.625 7.14583 9.55967 7.14583 9.47917C7.14583 9.39867 7.0805 9.33333 6.99941 9.33333"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const JobMessageReadIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.74942 5.25V10.5C1.74942 11.4666 2.53284 12.25 3.49942 12.25H10.4994C11.466 12.25 12.2494 11.4666 12.2494 10.5V5.25"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5655 3.94626L5.98442 1.49451C6.594 1.05701 7.41475 1.05759 8.02434 1.49509L11.4287 3.93984C12.5189 4.72267 12.5183 6.00309 11.4275 6.78476L8.015 9.23184C7.40542 9.66934 6.58467 9.66876 5.97509 9.23126L2.56434 6.78184C1.47817 6.00134 1.47875 4.72559 2.5655 3.94626Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5012 7.44917V6.41667C10.5012 5.77208 9.97909 5.25 9.33451 5.25H4.66784C4.02326 5.25 3.50117 5.77208 3.50117 6.41667V7.42292"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PreviousIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19.25 3.5L8.75 14.0023L19.2442 24.5"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DragNDropIcon = (props: any) => (
    <svg width="36" {...props} height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.5 32H6C5.172 32 4.5 31.328 4.5 30.5V14C4.5 13.172 5.172 12.5 6 12.5H22.5C23.328 12.5 24 13.172 24 14V30.5C24 31.328 23.328 32 22.5 32Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M31.5 8V6.5C31.5 5.672 30.828 5 30 5H28.5"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M31.5 23V24.5C31.5 25.328 30.828 26 30 26H28.5"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 8V6.5C10.5 5.672 11.172 5 12 5H13.5"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M19.5 5H22.5" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M31.5 17V14" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const AttachementRead = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.24927 6.75V13.5C2.24927 14.7428 3.25652 15.75 4.49927 15.75H13.4993C14.742 15.75 15.7493 14.7428 15.7493 13.5V6.75"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.29841 5.07375L7.69416 1.9215C8.47791 1.359 9.53316 1.35975 10.3169 1.92225L14.6939 5.0655C16.0957 6.072 16.0949 7.71825 14.6924 8.72325L10.3049 11.8695C9.52116 12.432 8.46591 12.4313 7.68216 11.8688L3.29691 8.7195C1.90041 7.716 1.90116 6.07575 3.29841 5.07375Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5015 9.5775V8.25C13.5015 7.42125 12.8302 6.75 12.0015 6.75H6.00146C5.17271 6.75 4.50146 7.42125 4.50146 8.25V9.54375"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachementMore = (props: any) => (
    <svg width="22" {...props} height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.9976 15.5853C10.7684 15.5853 10.5808 15.7728 10.5833 16.0021C10.5833 16.2314 10.7709 16.4189 11.0001 16.4189C11.2294 16.4189 11.417 16.2314 11.417 16.0021C11.417 15.7728 11.2294 15.5853 10.9976 15.5853"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9976 10.5832C10.7684 10.5832 10.5808 10.7708 10.5833 11C10.5833 11.2293 10.7709 11.4169 11.0001 11.4169C11.2294 11.4169 11.417 11.2293 11.417 11C11.417 10.7708 11.2294 10.5832 10.9976 10.5832"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9976 5.58112C10.7684 5.58112 10.5808 5.76869 10.5833 5.99796C10.5833 6.22722 10.7709 6.4148 11.0001 6.4148C11.2294 6.4148 11.417 6.22722 11.417 5.99796C11.417 5.76869 11.2294 5.58112 10.9976 5.58112"
            stroke="black"
            strokeOpacity="0.7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachementNoRead = (props: any) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5305 9.5385L14.91 7.24725C15.4357 6.89175 15.75 6.2985 15.75 5.664V5.664C15.75 4.6065 14.8935 3.75 13.8367 3.75H4.17448C3.11773 3.75 2.26123 4.6065 2.26123 5.66325V5.66325C2.26123 6.29775 2.57548 6.891 3.10123 7.24725L6.48073 9.5385C8.00548 10.572 10.0057 10.572 11.5305 9.5385V9.5385Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.25 5.66327V12.75C2.25 13.9928 3.25725 15 4.5 15H13.5C14.7428 15 15.75 13.9928 15.75 12.75V5.66402"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const English = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 30" {...props} width="1000" height="600">
        <clipPath id="t">
            <path d="M25,15h25v15zv15h-25zh-25v-15zv-15h25z" />
        </clipPath>
        <path d="M0,0v30h50v-30z" fill="#012169" />
        <path d="M0,0 50,30M50,0 0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 50,30M50,0 0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4" />
        <path d="M-1 11h22v-12h8v12h22v8h-22v12h-8v-12h-22z" fill="#C8102E" stroke="#FFF" strokeWidth="2" />
    </svg>
)

export const French = (props: any) => (
    <svg width="18" height="12" {...props} viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 1C0 0.447715 0.447715 0 1 0H6V12H1C0.447715 12 0 11.5523 0 11V1Z" fill="#165BB9" />
        <rect x="6" width="6" height="12" fill="white" />
        <path d="M12 0H17C17.5523 0 18 0.447715 18 1V11C18 11.5523 17.5523 12 17 12H12V0Z" fill="#C21818" />
    </svg>
)

export const LogOutIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3333 10H3.33334" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.16583 5.83334L13.3333 10.0008L9.16583 14.1675"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.3333 3.33334H15C15.9208 3.33334 16.6667 4.07918 16.6667 5.00001V15C16.6667 15.9208 15.9208 16.6667 15 16.6667H13.3333"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EditProfile = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.99749 14.5853C9.76823 14.5853 9.58065 14.7728 9.58315 15.0021C9.58315 15.2314 9.77073 15.4189 10 15.4189C10.2293 15.4189 10.4168 15.2314 10.4168 15.0021C10.4168 14.7728 10.2293 14.5853 9.99749 14.5853"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.99749 9.58319C9.76823 9.58319 9.58065 9.77077 9.58315 10C9.58315 10.2293 9.77073 10.4169 10 10.4169C10.2293 10.4169 10.4168 10.2293 10.4168 10C10.4168 9.77077 10.2293 9.58319 9.99749 9.58319"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.99749 4.58112C9.76823 4.58112 9.58065 4.76869 9.58315 4.99796C9.58315 5.22722 9.77073 5.4148 10 5.4148C10.2293 5.4148 10.4168 5.22722 10.4168 4.99796C10.4168 4.76869 10.2293 4.58112 9.99749 4.58112"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StarOutline = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73309 20.829C7.22623 21.0936 6.61304 21.047 6.15196 20.7089C5.69089 20.3708 5.46212 19.8 5.56209 19.237L6.37109 14.6L2.96509 11.336C2.54876 10.939 2.39619 10.3388 2.57235 9.79117C2.74851 9.24352 3.22237 8.84486 3.79209 8.76501L8.52109 8.08901L10.6561 3.83001C10.9092 3.31923 11.43 2.99609 12.0001 2.99609C12.5702 2.99609 13.0909 3.31923 13.3441 3.83001L15.4791 8.08901L20.2081 8.76501C20.7778 8.84486 21.2517 9.24352 21.4278 9.79117C21.604 10.3388 21.4514 10.939 21.0351 11.336L17.6291 14.6L18.4381 19.238C18.5381 19.801 18.3093 20.3718 17.8482 20.7099C17.3871 21.048 16.7739 21.0946 16.2671 20.83L12.0001 18.625L7.73309 20.829Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ReNewIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 4.66278C9.29197 4.6635 5.32093 8.16919 4.73643 12.8408C4.15193 17.5124 7.13682 21.8884 11.6995 23.049C16.2622 24.2097 20.9753 21.7919 22.6941 17.4088C24.413 13.0258 22.5998 8.04872 18.4643 5.79842"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.4644 9.38737V5.26031H22.5914"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PowerIocn = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.9499 5.05005C17.6834 7.78355 17.6834 12.2163 14.9499 14.9498C12.2164 17.6833 7.78363 17.6833 5.05012 14.9498C2.31662 12.2163 2.31662 7.78355 5.05012 5.05005"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10 3V10" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const CloseEtiquetteIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.66663 4.66666L9.33329 9.33332"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33329 4.66666L4.66663 9.33332"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CloseIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.33331 9.33331L18.6666 18.6666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.6666 9.33331L9.33331 18.6666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PdfFile = (props: any) => (
    <svg width="28" height="29" viewBox="0 0 28 29" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3372 9.83137H18.6686C18.024 9.83137 17.5015 9.30882 17.5015 8.66422V3.99561"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.99707 9.83137V6.32991C6.99707 5.04071 8.04217 3.99561 9.33138 3.99561H17.7022C18.3212 3.99561 18.9149 4.24176 19.3525 4.67956L22.6533 7.98026C23.0911 8.41793 23.3372 9.01157 23.3372 9.63062V22.67C23.3372 23.9592 22.2921 25.0044 21.0029 25.0044H9.33138C8.04217 25.0044 6.99707 23.9592 6.99707 22.67V21.5029"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="3.49561"
            y="9.83136"
            width="11.6715"
            height="11.6715"
            rx="3"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.48389 13.3071H10.4018C11.0464 13.3071 11.5689 13.8297 11.5689 14.4743V15.0579C11.5689 15.7025 11.0464 16.225 10.4018 16.225H7.48389"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.48397 17.9757V13.3071"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CheckIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.3334 7.58331L10.5 20.4166L4.66669 14.5833"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TransmissionEmailTableIcon = (props: any) => (
    <svg width="21" height="21" {...props} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3117 11.0984L17.0667 8.55252C17.6508 8.15752 18 7.49835 18 6.79335V6.79335C18 5.61835 17.0483 4.66669 15.8742 4.66669H5.13835C3.96418 4.66669 3.01251 5.61835 3.01251 6.79252V6.79252C3.01251 7.49752 3.36168 8.15669 3.94585 8.55252L7.70085 11.0984C9.39501 12.2467 11.6175 12.2467 13.3117 11.0984V11.0984Z"
            stroke="#307ADE"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.79254V14.6667C3 16.0475 4.11917 17.1667 5.5 17.1667H15.5C16.8808 17.1667 18 16.0475 18 14.6667V6.79337"
            stroke="#307ADE"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Send = (props: any) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.75401 12.149L10.525 20.118C10.746 21.111 12.065 21.325 12.588 20.453L20.837 6.704C21.288 5.954 20.748 5 19.873 5H4.32201C3.31901 5 2.81701 6.212 3.52601 6.921L8.75401 12.149Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.84 5.56L8.75 12.15"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const Posted = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.51667 3.90833V3.90833C8.75 4.14166 8.80833 4.43333 8.75 4.66666L8.10833 8.05C7.93333 8.86666 7.29167 9.50833 6.475 9.68333L3.09166 10.325C2.8 10.3833 2.50833 10.2667 2.33333 10.0917V10.0917C1.98333 9.74166 1.98333 9.21666 2.33333 8.86666L7.29166 3.90833C7.58333 3.55833 8.16667 3.55833 8.51667 3.90833V3.90833Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.25001 2.39166C5.23368 2.39166 5.22084 2.37883 5.22084 2.3625C5.22084 2.34616 5.23368 2.33333 5.25001 2.33333C5.26634 2.33333 5.27918 2.34616 5.27918 2.3625C5.27918 2.37883 5.26634 2.39166 5.25001 2.39166"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.75 12.25H12.25" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.75001 4.08333V2.33333" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.50001 2.91666V2.33333" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.51667 3.90833L11.55 6.94166C12.0167 7.40833 12.0167 8.10833 11.55 8.57499L7.875 12.25"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M2.27502 10.15L4.43336 12.25" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EditStatusIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 17 16" fill="none" {...props}>
        <path
            d="M14.7222 7.61133H15.6111C16.1018 7.61133 16.5 8.00955 16.5 8.50022V13.8336C16.5 14.3242 16.1018 14.7224 15.6111 14.7224H1.38889C0.898222 14.7224 0.5 14.3242 0.5 13.8336V8.50022C0.5 8.00955 0.898222 7.61133 1.38889 7.61133H2.27778"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.7222 7.61133H15.6111C16.1018 7.61133 16.5 8.00955 16.5 8.50022V13.8336C16.5 14.3242 16.1018 14.7224 15.6111 14.7224H1.38889C0.898222 14.7224 0.5 14.3242 0.5 13.8336V8.50022C0.5 8.00955 0.898222 7.61133 1.38889 7.61133H2.27778"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.1667 2.27795L13.8334 4.94462"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.1667 2.27795L13.8334 4.94462"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.684 0.760667L6.04755 7.39711C5.88044 7.56422 5.78711 7.79 5.78711 8.02556V10.278H8.13111C8.36667 10.278 8.59333 10.1847 8.75955 10.0176L15.3498 3.42733C15.6973 3.07978 15.6973 2.51711 15.3498 2.17044L13.94 0.760667C13.5942 0.413111 13.0316 0.413111 12.684 0.760667V0.760667Z"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.684 0.760667L6.04755 7.39711C5.88044 7.56422 5.78711 7.79 5.78711 8.02556V10.278H8.13111C8.36667 10.278 8.59333 10.1847 8.75955 10.0176L15.3498 3.42733C15.6973 3.07978 15.6973 2.51711 15.3498 2.17044L13.94 0.760667C13.5942 0.413111 13.0316 0.413111 12.684 0.760667V0.760667Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EditIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" viewBox="0 0 28 28" {...props}>
        <defs>
            <clipPath id="clip-path">
                <rect id="Mask" width="28" height="28" fill="none" />
            </clipPath>
        </defs>
        <rect width="28" height="28" fill="none" />
        <g clip-path="url(#clip-path)">
            <path
                data-name="Rectangle 4"
                d="M0,2A2,2,0,0,1,2,0H4A2,2,0,0,1,6,2V18L3,23,0,18Z"
                transform="translate(18.01 2.247) rotate(45)"
                fill="none"
                stroke="#000"
                stroke-miterlimit="15"
                stroke-linejoin="round"
                stroke-width="1.5"
            />
            <path
                d="M0,1H5"
                transform="translate(15.536 5.429) rotate(45)"
                fill="none"
                stroke="#000"
                stroke-linecap="square"
                stroke-miterlimit="10"
                troke-width="1.5"
            />
        </g>
    </svg>
)

export const Warning = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 2.5V2.5C14.6425 2.5 18 5.8575 18 10V10C18 14.1425 14.6425 17.5 10.5 17.5V17.5C6.3575 17.5 3 14.1425 3 10V10C3 5.8575 6.3575 2.5 10.5 2.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 10.4167V6.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4992 13.3333C10.3842 13.3333 10.2908 13.4267 10.2917 13.5417C10.2917 13.6567 10.385 13.75 10.5 13.75C10.615 13.75 10.7083 13.6567 10.7083 13.5417C10.7083 13.4267 10.615 13.3333 10.4992 13.3333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Email = () => (
    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.999176 7.5V15C0.999176 16.3808 2.11834 17.5 3.49918 17.5H13.4992C14.88 17.5 15.9992 16.3808 15.9992 15V7.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.16502 5.63751L7.04918 2.13501C7.92002 1.51001 9.09252 1.51084 9.96335 2.13584L14.8267 5.62834C16.3842 6.74667 16.3834 8.57584 14.825 9.69251L9.95002 13.1883C9.07918 13.8133 7.90668 13.8125 7.03585 13.1875L2.16335 9.68834C0.611685 8.57334 0.612518 6.75084 2.16502 5.63751Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5017 10.6417V9.16667C13.5017 8.24583 12.7558 7.5 11.835 7.5H5.16835C4.24751 7.5 3.50168 8.24583 3.50168 9.16667V10.6042"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EmailError = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 8.33333L9 12.8333C9.88889 13.5 11.1111 13.5 12 12.8333L18 8.33333"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3467 7.09417L12.02 3.01513C11.1231 2.32829 9.877 2.32829 8.98008 3.01513L3.65333 7.09417C3.2415 7.40955 2.99999 7.8987 3 8.41743V15C3 16.3807 4.11929 17.5 5.5 17.5H15.5C16.8807 17.5 18 16.3807 18 15V8.41738C18 7.89868 17.7585 7.40954 17.3467 7.09417Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.45834 6.87503L11.5417 8.95836"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.45834 8.95836L11.5417 6.87503"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EmailPending = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.1667 11.4658V5.0275"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.3334 15H4.66669C3.28585 15 2.16669 13.8808 2.16669 12.5V5.0275"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.11335 9.18166L3.07085 6.52583C2.51502 6.23249 2.16669 5.65583 2.16669 5.02749V4.99999C2.16669 4.07916 2.91252 3.33333 3.83335 3.33333H15.4725C16.4084 3.33333 17.1667 4.09166 17.1667 5.02749V5.04416C17.1667 5.66249 16.8242 6.23083 16.2767 6.51916L11.22 9.18249C10.2475 9.69416 9.08585 9.69416 8.11335 9.18166Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.825 14.58C18.825 16.6508 17.1467 18.33 15.0758 18.33C13.0483 18.3308 11.3242 16.6067 11.325 14.5792C11.3258 12.5083 13.0042 10.83 15.075 10.83C17.1458 10.83 18.825 12.5092 18.825 14.58"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.9767 13.175V14.8025L16.2567 15.5833"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Dashboard = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 21H16C14.895 21 14 20.105 14 19V14C14 12.895 14.895 12 16 12H19C20.105 12 21 12.895 21 14V19C21 20.105 20.105 21 19 21Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 9H16C14.895 9 14 8.105 14 7V5C14 3.895 14.895 3 16 3H19C20.105 3 21 3.895 21 5V7C21 8.105 20.105 9 19 9Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 3H8C9.105 3 10 3.895 10 5V10C10 11.105 9.105 12 8 12H5C3.895 12 3 11.105 3 10V5C3 3.895 3.895 3 5 3Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 15H8C9.105 15 10 15.895 10 17V19C10 20.105 9.105 21 8 21H5C3.895 21 3 20.105 3 19V17C3 15.895 3.895 15 5 15Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Contact = (props: any) => (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3348 22.0037H5.66391C4.74253 22.0037 3.99622 21.2574 3.99622 20.3361V8.66519C3.99622 7.74381 4.74253 6.9975 5.66391 6.9975H17.3358C18.2562 6.9975 19.0025 7.74381 19.0025 8.66519V20.3371C19.0025 21.2574 18.2562 22.0037 17.3348 22.0037Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.2681 11.1652C14.2445 12.1416 14.2445 13.7253 13.2681 14.7027C12.2917 15.6791 10.708 15.6791 9.73061 14.7027C8.7532 13.7263 8.7542 12.1426 9.73061 11.1652C10.707 10.1878 12.2907 10.1888 13.2681 11.1652"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.0012 19.4367C15.8701 19.1075 15.667 18.8114 15.4069 18.5703V18.5703C14.9678 18.1621 14.3925 17.9361 13.7923 17.9361C12.7918 17.9361 10.2068 17.9361 9.20636 17.9361C8.60611 17.9361 8.03187 18.1631 7.59168 18.5703V18.5703C7.33158 18.8114 7.12849 19.1075 6.99744 19.4367"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.99744 6.9975V5.66394C6.99744 4.74256 7.74375 3.99625 8.66513 3.99625H20.337C21.2574 3.99625 22.0037 4.74256 22.0037 5.66394V17.3358C22.0037 18.2562 21.2574 19.0025 20.336 19.0025H19.0024"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const Archive = (props: any) => (
    <svg
        style={props.style}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={props.style?.fill || "none"}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.6666 14.6667V15.5556C14.6666 16.0465 14.2687 16.4444 13.7778 16.4444H10.2222C9.73128 16.4444 9.33331 16.0465 9.33331 15.5556V14.6667"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 13.0437V18.2222C4 19.2041 4.79594 20 5.77778 20H18.2222C19.2041 20 20 19.2041 20 18.2222V13.0437C20 12.3516 19.899 11.6632 19.7001 11.0003L17.9801 5.26693C17.7545 4.51496 17.0624 3.99999 16.2773 4H7.72272C6.93764 4 6.24551 4.51496 6.01992 5.26693L4.29992 11.0003C4.10104 11.6632 4 12.3516 4 13.0437Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.9224 12H4.0777"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.1111 6.66667H8.88892"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16 9.33333H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const Bill = (props: any) => (
    <svg
        style={props.style}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={props.style?.fill || "none"}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M8 7H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 11H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 15H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.776 20.888L8.447 19.223C8.165 19.082 7.834 19.082 7.553 19.223L4.724 20.638C4.391 20.804 4 20.563 4 20.191V4C4 3.448 4.448 3 5 3H19C19.552 3 20 3.448 20 4V20.191C20 20.563 19.609 20.804 19.276 20.638L16.447 19.223C16.165 19.082 15.834 19.082 15.553 19.223L12.224 20.888C12.083 20.959 11.917 20.959 11.776 20.888V20.888Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 6.99C15.997 6.99 15.995 6.992 15.995 6.995C15.995 6.998 15.997 7 16 7C16.003 7 16.005 6.998 16.005 6.995C16.005 6.992 16.003 6.99 16 6.99"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 10.99C15.997 10.99 15.995 10.992 15.995 10.995C15.995 10.998 15.997 11 16 11C16.003 11 16.005 10.998 16.005 10.995C16.005 10.992 16.003 10.99 16 10.99"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 14.99C15.997 14.99 15.995 14.992 15.995 14.995C15.995 14.998 15.997 15 16 15C16.003 15 16.005 14.998 16.005 14.995C16.005 14.992 16.003 14.99 16 14.99"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Report = (props: any) => (
    <svg
        style={props.style}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={props.style?.fill || "none"}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.6 26.8V19.6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M28.4 19.6V26.8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.8 19.6V26.8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M22 19.6V26.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M25.2 19.6V26.8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22 17.4199C21.9448 17.4199 21.9 17.4647 21.9008 17.5199C21.9008 17.5751 21.9456 17.6199 22.0008 17.6199C22.056 17.6199 22.1008 17.5751 22.1008 17.5199C22.1 17.4647 22.0552 17.4199 22 17.4199"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6 19.6H14.4V17.4888L22 14.8L29.6 17.4888V19.6Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.2 26.8H14.8L14 27.6V29.2H30V27.6L29.2 26.8Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M48.018 17.214C49.1007 17.214 50.0293 17.41 50.804 17.802C51.5787 18.194 52.1713 18.7587 52.582 19.496C52.9927 20.2333 53.198 21.1107 53.198 22.128C53.198 23.136 52.9927 24.0087 52.582 24.746C52.1713 25.474 51.5787 26.034 50.804 26.426C50.0293 26.8087 49.1007 27 48.018 27H45.12V17.214H48.018ZM48.018 26.188C49.3807 26.188 50.4167 25.8333 51.126 25.124C51.8447 24.4053 52.204 23.4067 52.204 22.128C52.204 20.84 51.8447 19.8367 51.126 19.118C50.4167 18.39 49.3807 18.026 48.018 18.026H46.1V26.188H48.018ZM61.9208 22.786C61.9208 23.122 61.9114 23.3787 61.8928 23.556H55.5508C55.5788 24.1347 55.7188 24.6293 55.9708 25.04C56.2228 25.4507 56.5541 25.7633 56.9648 25.978C57.3754 26.1833 57.8234 26.286 58.3088 26.286C58.9434 26.286 59.4754 26.132 59.9048 25.824C60.3434 25.516 60.6328 25.1007 60.7728 24.578H61.8088C61.6221 25.3247 61.2208 25.936 60.6048 26.412C59.9981 26.8787 59.2328 27.112 58.3088 27.112C57.5901 27.112 56.9461 26.9533 56.3768 26.636C55.8074 26.3093 55.3594 25.852 55.0328 25.264C54.7154 24.6667 54.5568 23.9713 54.5568 23.178C54.5568 22.3847 54.7154 21.6893 55.0328 21.092C55.3501 20.4947 55.7934 20.0373 56.3628 19.72C56.9321 19.4027 57.5808 19.244 58.3088 19.244C59.0368 19.244 59.6714 19.4027 60.2128 19.72C60.7634 20.0373 61.1834 20.4667 61.4728 21.008C61.7714 21.54 61.9208 22.1327 61.9208 22.786ZM60.9268 22.758C60.9361 22.1887 60.8194 21.7033 60.5768 21.302C60.3434 20.9007 60.0214 20.5973 59.6108 20.392C59.2001 20.1867 58.7521 20.084 58.2668 20.084C57.5388 20.084 56.9181 20.3173 56.4048 20.784C55.8914 21.2507 55.6068 21.9087 55.5508 22.758H60.9268ZM59.5268 17.102L56.6568 18.768V18.012L59.5268 16.22V17.102ZM63.2658 23.178C63.2658 22.3847 63.4244 21.694 63.7418 21.106C64.0591 20.5087 64.4978 20.0513 65.0578 19.734C65.6178 19.4073 66.2571 19.244 66.9758 19.244C67.9184 19.244 68.6931 19.4773 69.2998 19.944C69.9158 20.4107 70.3124 21.0453 70.4898 21.848H69.4398C69.3091 21.2973 69.0244 20.868 68.5858 20.56C68.1564 20.2427 67.6198 20.084 66.9758 20.084C66.4624 20.084 66.0004 20.2007 65.5898 20.434C65.1791 20.6673 64.8524 21.0173 64.6098 21.484C64.3764 21.9413 64.2598 22.506 64.2598 23.178C64.2598 23.85 64.3764 24.4193 64.6098 24.886C64.8524 25.3527 65.1791 25.7027 65.5898 25.936C66.0004 26.1693 66.4624 26.286 66.9758 26.286C67.6198 26.286 68.1564 26.132 68.5858 25.824C69.0244 25.5067 69.3091 25.068 69.4398 24.508H70.4898C70.3124 25.292 69.9158 25.922 69.2998 26.398C68.6838 26.874 67.9091 27.112 66.9758 27.112C66.2571 27.112 65.6178 26.9533 65.0578 26.636C64.4978 26.3093 64.0591 25.852 63.7418 25.264C63.4244 24.6667 63.2658 23.9713 63.2658 23.178ZM73.2797 16.64V27H72.2997V16.64H73.2797ZM75.0509 23.164C75.0509 22.38 75.2049 21.694 75.5129 21.106C75.8302 20.5087 76.2642 20.0513 76.8149 19.734C77.3749 19.4073 78.0049 19.244 78.7049 19.244C79.4329 19.244 80.0582 19.412 80.5809 19.748C81.1129 20.084 81.4956 20.5133 81.7289 21.036V19.356H82.7089V27H81.7289V25.306C81.4862 25.8287 81.0989 26.2627 80.5669 26.608C80.0442 26.944 79.4189 27.112 78.6909 27.112C78.0002 27.112 77.3749 26.9487 76.8149 26.622C76.2642 26.2953 75.8302 25.8333 75.5129 25.236C75.2049 24.6387 75.0509 23.948 75.0509 23.164ZM81.7289 23.178C81.7289 22.562 81.6029 22.0207 81.3509 21.554C81.0989 21.0873 80.7536 20.728 80.3149 20.476C79.8856 20.224 79.4096 20.098 78.8869 20.098C78.3456 20.098 77.8602 20.2193 77.4309 20.462C77.0016 20.7047 76.6609 21.0593 76.4089 21.526C76.1662 21.9833 76.0449 22.5293 76.0449 23.164C76.0449 23.7893 76.1662 24.34 76.4089 24.816C76.6609 25.2827 77.0016 25.642 77.4309 25.894C77.8602 26.1367 78.3456 26.258 78.8869 26.258C79.4096 26.258 79.8856 26.132 80.3149 25.88C80.7536 25.628 81.0989 25.2687 81.3509 24.802C81.6029 24.3353 81.7289 23.794 81.7289 23.178ZM85.9262 20.714C86.1408 20.238 86.4675 19.8693 86.9062 19.608C87.3542 19.3467 87.9002 19.216 88.5442 19.216V20.238H88.2782C87.5688 20.238 86.9995 20.4293 86.5702 20.812C86.1408 21.1947 85.9262 21.834 85.9262 22.73V27H84.9462V19.356H85.9262V20.714ZM89.5704 23.164C89.5704 22.38 89.7244 21.694 90.0324 21.106C90.3498 20.5087 90.7838 20.0513 91.3344 19.734C91.8944 19.4073 92.5244 19.244 93.2244 19.244C93.9524 19.244 94.5778 19.412 95.1004 19.748C95.6324 20.084 96.0151 20.5133 96.2484 21.036V19.356H97.2284V27H96.2484V25.306C96.0058 25.8287 95.6184 26.2627 95.0864 26.608C94.5638 26.944 93.9384 27.112 93.2104 27.112C92.5198 27.112 91.8944 26.9487 91.3344 26.622C90.7838 26.2953 90.3498 25.8333 90.0324 25.236C89.7244 24.6387 89.5704 23.948 89.5704 23.164ZM96.2484 23.178C96.2484 22.562 96.1224 22.0207 95.8704 21.554C95.6184 21.0873 95.2731 20.728 94.8344 20.476C94.4051 20.224 93.9291 20.098 93.4064 20.098C92.8651 20.098 92.3798 20.2193 91.9504 20.462C91.5211 20.7047 91.1804 21.0593 90.9284 21.526C90.6858 21.9833 90.5644 22.5293 90.5644 23.164C90.5644 23.7893 90.6858 24.34 90.9284 24.816C91.1804 25.2827 91.5211 25.642 91.9504 25.894C92.3798 26.1367 92.8651 26.258 93.4064 26.258C93.9291 26.258 94.4051 26.132 94.8344 25.88C95.2731 25.628 95.6184 25.2687 95.8704 24.802C96.1224 24.3353 96.2484 23.794 96.2484 23.178ZM100.74 20.182V24.928C100.74 25.3947 100.828 25.7167 101.006 25.894C101.183 26.0713 101.496 26.16 101.944 26.16H102.84V27H101.79C101.099 27 100.586 26.8413 100.25 26.524C99.9137 26.1973 99.7457 25.6653 99.7457 24.928V20.182H98.6817V19.356H99.7457V17.438H100.74V19.356H102.84V20.182H100.74ZM104.946 17.914C104.75 17.914 104.582 17.844 104.442 17.704C104.302 17.564 104.232 17.3913 104.232 17.186C104.232 16.9807 104.302 16.8127 104.442 16.682C104.582 16.542 104.75 16.472 104.946 16.472C105.142 16.472 105.31 16.542 105.45 16.682C105.59 16.8127 105.66 16.9807 105.66 17.186C105.66 17.3913 105.59 17.564 105.45 17.704C105.31 17.844 105.142 17.914 104.946 17.914ZM105.436 19.356V27H104.456V19.356H105.436ZM111.001 27.112C110.282 27.112 109.634 26.9533 109.055 26.636C108.486 26.3093 108.033 25.852 107.697 25.264C107.37 24.6667 107.207 23.9713 107.207 23.178C107.207 22.3847 107.375 21.694 107.711 21.106C108.047 20.5087 108.504 20.0513 109.083 19.734C109.662 19.4073 110.31 19.244 111.029 19.244C111.748 19.244 112.396 19.4073 112.975 19.734C113.563 20.0513 114.02 20.5087 114.347 21.106C114.683 21.694 114.851 22.3847 114.851 23.178C114.851 23.962 114.683 24.6527 114.347 25.25C114.011 25.8473 113.549 26.3093 112.961 26.636C112.373 26.9533 111.72 27.112 111.001 27.112ZM111.001 26.258C111.505 26.258 111.972 26.146 112.401 25.922C112.83 25.6887 113.176 25.3433 113.437 24.886C113.708 24.4193 113.843 23.85 113.843 23.178C113.843 22.506 113.712 21.9413 113.451 21.484C113.19 21.0173 112.844 20.672 112.415 20.448C111.986 20.2147 111.519 20.098 111.015 20.098C110.511 20.098 110.044 20.2147 109.615 20.448C109.186 20.672 108.84 21.0173 108.579 21.484C108.327 21.9413 108.201 22.506 108.201 23.178C108.201 23.85 108.327 24.4193 108.579 24.886C108.84 25.3433 109.181 25.6887 109.601 25.922C110.03 26.146 110.497 26.258 111.001 26.258ZM120.222 19.216C121.136 19.216 121.883 19.5007 122.462 20.07C123.04 20.63 123.33 21.4467 123.33 22.52V27H122.364V22.632C122.364 21.8013 122.154 21.1667 121.734 20.728C121.323 20.2893 120.758 20.07 120.04 20.07C119.302 20.07 118.714 20.3033 118.276 20.77C117.837 21.2367 117.618 21.9227 117.618 22.828V27H116.638V19.356H117.618V20.658C117.86 20.1913 118.21 19.8367 118.668 19.594C119.125 19.342 119.643 19.216 120.222 19.216ZM128.129 27.112C127.252 27.112 126.533 26.9113 125.973 26.51C125.422 26.0993 125.114 25.544 125.049 24.844H126.057C126.104 25.2733 126.304 25.6233 126.659 25.894C127.023 26.1553 127.508 26.286 128.115 26.286C128.647 26.286 129.062 26.16 129.361 25.908C129.669 25.656 129.823 25.3433 129.823 24.97C129.823 24.7087 129.739 24.494 129.571 24.326C129.403 24.158 129.188 24.0273 128.927 23.934C128.675 23.8313 128.33 23.724 127.891 23.612C127.322 23.4627 126.86 23.3133 126.505 23.164C126.15 23.0147 125.847 22.7953 125.595 22.506C125.352 22.2073 125.231 21.8107 125.231 21.316C125.231 20.9427 125.343 20.5973 125.567 20.28C125.791 19.9627 126.108 19.7107 126.519 19.524C126.93 19.3373 127.396 19.244 127.919 19.244C128.74 19.244 129.403 19.454 129.907 19.874C130.411 20.2847 130.682 20.854 130.719 21.582H129.739C129.711 21.134 129.534 20.7747 129.207 20.504C128.89 20.224 128.451 20.084 127.891 20.084C127.396 20.084 126.995 20.2007 126.687 20.434C126.379 20.6673 126.225 20.9567 126.225 21.302C126.225 21.6007 126.314 21.848 126.491 22.044C126.678 22.2307 126.906 22.38 127.177 22.492C127.448 22.5947 127.812 22.7113 128.269 22.842C128.82 22.9913 129.258 23.136 129.585 23.276C129.912 23.416 130.192 23.6213 130.425 23.892C130.658 24.1627 130.78 24.522 130.789 24.97C130.789 25.3807 130.677 25.7493 130.453 26.076C130.229 26.3933 129.916 26.6453 129.515 26.832C129.114 27.0187 128.652 27.112 128.129 27.112Z"
            fill="white"
        />
    </svg>
)

export const Bill2 = (props) => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12 10.5H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 16.5H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 22.5H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.664 31.332L12.6705 28.8345C12.2475 28.623 11.751 28.623 11.3295 28.8345L7.086 30.957C6.5865 31.206 6 30.8445 6 30.2865V6C6 5.172 6.672 4.5 7.5 4.5H28.5C29.328 4.5 30 5.172 30 6V30.2865C30 30.8445 29.4135 31.206 28.914 30.957L24.6705 28.8345C24.2475 28.623 23.751 28.623 23.3295 28.8345L18.336 31.332C18.1245 31.4385 17.8755 31.4385 17.664 31.332V31.332Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24 10.485C23.9955 10.485 23.9925 10.488 23.9925 10.4925C23.9925 10.497 23.9955 10.5 24 10.5C24.0045 10.5 24.0075 10.497 24.0075 10.4925C24.0075 10.488 24.0045 10.485 24 10.485"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24 16.485C23.9955 16.485 23.9925 16.488 23.9925 16.4925C23.9925 16.497 23.9955 16.5 24 16.5C24.0045 16.5 24.0075 16.497 24.0075 16.4925C24.0075 16.488 24.0045 16.485 24 16.485"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24 22.485C23.9955 22.485 23.9925 22.488 23.9925 22.4925C23.9925 22.497 23.9955 22.5 24 22.5C24.0045 22.5 24.0075 22.497 24.0075 22.4925C24.0075 22.488 24.0045 22.485 24 22.485"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CreditCart = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.002 18.0025V12C17.0022 11.4693 16.7914 10.9603 16.4162 10.585C16.0409 10.2098 15.5319 9.99902 15.0012 9.99917H4.99705C4.46635 9.99902 3.95735 10.2098 3.58209 10.585C3.20682 10.9603 2.99607 11.4693 2.99622 12V18.0025C2.99607 18.5332 3.20682 19.0422 3.58209 19.4175C3.95735 19.7927 4.46635 20.0035 4.99705 20.0033H15.0012C16.1062 20.0033 17.002 19.1075 17.002 18.0025Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.99622 14.0799H17.0021"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.19757 9.99917L7.40807 5.47729C7.54542 4.96481 7.88105 4.52806 8.34089 4.26341C8.80074 3.99877 9.34699 3.92799 9.8591 4.0667L19.5231 6.65778C20.0356 6.79512 20.4724 7.13075 20.737 7.5906C21.0016 8.05044 21.0724 8.59669 20.9337 9.1088L19.3831 14.9012C19.1071 15.9437 18.0521 16.5776 17.0021 16.3318"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Bank = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 18V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 9V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 9V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 9V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 9V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M12 6.275C11.931 6.275 11.875 6.331 11.876 6.4C11.876 6.469 11.932 6.525 12.001 6.525C12.07 6.525 12.126 6.469 12.126 6.4C12.125 6.331 12.069 6.275 12 6.275"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5 9H2.5V6.361L12 3L21.5 6.361V9Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 18H3L2 19V21H22V19L21 18Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Money = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 19.5V13.5H21V19.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21 13.5H22.5V7.5H10.5V13.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26.7426 21.2574C29.0858 23.6005 29.0858 27.3995 26.7426 29.7427C24.3995 32.0858 20.6005 32.0858 18.2573 29.7427C15.9142 27.3995 15.9142 23.6005 18.2573 21.2574C20.6005 18.9142 24.3995 18.9142 26.7426 21.2574"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 25.5V31.5H22.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.5 19.5H7.5V25.5H16.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Disk = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27 21H9C6.5145 21 4.5 23.0145 4.5 25.5V25.5C4.5 27.9855 6.5145 30 9 30H27C29.4855 30 31.5 27.9855 31.5 25.5V25.5C31.5 23.0145 29.4855 21 27 21Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M27 25.5H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.05303 25.4469C9.08232 25.4762 9.08232 25.5237 9.05303 25.553C9.02374 25.5823 8.97626 25.5823 8.94697 25.553C8.91768 25.5237 8.91768 25.4762 8.94697 25.4469C8.97626 25.4176 9.02374 25.4176 9.05303 25.4469"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M31.485 25.1355L30.2145 8.7675C30.093 7.206 28.791 6 27.2235 6H8.77651C7.20901 6 5.90701 7.206 5.78551 8.7675L4.51501 25.1355"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Account = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.75 13H12.25C13.7688 13 15 14.2312 15 15.75V21H9V15.75C9 14.2312 10.2312 13 11.75 13Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 18V10.9597C3 9.5927 3.62139 8.29979 4.68885 7.44582L8.8765 4.09568C10.7026 2.63477 13.2974 2.63477 15.1235 4.09568L19.3111 7.44581C20.3786 8.29978 21 9.59269 21 10.9597V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DomainIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17 21V4C17 3.448 16.552 3 16 3H8C7.448 3 7 3.448 7 4V21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 9H3C2.448 9 2 9.448 2 10V21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22 21V10C22 9.448 21.552 9 21 9H17"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.5 17H14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.5 17V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 21V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 10.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 13.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 7.5H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 13.5H7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 17H7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 13.5H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 17H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23 21H1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const Setting = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.65402 18.634L10.18 19.817C10.4995 20.5364 11.2128 21 12 21V21C12.7872 21 13.5006 20.5364 13.82 19.817L14.346 18.634C14.5333 18.2142 14.8482 17.8643 15.246 17.634V17.634C15.6463 17.4031 16.1094 17.3047 16.569 17.353L17.856 17.49C18.6387 17.5728 19.3967 17.1867 19.79 16.505V16.505C20.1838 15.8237 20.1392 14.9743 19.676 14.338L18.914 13.291C18.6427 12.9154 18.4977 12.4633 18.5 12V12C18.4999 11.5379 18.6463 11.0877 18.918 10.714L19.68 9.667C20.1432 9.03075 20.1878 8.18133 19.794 7.5V7.5C19.4007 6.81827 18.6427 6.43221 17.86 6.515L16.573 6.652C16.1134 6.70027 15.6503 6.60191 15.25 6.371V6.371C14.8514 6.13943 14.5364 5.78762 14.35 5.366L13.82 4.183C13.5006 3.46355 12.7872 3 12 3V3C11.2128 3 10.4995 3.46355 10.18 4.183L9.65402 5.366C9.46765 5.78762 9.1526 6.13943 8.75402 6.371V6.371C8.35371 6.60191 7.89062 6.70027 7.43102 6.652L6.14002 6.515C5.35733 6.43221 4.59933 6.81827 4.20602 7.5V7.5C3.81219 8.18133 3.85688 9.03075 4.32002 9.667L5.08202 10.714C5.35376 11.0877 5.5001 11.5379 5.50002 12V12C5.5001 12.4621 5.35376 12.9123 5.08202 13.286L4.32002 14.333C3.85688 14.9693 3.81219 15.8187 4.20602 16.5V16.5C4.5997 17.1813 5.35742 17.5673 6.14002 17.485L7.42702 17.348C7.88662 17.2997 8.34971 17.3981 8.75002 17.629V17.629C9.15009 17.8599 9.4666 18.2118 9.65402 18.634V18.634Z"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <circle
            cx="12"
            cy="12"
            r="2.647"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Signed = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.9497 5.55026C21.6834 8.28393 21.6834 12.7161 18.9497 15.4497C16.216 18.1834 11.7839 18.1834 9.0502 15.4497C6.31652 12.7161 6.31652 8.28392 9.0502 5.55026C11.7839 2.81658 16.216 2.81658 18.9497 5.55026"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33331 15.7068V24.5L14 22.1667L18.6666 24.5V15.7068"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Statistic = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.33 3.50249C26.247 4.24199 30.135 8.12849 30.873 13.0455C31.008 13.944 30.285 14.7495 29.376 14.7495H21.1245C20.2965 14.7495 19.6245 14.0775 19.6245 13.2495V4.99799C19.6245 4.08899 20.4315 3.36749 21.33 3.50249V3.50249Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.776 26.3835C29.8545 24.927 30.5925 23.2035 30.873 21.33C31.008 20.4315 30.285 19.626 29.376 19.626H23.2455C21.909 19.626 21.24 21.2415 22.185 22.1865L26.5215 26.523C27.1605 27.1605 28.2375 27.1095 28.776 26.3835V26.3835Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0635 9.999C6.864 10.92 2.2965 16.8435 3.597 23.532C4.4625 27.9825 8.0595 31.563 12.513 32.4105C15.8895 33.0525 19.0665 32.202 21.501 30.4035C22.23 29.865 22.2855 28.785 21.645 28.1445L15.189 21.6885C14.907 21.4065 14.7495 21.0255 14.7495 20.628V11.493C14.7495 10.5915 13.956 9.867 13.0635 9.999V9.999Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SendEre = (props: any) => (
    <svg width="21" height="20" viewBox="0 0 21 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.79501 10.1242L9.27084 16.765C9.45501 17.5925 10.5542 17.7708 10.99 17.0442L17.8642 5.58666C18.24 4.96166 17.79 4.16666 17.0608 4.16666H4.10168C3.26584 4.16666 2.84751 5.17666 3.43834 5.76749L7.79501 10.1242Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.8667 4.63333L7.79169 10.125"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Envelope = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.99918 7.5V15C2.99918 16.3808 4.11834 17.5 5.49918 17.5H15.4992C16.88 17.5 17.9992 16.3808 17.9992 15V7.5"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.16502 5.63751L9.04918 2.13501C9.92002 1.51001 11.0925 1.51084 11.9634 2.13584L16.8267 5.62834C18.3842 6.74667 18.3834 8.57584 16.825 9.69251L11.95 13.1883C11.0792 13.8133 9.90668 13.8125 9.03585 13.1875L4.16335 9.68834C2.61168 8.57334 2.61252 6.75084 4.16502 5.63751Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.5017 10.6417V9.16667C15.5017 8.24583 14.7558 7.5 13.835 7.5H7.16835C6.24751 7.5 5.50168 8.24583 5.50168 9.16667V10.6042"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeOff = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 8.33333L9 12.8333C9.88889 13.5 11.1111 13.5 12 12.8333L18 8.33333"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3467 7.09417L12.02 3.01513C11.1231 2.32829 9.877 2.32829 8.98008 3.01513L3.65333 7.09417C3.2415 7.40955 2.99999 7.8987 3 8.41743V15C3 16.3807 4.11929 17.5 5.5 17.5H15.5C16.8807 17.5 18 16.3807 18 15V8.41738C18 7.89868 17.7585 7.40954 17.3467 7.09417Z"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.45834 6.87503L11.5417 8.95836"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.45834 8.95836L11.5417 6.87503"
            stroke="#9747FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeClose = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.1667 11.4658V5.0275"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.3334 15H4.66669C3.28585 15 2.16669 13.8808 2.16669 12.5V5.0275"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.11335 9.18166L3.07085 6.52583C2.51502 6.23249 2.16669 5.65583 2.16669 5.02749V4.99999C2.16669 4.07916 2.91252 3.33333 3.83335 3.33333H15.4725C16.4084 3.33333 17.1667 4.09166 17.1667 5.02749V5.04416C17.1667 5.66249 16.8242 6.23083 16.2767 6.51916L11.22 9.18249C10.2475 9.69416 9.08585 9.69416 8.11335 9.18166Z"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.825 14.58C18.825 16.6508 17.1467 18.33 15.0758 18.33C13.0483 18.3308 11.3242 16.6067 11.325 14.5792C11.3258 12.5083 13.0042 10.83 15.075 10.83C17.1458 10.83 18.825 12.5092 18.825 14.58"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.9767 13.175V14.8025L16.2567 15.5833"
            stroke="#D5895E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const HelpCenter = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.2988 11.2988C11.5754 10.107 12.6609 9.28066 13.8833 9.3314C15.2514 9.25562 16.4242 10.2981 16.5094 11.6657C16.5094 13.421 14 14 14 15.1672"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.1461 18.377C14.146 18.4575 14.0807 18.5227 14.0001 18.5227C13.9196 18.5227 13.8543 18.4574 13.8543 18.3769C13.8543 18.2964 13.9195 18.231 14 18.2309C14.0388 18.2309 14.076 18.2463 14.1034 18.2737C14.1308 18.3011 14.1461 18.3382 14.1461 18.377"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.39981 20.0205C2.26953 15.5525 3.07396 9.43293 7.25261 5.9257C11.4313 2.41846 17.5976 2.68728 21.4552 6.54486C25.3127 10.4024 25.5816 16.5688 22.0743 20.7474C18.5671 24.9261 12.4475 25.7305 7.97954 22.6002L4.66279 23.3372L5.39981 20.0205Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SearchCenter = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5586 6.51217C19.2791 9.23263 19.2791 13.6434 16.5586 16.3638C13.8382 19.0843 9.42743 19.0843 6.70697 16.3638C3.98651 13.6434 3.98651 9.23263 6.70697 6.51217C9.42743 3.79172 13.8382 3.79172 16.5586 6.51217"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5083 16.4033L23.3333 23.3217"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ContactSingle = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9 8.25C7.56385 8.25 6.38775 7.07443 6.38775 5.63775H4.88775C4.88775 7.90307 6.73564 9.75 9 9.75V8.25ZM6.38775 5.63775C6.38775 4.19369 7.5712 3 9 3V1.5C6.7283 1.5 4.88775 3.37981 4.88775 5.63775H6.38775ZM9 3C10.4361 3 11.6122 4.17557 11.6122 5.61225H13.1122C13.1122 3.34693 11.2644 1.5 9 1.5V3ZM11.6122 5.61225C11.6122 7.05631 10.4288 8.25 9 8.25V9.75C11.2717 9.75 13.1122 7.87019 13.1122 5.61225H11.6122ZM14.25 15H3.75V16.5H14.25V15ZM3.75 15H2.25C2.25 15.8267 2.92329 16.5 3.75 16.5V15ZM3.75 15V14.25H2.25V15H3.75ZM3.75 14.25C3.75 13.0142 4.76421 12 6 12V10.5C3.93579 10.5 2.25 12.1858 2.25 14.25H3.75ZM6 12H12V10.5H6V12ZM12 12C13.2358 12 14.25 13.0142 14.25 14.25H15.75C15.75 12.1858 14.0642 10.5 12 10.5V12ZM14.25 14.25V15H15.75V14.25H14.25ZM14.25 15V16.5C15.0767 16.5 15.75 15.8267 15.75 15H14.25Z"
            fill="black"
        />
    </svg>
)

export const Tiers = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5006 5.99875V2.9975C10.5007 2.75148 10.6214 2.52114 10.8236 2.38103C11.0259 2.24092 11.2839 2.20886 11.5143 2.29521L15.2658 3.70205C15.5589 3.8119 15.753 4.09212 15.7528 4.40509V15.7528"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.89912 5.99875H11.1009C11.5981 5.99875 12.0012 6.40186 12.0012 6.89912V15.7528H5.99875V6.89912C5.99875 6.40186 6.40186 5.99875 6.89912 5.99875Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.24968 5.99874V4.49812C8.24968 4.08373 7.91375 3.7478 7.49937 3.7478H4.49812C4.08373 3.7478 3.7478 4.08373 3.7478 4.49812V8.24968"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.99875 2.24719V3.74782"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5031 15.7528H1.49686"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.87454 10.2755H10.1255"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.87454 8.2497H10.1255"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.87454 12.3014H10.1255"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.24719 15.7528V9.00001C2.24719 8.58562 2.58312 8.24969 2.9975 8.24969H5.99875"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ArchiveIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.5 8.16667H3.49998C2.85598 8.16667 2.33331 7.644 2.33331 7V4.66667C2.33331 4.02267 2.85598 3.5 3.49998 3.5H24.5C25.144 3.5 25.6666 4.02267 25.6666 4.66667V7C25.6666 7.644 25.144 8.16667 24.5 8.16667Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 12.8333H17.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.1115 8.16663V22.1666C24.1115 23.4558 23.0673 24.5 21.7782 24.5H6.22182C4.93266 24.5 3.88849 23.4558 3.88849 22.1666V8.16663"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.7235 22.0617L20.3152 21.0362C20.1087 20.5159 19.7878 20.0492 19.3772 19.6689L19.3025 19.6C18.6562 19.0004 17.8068 18.6667 16.9248 18.6667H11.0752C10.1932 18.6667 9.34383 19.0004 8.69633 19.5989L8.62166 19.6689C8.211 20.0492 7.89133 20.5159 7.68366 21.0362L7.27533 22.0617"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.8874 8.68829C18.482 10.2829 18.482 12.8684 16.8874 14.463C15.2927 16.0576 12.7073 16.0576 11.1127 14.463C9.51803 12.8684 9.51803 10.2829 11.1127 8.68829C12.7073 7.09365 15.2927 7.09365 16.8874 8.68829"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.4247 6.57538C25.5252 10.6759 25.5252 17.3241 21.4247 21.4246C17.3242 25.5251 10.6759 25.5251 6.57544 21.4246C2.47493 17.3241 2.47493 10.6759 6.57544 6.57538C10.6759 2.47487 17.3242 2.47487 21.4247 6.57538"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DocumentIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.483 7.483L18.1836 4.18367C17.7461 3.74617 17.1523 3.5 16.534 3.5H8.16665C6.87748 3.5 5.83331 4.54417 5.83331 5.83333V22.1667C5.83331 23.4558 6.87748 24.5 8.16665 24.5H19.8333C21.1225 24.5 22.1666 23.4558 22.1666 22.1667V9.13267C22.1666 8.51433 21.9205 7.9205 21.483 7.483V7.483Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.1666 9.33333H17.5C16.856 9.33333 16.3333 8.81067 16.3333 8.16667V3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserOffIcon = (props: any) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="14"
            cy="9.62312"
            r="4.9604"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66278 23.3371C4.66278 20.4368 7.01459 18.085 9.91497 18.085H12.9297"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3558 23.0664L22.4829 18.9393"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.3558 18.9393L22.4829 23.0664"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AbandonIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.1666 12.8333V9.13267C22.1666 8.51433 21.9205 7.9205 21.483 7.483L18.1836 4.18367C17.7461 3.74617 17.1523 3.5 16.534 3.5H8.16665C6.87748 3.5 5.83331 4.54417 5.83331 5.83333V22.1667C5.83331 23.4558 6.87748 24.5 8.16665 24.5H15.1666"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.1666 9.33333H17.5C16.856 9.33333 16.3333 8.81067 16.3333 8.16667V3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6667 20.4167C25.6667 22.6765 23.8432 24.5 21.5833 24.5C19.3235 24.5 17.5 22.6765 17.5 20.4167C17.5 18.1569 19.3235 16.3334 21.5833 16.3334C23.8432 16.3334 25.6667 18.1569 25.6667 20.4167Z"
            stroke="currentColor"
            strokeWidth="1.3125"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.697 23.3029L24.4696 17.5303"
            stroke="currentColor"
            strokeWidth="1.3125"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const RefreshIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.875 9.625H3.5V5.25"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.5 14C24.5 8.2005 19.7995 3.5 14 3.5C9.76502 3.5 6.12385 6.013 4.46368 9.625"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.125 18.375H24.5V22.75"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 14C3.5 19.7995 8.2005 24.5 14 24.5C18.235 24.5 21.8762 21.987 23.5363 18.375"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Filter = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0833 11.25L16.4225 6.91081C16.5792 6.75415 16.6667 6.54248 16.6667 6.32165V4.16665C16.6667 3.70665 16.2933 3.33331 15.8333 3.33331H4.16666C3.70666 3.33331 3.33333 3.70665 3.33333 4.16665V6.32165C3.33333 6.54248 3.42083 6.75498 3.57749 6.91081L7.91666 11.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.91666 11.25V16.4575C7.91666 17.135 8.55332 17.6325 9.21082 17.4683L11.2942 16.9475C11.7575 16.8317 12.0833 16.415 12.0833 15.9367V11.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeOpen = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.36872 8.15793V14.7895C3.36872 16.0105 4.3583 17 5.57925 17H14.4214C15.6423 17 16.6319 16.0105 16.6319 14.7895V8.15793"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.36872 8.15793V14.7895C3.36872 16.0105 4.3583 17 5.57925 17H14.4214C15.6423 17 16.6319 16.0105 16.6319 14.7895V8.15793"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.39956 6.51105L8.71819 3.41411C9.48819 2.86147 10.5249 2.86221 11.2949 3.41484L15.5951 6.50295C16.9723 7.49179 16.9716 9.10916 15.5937 10.0965L11.2831 13.1876C10.5131 13.7402 9.4764 13.7395 8.7064 13.1868L4.39808 10.0928C3.02608 9.10695 3.02682 7.49547 4.39956 6.51105Z"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.39956 6.51105L8.71819 3.41411C9.48819 2.86147 10.5249 2.86221 11.2949 3.41484L15.5951 6.50295C16.9723 7.49179 16.9716 9.10916 15.5937 10.0965L11.2831 13.1876C10.5131 13.7402 9.4764 13.7395 8.7064 13.1868L4.39808 10.0928C3.02608 9.10695 3.02682 7.49547 4.39956 6.51105Z"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.4235 10.9358V9.63161C14.4235 8.8174 13.7641 8.15793 12.9498 8.15793H7.05511C6.2409 8.15793 5.58143 8.8174 5.58143 9.63161V10.9027"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.4235 10.9358V9.63161C14.4235 8.8174 13.7641 8.15793 12.9498 8.15793H7.05511C6.2409 8.15793 5.58143 8.8174 5.58143 9.63161V10.9027"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeOpenActive = (props: any) => (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.868576 6.15793V12.7895C0.868576 14.0105 1.85815 15 3.0791 15H11.9212C13.1422 15 14.1317 14.0105 14.1317 12.7895V6.15793"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M0.868576 6.15793V12.7895C0.868576 14.0105 1.85815 15 3.0791 15H11.9212C13.1422 15 14.1317 14.0105 14.1317 12.7895V6.15793"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.89941 4.51105L6.21804 1.41411C6.98804 0.861474 8.02478 0.862211 8.79478 1.41484L13.095 4.50295C14.4721 5.49179 14.4714 7.10916 13.0935 8.09653L8.78299 11.1876C8.01299 11.7402 6.97626 11.7395 6.20626 11.1868L1.89794 8.09284C0.52594 7.10695 0.526676 5.49547 1.89941 4.51105Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9234 8.93582V7.63161C11.9234 6.8174 11.2639 6.15793 10.4497 6.15793H4.55497C3.74076 6.15793 3.08128 6.8174 3.08128 7.63161V8.90267"
            fill="white"
        />
        <path
            d="M11.9234 8.93582V7.63161C11.9234 6.8174 11.2639 6.15793 10.4497 6.15793H4.55497C3.74076 6.15793 3.08128 6.8174 3.08128 7.63161V8.90267"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeCloseIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 6.15079V13.5C3 14.7888 4.04456 15.8333 5.33333 15.8333H14.6667C15.9554 15.8333 17 14.7888 17 13.5V6.15157"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.15079V13.5C3 14.7888 4.04456 15.8333 5.33333 15.8333H14.6667C15.9554 15.8333 17 14.7888 17 13.5V6.15157"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6245 10.1695L16.1292 7.79343C16.6744 7.42477 17.0003 6.80955 17.0003 6.15155V6.15155C17.0003 5.05488 16.1121 4.16666 15.0162 4.16666H4.99607C3.90019 4.16666 3.01196 5.05488 3.01196 6.15077V6.15077C3.01196 6.80877 3.33785 7.42399 3.88307 7.79343L7.38774 10.1695C8.96896 11.2413 11.0433 11.2413 12.6245 10.1695V10.1695Z"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6245 10.1695L16.1292 7.79343C16.6744 7.42477 17.0003 6.80955 17.0003 6.15155V6.15155C17.0003 5.05488 16.1121 4.16666 15.0162 4.16666H4.99607C3.90019 4.16666 3.01196 5.05488 3.01196 6.15077V6.15077C3.01196 6.80877 3.33785 7.42399 3.88307 7.79343L7.38774 10.1695C8.96896 11.2413 11.0433 11.2413 12.6245 10.1695V10.1695Z"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeCloseIconActive = (props: any) => (
    <svg width="16" height="14" {...props} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 3.15079V10.5C1 11.7888 2.04456 12.8333 3.33333 12.8333H12.6667C13.9554 12.8333 15 11.7888 15 10.5V3.15157"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M1 3.15079V10.5C1 11.7888 2.04456 12.8333 3.33333 12.8333H12.6667C13.9554 12.8333 15 11.7888 15 10.5V3.15157"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6245 7.16954L14.1292 4.79343C14.6744 4.42477 15.0003 3.80955 15.0003 3.15155V3.15155C15.0003 2.05488 14.1121 1.16666 13.0162 1.16666H2.99607C1.90019 1.16666 1.01196 2.05488 1.01196 3.15077V3.15077C1.01196 3.80877 1.33785 4.42399 1.88307 4.79343L5.38774 7.16954C6.96896 8.24132 9.0433 8.24132 10.6245 7.16954V7.16954Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ArrowDownIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.5 5.25L7 8.75L10.5 5.25"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 5.25L7 8.75L10.5 5.25"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FilterInput = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.0833 11.25L16.4225 6.91081C16.5791 6.75415 16.6666 6.54248 16.6666 6.32165V4.16665C16.6666 3.70665 16.2933 3.33331 15.8333 3.33331H4.16665C3.70665 3.33331 3.33331 3.70665 3.33331 4.16665V6.32165C3.33331 6.54248 3.42081 6.75498 3.57748 6.91081L7.91665 11.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.91663 11.25V16.4575C7.91663 17.135 8.55329 17.6325 9.21079 17.4683L11.2941 16.9475C11.7575 16.8317 12.0833 16.415 12.0833 15.9367V11.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TableIconNew = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V15.8333C17.5 16.7542 16.7542 17.5 15.8333 17.5H4.16667C3.24583 17.5 2.5 16.7542 2.5 15.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.49999 2.5V17.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.5 2.5V17.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const DisableUser = (props: any) => (
    <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="15"
            cy="10.6231"
            r="4.9604"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.66278 24.3371C5.66278 21.4368 8.01459 19.085 10.915 19.085H13.9297"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.3558 24.0664L23.4829 19.9393"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.3558 19.9393L23.4829 24.0664"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FilterIcon = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9167 15.75L22.9915 9.67513C23.2109 9.45579 23.3334 9.15946 23.3334 8.85029V5.83329C23.3334 5.18929 22.8107 4.66663 22.1667 4.66663H5.83335C5.18935 4.66663 4.66669 5.18929 4.66669 5.83329V8.85029C4.66669 9.15946 4.78919 9.45696 5.00852 9.67513L11.0834 15.75"
            fill="currentcolor"
            fillOpacity="0.3"
        />
        <path
            d="M16.9167 15.75L22.9915 9.67513C23.2109 9.45579 23.3334 9.15946 23.3334 8.85029V5.83329C23.3334 5.18929 22.8107 4.66663 22.1667 4.66663H5.83335C5.18935 4.66663 4.66669 5.18929 4.66669 5.83329V8.85029C4.66669 9.15946 4.78919 9.45696 5.00852 9.67513L11.0834 15.75"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0834 15.75V23.0405C11.0834 23.989 11.9747 24.6855 12.8952 24.4557L15.8119 23.7265C16.4605 23.5643 16.9167 22.981 16.9167 22.3113V15.75"
            fill="currentcolor"
            fillOpacity="0.3"
        />
        <path
            d="M11.0834 15.75V23.0405C11.0834 23.989 11.9747 24.6855 12.8952 24.4557L15.8119 23.7265C16.4605 23.5643 16.9167 22.981 16.9167 22.3113V15.75"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnabledUser = (props: any) => (
    <svg width="28" height="28" {...props} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 13.25C11.536 13.25 9.51985 11.2348 9.51985 8.76983H8.01985C8.01985 12.0635 10.7077 14.75 14 14.75V13.25ZM9.51985 8.76983C9.51985 6.29744 11.5433 4.25 14 4.25V2.75C10.7004 2.75 8.01985 5.48356 8.01985 8.76983H9.51985ZM14 4.25C16.4641 4.25 18.4802 6.26516 18.4802 8.73017H19.9802C19.9802 5.43651 17.2923 2.75 14 2.75V4.25ZM18.4802 8.73017C18.4802 11.2026 16.4567 13.25 14 13.25V14.75C17.2996 14.75 19.9802 12.0164 19.9802 8.73017H18.4802ZM22.1667 23.75H5.83335V25.25H22.1667V23.75ZM5.83335 23.75C5.6059 23.75 5.41669 23.5608 5.41669 23.3333H3.91669C3.91669 24.3892 4.77747 25.25 5.83335 25.25V23.75ZM5.41669 23.3333V22.1667H3.91669V23.3333H5.41669ZM5.41669 22.1667C5.41669 20.0142 7.1809 18.25 9.33335 18.25V16.75C6.35247 16.75 3.91669 19.1858 3.91669 22.1667H5.41669ZM9.33335 18.25H18.6667V16.75H9.33335V18.25ZM18.6667 18.25C20.8191 18.25 22.5834 20.0142 22.5834 22.1667H24.0834C24.0834 19.1858 21.6476 16.75 18.6667 16.75V18.25ZM22.5834 22.1667V23.3333H24.0834V22.1667H22.5834ZM22.5834 23.3333C22.5834 23.5608 22.3941 23.75 22.1667 23.75V25.25C23.2226 25.25 24.0834 24.3892 24.0834 23.3333H22.5834Z"
            fill="currentcolor"
        />
    </svg>
)

export const ColomnViewSave = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.48061 14.9621L6.40017 16.5594C6.08071 16.7284 5.69314 16.7022 5.3994 16.4916C5.10566 16.2811 4.9563 15.9225 5.01375 15.5657L5.70154 11.6107L2.78783 8.81036C2.52743 8.56012 2.4335 8.18278 2.54621 7.83967C2.65892 7.49657 2.95831 7.24843 3.31638 7.20136L7.34306 6.62445L9.14131 3.02295C9.30519 2.70028 9.63643 2.49701 9.99833 2.49701C10.3602 2.49701 10.6915 2.70028 10.8554 3.02295L12.6578 6.62445L16.6844 7.19969C17.0423 7.24674 17.3416 7.49462 17.4544 7.83745C17.5673 8.18028 17.4738 8.55745 17.2138 8.80786L15.5698 10.3877"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.4956 12.8412C16.138 13.4822 16.3308 14.4472 15.984 15.2858C15.6372 16.1244 14.8191 16.6713 13.9116 16.6713C13.0041 16.6713 12.1861 16.1244 11.8393 15.2858C11.4924 14.4472 11.6852 13.4822 12.3276 12.8412C13.2028 11.9673 14.6204 11.9673 15.4956 12.8412"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.9862 17.5031L15.4956 16.0125"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SelectOn = (props: any) => (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5 0H2.5C1.39 0 0.5 0.9 0.5 2V16C0.5 17.1 1.39 18 2.5 18H16.5C17.61 18 18.5 17.1 18.5 16V2C18.5 0.9 17.61 0 16.5 0ZM7.5 14L2.5 9L3.91 7.59L7.5 11.17L15.09 3.58L16.5 5L7.5 14Z"
            fill="#307ADE"
        />
    </svg>
)

export const SelectSome = (props: any) => (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM14.5 10H4.5V8H14.5V10Z"
            fill="#307ADE"
        />
    </svg>
)

export const SelectOff = (props: any) => (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="0.5" width="17" height="17" rx="1.5" fill="white" stroke="#D3E5F4" />
    </svg>
)

export const ReadContact = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.3739 12.718L19.8799 9.663C20.5809 9.189 20.9999 8.398 20.9999 7.552C20.9999 6.142 19.8579 5 18.4489 5H5.56589C4.15689 5 3.01489 6.142 3.01489 7.551C3.01489 8.397 3.43389 9.188 4.13489 9.663L8.64089 12.718C10.6739 14.096 13.3409 14.096 15.3739 12.718Z"
            fill="#307ADE"
            fillOpacity="0.3"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 7.55103V17C3 18.657 4.343 20 6 20H18C19.657 20 21 18.657 21 17V7.55203"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M3 7.55103V17C3 18.657 4.343 20 6 20H18C19.657 20 21 18.657 21 17V7.55203"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const Read = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3117 10.5983L17.0667 8.05251C17.6508 7.65751 18 6.99834 18 6.29334V6.29334C18 5.11834 17.0483 4.16667 15.8742 4.16667H5.13835C3.96418 4.16667 3.01251 5.11834 3.01251 6.29251V6.29251C3.01251 6.99751 3.36168 7.65667 3.94585 8.05251L7.70085 10.5983C9.39501 11.7467 11.6175 11.7467 13.3117 10.5983V10.5983Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.29251V14.1667C3 15.5475 4.11917 16.6667 5.5 16.6667H15.5C16.8808 16.6667 18 15.5475 18 14.1667V6.29334"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const NoRead = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.49918 7.5V15C2.49918 16.3808 3.61834 17.5 4.99918 17.5H14.9992C16.38 17.5 17.4992 16.3808 17.4992 15V7.5"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.66502 5.6375L8.54918 2.135C9.42002 1.51 10.5925 1.51083 11.4634 2.13583L16.3267 5.62833C17.8842 6.74666 17.8834 8.57583 16.325 9.6925L11.45 13.1883C10.5792 13.8133 9.40668 13.8125 8.53585 13.1875L3.66335 9.68833C2.11168 8.57333 2.11252 6.75083 3.66502 5.6375Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.0017 10.6417V9.16667C15.0017 8.24583 14.2558 7.5 13.335 7.5H6.66835C5.74751 7.5 5.00168 8.24583 5.00168 9.16667V10.6042"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SettingsIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" color="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.263 21.7397L11.8766 23.1198C12.2493 23.9592 13.0816 24.5 14 24.5V24.5C14.9184 24.5 15.7506 23.9592 16.1233 23.1198L16.737 21.7397C16.9554 21.2499 17.3229 20.8417 17.787 20.573V20.573C18.254 20.3036 18.7943 20.1889 19.3305 20.2452L20.832 20.405C21.7451 20.5016 22.6294 20.0512 23.0883 19.2558V19.2558C23.5478 18.4609 23.4956 17.47 22.9553 16.7277L22.0663 15.5062C21.7497 15.068 21.5806 14.5406 21.5833 14V14C21.5832 13.4609 21.7539 12.9357 22.071 12.4997L22.96 11.2782C23.5003 10.5359 23.5524 9.54489 23.093 8.75V8.75C22.6341 7.95464 21.7498 7.50425 20.8366 7.60083L19.3351 7.76067C18.7989 7.81698 18.2587 7.70223 17.7916 7.43283V7.43283C17.3266 7.16266 16.9591 6.75223 16.7416 6.26033L16.1233 4.88017C15.7506 4.04081 14.9184 3.5 14 3.5V3.5C13.0816 3.5 12.2493 4.04081 11.8766 4.88017L11.263 6.26033C11.0455 6.75223 10.678 7.16266 10.213 7.43283V7.43283C9.74594 7.70223 9.20567 7.81698 8.66947 7.76067L7.1633 7.60083C6.25016 7.50425 5.36583 7.95464 4.90697 8.75V8.75C4.44751 9.54489 4.49964 10.5359 5.03997 11.2782L5.92897 12.4997C6.24601 12.9357 6.41673 13.4609 6.41663 14V14C6.41673 14.5391 6.24601 15.0643 5.92897 15.5003L5.03997 16.7218C4.49964 17.4641 4.44751 18.4551 4.90697 19.25V19.25C5.36626 20.0449 6.25028 20.4951 7.1633 20.3992L8.6648 20.2393C9.201 20.183 9.74128 20.2978 10.2083 20.5672V20.5672C10.6751 20.8366 11.0443 21.2471 11.263 21.7397V21.7397Z"
            stroke="currentcolor"
            strokeWidth="1.5"
        />
        <circle
            cx="14"
            cy="14"
            r="3.08817"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const Trash = (props: any) => (
    <svg width="24" height="25" {...props} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7.5H19" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M18 7.5V18.5C18 19.605 17.105 20.5 16 20.5H8C6.895 20.5 6 19.605 6 18.5V7.5"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M15 4.25H9" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 11.5V16.5" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 11.5V16.5" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const CredentialErrorIcon = (props: any) => (
    <svg width="36" height="36" {...props} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 27L9 31.5" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.5 31.5L9 27" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.75 27L20.25 31.5" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.75 31.5L20.25 27"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M27 27L31.5 31.5" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27 31.5L31.5 27" stroke="#DA4FA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M23.172 19.359C22.5705 17.718 20.5035 16.5 18 16.5C15.4965 16.5 13.4295 17.718 12.828 19.359"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.3639 5.63604C27.8786 9.15077 27.8786 14.8493 24.3639 18.364C20.8492 21.8787 15.1507 21.8787 11.636 18.364C8.12126 14.8492 8.12126 9.15075 11.636 5.63604C15.1507 2.12132 20.8492 2.12132 24.3639 5.63604"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.1213 8.00368C21.2929 9.17525 21.2929 11.0748 20.1213 12.2463C18.9497 13.4179 17.0502 13.4179 15.8786 12.2463C14.7071 11.0748 14.7071 9.17526 15.8786 8.00368C17.0502 6.83211 18.9497 6.83211 20.1213 8.00368"
            stroke="#DA4FA3"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EyeOpenIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2384_219922)">
            <path
                d="M14.122 9.88024C15.293 11.0512 15.293 12.9522 14.122 14.1252C12.951 15.2962 11.05 15.2962 9.877 14.1252C8.706 12.9542 8.706 11.0532 9.877 9.88024C11.05 8.70724 12.95 8.70724 14.122 9.88024"
                stroke="#307ADE"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 12C3 11.341 3.152 10.689 3.446 10.088V10.088C4.961 6.991 8.309 5 12 5C15.691 5 19.039 6.991 20.554 10.088V10.088C20.848 10.689 21 11.341 21 12C21 12.659 20.848 13.311 20.554 13.912V13.912C19.039 17.009 15.691 19 12 19C8.309 19 4.961 17.009 3.446 13.912V13.912C3.152 13.311 3 12.659 3 12Z"
                stroke="#307ADE"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_2384_219922">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

export const EyeCloseIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.5581 13.5577C13.9186 14.6361 12.6764 15.2036 11.4425 14.9811C10.2087 14.7585 9.24295 13.7928 9.02042 12.559C8.79789 11.3251 9.36539 10.0829 10.4438 9.44336"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.9966 16.9961C16.2718 18.3043 14.1648 19.0094 12 19.0028C8.4129 19.0667 5.09855 17.0953 3.44244 13.9127C2.84754 12.7069 2.84754 11.2929 3.44244 10.0871C4.27069 8.43772 5.59099 7.08646 7.22073 6.22021"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.4273 14.1345C20.4675 14.0585 20.5197 13.9903 20.5576 13.9128C21.1525 12.707 21.1525 11.293 20.5576 10.0872C18.9015 6.90465 15.5871 4.93323 12 4.99711C11.7751 4.99711 11.5565 5.02712 11.3345 5.04175"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.0038 20.0037L3.99667 2.99658"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const GoldStart = (props: any) => (
    <svg width="19" {...props} height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.29975 16.1218C5.91961 16.3202 5.45972 16.2853 5.11391 16.0317C4.7681 15.7781 4.59653 15.35 4.6715 14.9278L5.27825 11.45L2.72375 9.00201C2.41151 8.70424 2.29708 8.25412 2.4292 7.84338C2.56132 7.43264 2.91671 7.13365 3.344 7.07376L6.89075 6.56676L8.492 3.37251C8.68186 2.98943 9.07245 2.74707 9.5 2.74707C9.92755 2.74707 10.3181 2.98943 10.508 3.37251L12.1093 6.56676L15.656 7.07376C16.0833 7.13365 16.4387 7.43264 16.5708 7.84338C16.7029 8.25412 16.5885 8.70424 16.2763 9.00201L13.7218 11.45L14.3285 14.9285C14.4035 15.3507 14.2319 15.7788 13.8861 16.0324C13.5403 16.286 13.0804 16.3209 12.7003 16.1225L9.5 14.4688L6.29975 16.1218Z"
            fill="#E8C611"
            fillOpacity="0.3"
            stroke="#E8C611"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EyeMoreIcon = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5915 7.41C11.4698 8.28825 11.4698 9.714 10.5915 10.5937C9.71327 11.472 8.28752 11.472 7.40777 10.5937C6.52952 9.7155 6.52952 8.28975 7.40777 7.41C8.28752 6.53025 9.71252 6.53025 10.5915 7.41"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.25 9C2.25 8.50575 2.364 8.01675 2.5845 7.566V7.566C3.72075 5.24325 6.23175 3.75 9 3.75C11.7682 3.75 14.2793 5.24325 15.4155 7.566V7.566C15.636 8.01675 15.75 8.50575 15.75 9C15.75 9.49425 15.636 9.98325 15.4155 10.434V10.434C14.2793 12.7567 11.7682 14.25 9 14.25C6.23175 14.25 3.72075 12.7567 2.5845 10.434V10.434C2.364 9.98325 2.25 9.49425 2.25 9Z"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DwnloadMoreIcon = (props: any) => (
    <svg width="18" height="18" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.00751 3.38251V14.6175"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.51727 10.1302L9.00002 14.6122L13.4828 10.1302"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const More = (props: any) => (
    <svg width="24" height="25" viewBox="0 0 24 25" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9972 18.0023C11.7221 18.0023 11.497 18.2274 11.5 18.5025C11.5 18.7776 11.7251 19.0027 12.0002 19.0027C12.2754 19.0027 12.5004 18.7776 12.5004 18.5025C12.5004 18.2274 12.2754 18.0023 11.9972 18.0023"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9972 11.9998C11.7221 11.9998 11.497 12.2249 11.5 12.5C11.5 12.7751 11.7251 13.0002 12.0002 13.0002C12.2754 13.0002 12.5004 12.7751 12.5004 12.5C12.5004 12.2249 12.2754 11.9998 11.9972 11.9998"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9972 5.99731C11.7221 5.99731 11.497 6.22241 11.5 6.49752C11.5 6.77264 11.7251 6.99773 12.0002 6.99773C12.2754 6.99773 12.5004 6.77264 12.5004 6.49752C12.5004 6.22241 12.2754 5.99731 11.9972 5.99731"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const LogoutIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.85999 12H20" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.8641 19.981L6.69605 20C5.50105 20.006 4.52905 19.048 4.52905 17.865V6.135C4.52905 4.956 5.49405 4 6.68605 4H11.0001"
            stroke="#307ADE"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16 16L20 12L16 8" stroke="#307ADE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const TableIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" color="#307ADE">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.1667 24.5H5.83333C4.54417 24.5 3.5 23.4558 3.5 22.1667V5.83333C3.5 4.54417 4.54417 3.5 5.83333 3.5H22.1667C23.4558 3.5 24.5 4.54417 24.5 5.83333V22.1667C24.5 23.4558 23.4558 24.5 22.1667 24.5Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.5 10.5H24.5" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.5 17.5H24.5" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 10.5V24.5" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EditRefSend = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.2317 5.90331L8.09668 3.76831" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.64642 12.25H1.75V10.3536C1.75 10.199 1.81125 10.0502 1.92092 9.94115L9.69908 2.1624C9.92717 1.93431 10.2964 1.93431 10.5239 2.1624L11.837 3.47548C12.0651 3.70356 12.0651 4.07281 11.837 4.30031L4.05883 12.0791C3.94975 12.1887 3.801 12.25 3.64642 12.25V12.25Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeGig = () => (
    <svg width="180" height="100" viewBox="0 0 180 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1247_10769)">
            <path
                d="M86.6153 31.3124C88.6563 29.918 91.3437 29.918 93.3847 31.3124L151.909 71.2958C156.781 74.6248 154.425 82.25 148.524 82.25L31.4761 82.25C25.5748 82.25 23.2187 74.6248 28.0914 71.2958L86.6153 31.3124Z"
                fill="white"
            />
        </g>
        <g filter="url(#filter1_d_1247_10769)">
            <path
                d="M93.3847 68.6876C91.3437 70.082 88.6563 70.082 86.6153 68.6876L28.0914 28.7042C23.2187 25.3752 25.5748 17.75 31.4761 17.75L148.524 17.75C154.425 17.75 156.781 25.3752 151.909 28.7042L93.3847 68.6876Z"
                fill="white"
            />
            <path
                d="M87.7435 67.0362L29.2196 27.0528C25.9712 24.8334 27.5419 19.75 31.4761 19.75L148.524 19.75C152.458 19.75 154.029 24.8334 150.78 27.0528L92.2565 67.0362C90.8958 67.9658 89.1042 67.9658 87.7435 67.0362Z"
                stroke="white"
                strokeWidth="4"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1247_10769"
                x="16.4648"
                y="21.2666"
                width="149.07"
                height="71.9834"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" dy="1" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.847 0 0 0 0 0.847 0 0 0 0 0.847 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1247_10769" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1247_10769" result="shape" />
            </filter>
            <filter
                id="filter1_d_1247_10769"
                x="16.4648"
                y="8.75"
                width="149.07"
                height="71.9834"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" dy="1" />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0.847 0 0 0 0 0.847 0 0 0 0 0.847 0 0 0 0.5 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1247_10769" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1247_10769" result="shape" />
            </filter>
        </defs>
    </svg>
)

export const ColIconMoney = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props} viewBox="0 0 14 14" fill="none">
        <path
            d="M10.7123 3.28769C12.7626 5.33794 12.7626 8.66206 10.7123 10.7123C8.66208 12.7626 5.33796 12.7626 3.28772 10.7123C1.23747 8.66204 1.23747 5.33793 3.28772 3.28769C5.33797 1.23744 8.66209 1.23744 10.7123 3.28769"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.7123 3.28769C12.7626 5.33794 12.7626 8.66206 10.7123 10.7123C8.66208 12.7626 5.33796 12.7626 3.28772 10.7123C1.23747 8.66204 1.23747 5.33793 3.28772 3.28769C5.33797 1.23744 8.66209 1.23744 10.7123 3.28769"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.06267 9.06268C7.92342 10.2019 6.07717 10.2019 4.93792 9.06268C3.79867 7.92343 3.79867 6.07718 4.93792 4.93793C6.07717 3.79868 7.92342 3.79868 9.06267 4.93793"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.06267 9.06268C7.92342 10.2019 6.07717 10.2019 4.93792 9.06268C3.79867 7.92343 3.79867 6.07718 4.93792 4.93793C6.07717 3.79868 7.92342 3.79868 9.06267 4.93793"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 6.19499H3.5"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 6.19499H3.5"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 7.80497H3.5"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 7.80497H3.5"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconUsers = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" {...props} height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M12.129 5.55536C12.5898 6.01621 12.5898 6.76339 12.129 7.22424C11.6681 7.68509 10.9209 7.68509 10.4601 7.22424C9.99921 6.76339 9.99921 6.01621 10.4601 5.55536C10.9209 5.0945 11.6681 5.0945 12.129 5.55536"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.129 5.55536C12.5898 6.01621 12.5898 6.76339 12.129 7.22424C11.6681 7.68509 10.9209 7.68509 10.4601 7.22424C9.99921 6.76339 9.99921 6.01621 10.4601 5.55536C10.9209 5.0945 11.6681 5.0945 12.129 5.55536"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.28485 3.44884C8.99446 4.15845 8.99446 5.30896 8.28485 6.01858C7.57523 6.7282 6.42472 6.7282 5.7151 6.01858C5.00549 5.30897 5.00549 4.15846 5.7151 3.44884C6.42472 2.73922 7.57523 2.73922 8.28485 3.44884"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.28485 3.44884C8.99446 4.15845 8.99446 5.30896 8.28485 6.01858C7.57523 6.7282 6.42472 6.7282 5.7151 6.01858C5.00549 5.30897 5.00549 4.15846 5.7151 3.44884C6.42472 2.73922 7.57523 2.73922 8.28485 3.44884"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.53995 5.55536C4.0008 6.01621 4.0008 6.76339 3.53995 7.22424C3.0791 7.68509 2.33191 7.68509 1.87106 7.22424C1.41021 6.76339 1.41021 6.01621 1.87106 5.55536C2.33191 5.0945 3.0791 5.0945 3.53995 5.55536"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.53995 5.55536C4.0008 6.01621 4.0008 6.76339 3.53995 7.22424C3.0791 7.68509 2.33191 7.68509 1.87106 7.22424C1.41021 6.76339 1.41021 6.01621 1.87106 5.55536C2.33191 5.0945 3.0791 5.0945 3.53995 5.55536"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.4167 11.0833V10.4439C13.4167 9.63835 12.7639 8.9856 11.9583 8.9856H11.4911"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.4167 11.0833V10.4439C13.4167 9.63835 12.7639 8.9856 11.9583 8.9856H11.4911"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.583328 11.0833V10.4439C0.583328 9.63835 1.23608 8.9856 2.04166 8.9856H2.50891"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.583328 11.0833V10.4439C0.583328 9.63835 1.23608 8.9856 2.04166 8.9856H2.50891"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1144 11.0832V10.1493C10.1144 9.02175 9.20033 8.10767 8.07274 8.10767H5.92666C4.79908 8.10767 3.88499 9.02175 3.88499 10.1493V11.0832"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1144 11.0832V10.1493C10.1144 9.02175 9.20033 8.10767 8.07274 8.10767H5.92666C4.79908 8.10767 3.88499 9.02175 3.88499 10.1493V11.0832"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconBookMark = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props} viewBox="0 0 14 14" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.78583 3.81378L1.99442 6.32212C1.7045 6.72753 1.7045 7.27295 1.99442 7.67837L3.78583 10.1867C4.00458 10.493 4.35808 10.675 4.73492 10.675H11.0833C11.7279 10.675 12.25 10.1529 12.25 9.50829V4.49162C12.25 3.84703 11.7279 3.32495 11.0833 3.32495H4.73492C4.35808 3.32495 4.00458 3.50695 3.78583 3.81378Z"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.78583 3.81378L1.99442 6.32212C1.7045 6.72753 1.7045 7.27295 1.99442 7.67837L3.78583 10.1867C4.00458 10.493 4.35808 10.675 4.73492 10.675H11.0833C11.7279 10.675 12.25 10.1529 12.25 9.50829V4.49162C12.25 3.84703 11.7279 3.32495 11.0833 3.32495H4.73492C4.35808 3.32495 4.00458 3.50695 3.78583 3.81378Z"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.16746 6.25749C6.57751 6.66754 6.57751 7.33236 6.16746 7.74241C5.75741 8.15246 5.09259 8.15246 4.68254 7.74241C4.27249 7.33236 4.27249 6.66754 4.68254 6.25749C5.09259 5.84744 5.75741 5.84744 6.16746 6.25749"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.16746 6.25749C6.57751 6.66754 6.57751 7.33236 6.16746 7.74241C5.75741 8.15246 5.09259 8.15246 4.68254 7.74241C4.27249 7.33236 4.27249 6.66754 4.68254 6.25749C5.09259 5.84744 5.75741 5.84744 6.16746 6.25749"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconPaperAirePlane = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props} viewBox="0 0 14 14" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.1065 7.08688L6.13958 11.7355C6.2685 12.3147 7.03792 12.4395 7.343 11.9309L12.1549 3.91063C12.418 3.47313 12.103 2.91663 11.5926 2.91663H2.52117C1.93608 2.91663 1.64325 3.62363 2.05683 4.03721L5.1065 7.08688Z"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.1065 7.08688L6.13958 11.7355C6.2685 12.3147 7.03792 12.4395 7.343 11.9309L12.1549 3.91063C12.418 3.47313 12.103 2.91663 11.5926 2.91663H2.52117C1.93608 2.91663 1.64325 3.62363 2.05683 4.03721L5.1065 7.08688Z"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1567 3.24329L5.10416 7.08745"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1567 3.24329L5.10416 7.08745"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconBill = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props} viewBox="0 0 14 14" fill="none">
        <path
            d="M4.66667 4.08329H7"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66667 4.08329H7"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66667 6.41667H7"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66667 6.41667H7"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66667 8.75004H7"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.66667 8.75004H7"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.86933 12.1847L4.92742 11.2134C4.76292 11.1312 4.56983 11.1312 4.40592 11.2134L2.75567 12.0388C2.56142 12.1357 2.33333 11.9951 2.33333 11.7781V2.33333C2.33333 2.01133 2.59467 1.75 2.91667 1.75H11.0833C11.4053 1.75 11.6667 2.01133 11.6667 2.33333V11.7781C11.6667 11.9951 11.4386 12.1357 11.2443 12.0388L9.59408 11.2134C9.42958 11.1312 9.2365 11.1312 9.07258 11.2134L7.13067 12.1847C7.04842 12.2261 6.95158 12.2261 6.86933 12.1847V12.1847Z"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.86933 12.1847L4.92742 11.2134C4.76292 11.1312 4.56983 11.1312 4.40592 11.2134L2.75567 12.0388C2.56142 12.1357 2.33333 11.9951 2.33333 11.7781V2.33333C2.33333 2.01133 2.59467 1.75 2.91667 1.75H11.0833C11.4053 1.75 11.6667 2.01133 11.6667 2.33333V11.7781C11.6667 11.9951 11.4386 12.1357 11.2443 12.0388L9.59408 11.2134C9.42958 11.1312 9.2365 11.1312 9.07258 11.2134L7.13067 12.1847C7.04842 12.2261 6.95158 12.2261 6.86933 12.1847V12.1847Z"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 4.07745C9.33158 4.07745 9.33042 4.07861 9.33042 4.08036C9.33042 4.08211 9.33158 4.08328 9.33333 4.08328C9.33508 4.08328 9.33625 4.08211 9.33625 4.08036C9.33625 4.07861 9.33508 4.07745 9.33333 4.07745"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 4.07745C9.33158 4.07745 9.33042 4.07861 9.33042 4.08036C9.33042 4.08211 9.33158 4.08328 9.33333 4.08328C9.33508 4.08328 9.33625 4.08211 9.33625 4.08036C9.33625 4.07861 9.33508 4.07745 9.33333 4.07745"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 6.41082C9.33158 6.41082 9.33042 6.41199 9.33042 6.41374C9.33042 6.41549 9.33158 6.41665 9.33333 6.41665C9.33508 6.41665 9.33625 6.41549 9.33625 6.41374C9.33625 6.41199 9.33508 6.41082 9.33333 6.41082"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 6.41082C9.33158 6.41082 9.33042 6.41199 9.33042 6.41374C9.33042 6.41549 9.33158 6.41665 9.33333 6.41665C9.33508 6.41665 9.33625 6.41549 9.33625 6.41374C9.33625 6.41199 9.33508 6.41082 9.33333 6.41082"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 8.74419C9.33158 8.74419 9.33042 8.74536 9.33042 8.74711C9.33042 8.74886 9.33158 8.75003 9.33333 8.75003C9.33508 8.75003 9.33625 8.74886 9.33625 8.74711C9.33625 8.74536 9.33508 8.74419 9.33333 8.74419"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.33333 8.74419C9.33158 8.74419 9.33042 8.74536 9.33042 8.74711C9.33042 8.74886 9.33158 8.75003 9.33333 8.75003C9.33508 8.75003 9.33625 8.74886 9.33625 8.74711C9.33625 8.74536 9.33508 8.74419 9.33333 8.74419"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconCompany = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props} viewBox="0 0 14 14" fill="none">
        <path
            d="M8.16716 4.66571V2.33141C8.16723 2.14006 8.26111 1.9609 8.41839 1.85193C8.57568 1.74296 8.7764 1.71802 8.95557 1.78518L11.8735 2.87939C12.1014 2.96483 12.2523 3.18277 12.2522 3.4262V12.2522"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.16716 4.66571V2.33141C8.16723 2.14006 8.26111 1.9609 8.41839 1.85193C8.57568 1.74296 8.7764 1.71802 8.95557 1.78518L11.8735 2.87939C12.1014 2.96483 12.2523 3.18277 12.2522 3.4262V12.2522"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.36599 4.66565H8.63402C9.02078 4.66565 9.33431 4.97918 9.33431 5.36594V12.2521H4.6657V5.36594C4.6657 4.97918 4.97923 4.66565 5.36599 4.66565Z"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.36599 4.66565H8.63402C9.02078 4.66565 9.33431 4.97918 9.33431 5.36594V12.2521H4.6657V5.36594C4.6657 4.97918 4.97923 4.66565 5.36599 4.66565Z"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.41643 4.66565V3.49849C6.41643 3.17619 6.15515 2.91492 5.83285 2.91492H3.49855C3.17625 2.91492 2.91497 3.17619 2.91497 3.49849V6.41638"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.41643 4.66565V3.49849C6.41643 3.17619 6.15515 2.91492 5.83285 2.91492H3.49855C3.17625 2.91492 2.91497 3.17619 2.91497 3.49849V6.41638"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.6657 1.7478V2.91496"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.6657 1.7478V2.91496"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8358 12.2521H1.16424"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8358 12.2521H1.16424"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 7.99211H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 7.99211H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 6.41642H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 6.41642H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 9.56767H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.12463 9.56767H7.87536"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.74782 12.2521V6.99996C1.74782 6.67766 2.00909 6.41638 2.33139 6.41638H4.6657"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.74782 12.2521V6.99996C1.74782 6.67766 2.00909 6.41638 2.33139 6.41638H4.6657"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconCalendar = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" {...props} height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M4.37388 1.7478V3.49853"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.37388 1.7478V3.49853"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.62608 1.7478V3.49853"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.62608 1.7478V3.49853"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.7478 5.54106H12.2522"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.7478 5.54106H12.2522"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1.7478"
            y="2.62317"
            width="10.5044"
            height="9.62901"
            rx="3"
            stroke="currentcolor"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1.7478"
            y="2.62317"
            width="10.5044"
            height="9.62901"
            rx="3"
            stroke="currentcolor"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconCreditCart = (props: any) => (
    <svg width="14" {...props} height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.91787 10.5015V7.00004C9.91796 6.69046 9.79502 6.39355 9.57611 6.17464C9.35721 5.95574 9.06029 5.8328 8.75072 5.83289H2.91496C2.60538 5.8328 2.30846 5.95574 2.08956 6.17464C1.87066 6.39355 1.74772 6.69046 1.7478 7.00004V10.5015C1.74772 10.8111 1.87066 11.108 2.08956 11.3269C2.30846 11.5458 2.60538 11.6687 2.91496 11.6686H8.75072C9.39531 11.6686 9.91787 11.1461 9.91787 10.5015Z"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.7478 8.2133H9.91787" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.61523 5.83279L4.32136 3.19503C4.40148 2.89608 4.59726 2.64131 4.8655 2.48693C5.13375 2.33256 5.4524 2.29127 5.75112 2.37218L11.3885 3.88365C11.6874 3.96376 11.9422 4.15955 12.0966 4.42779C12.2509 4.69603 12.2922 5.01468 12.2113 5.31341L11.3068 8.69232C11.1458 9.30043 10.5304 9.67022 9.91786 9.52683"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconAdd = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.00008 8.33329L4.66675 6.99996L6.00008 5.66663"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 5.66663L9.33333 6.99996L8 8.33329"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1"
            y="1"
            width="12"
            height="12"
            rx="4"
            stroke="currentcolor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconEmail = (props: any) => (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.33333 7C9.33333 8.28858 8.28858 9.33333 7 9.33333C5.71142 9.33333 4.66667 8.28858 4.66667 7C4.66667 5.71142 5.71142 4.66667 7 4.66667V4.66667C8.28858 4.66667 9.33333 5.71142 9.33333 7V7.875C9.33333 8.68058 9.98608 9.33333 10.7917 9.33333C11.5972 9.33333 12.25 8.68058 12.25 7.875V7C12.25 4.10025 9.89975 1.75 7 1.75C4.10025 1.75 1.75 4.10025 1.75 7C1.75 9.89975 4.10025 12.25 7 12.25C7.67025 12.25 8.35158 12.1228 9.009 11.8504C9.36367 11.7034 9.6915 11.5191 9.99425 11.3085"
            stroke="currentcolor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ColIconContact = (props: any) => (
    <svg width="14" height="14" viewBox="0 0 14 14" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0502 10.6937L9.86474 10.2282C9.77082 9.99191 9.62557 9.78016 9.43891 9.6075L9.40507 9.576C9.11166 9.30416 8.72666 9.1525 8.32649 9.1525H5.67232C5.27216 9.1525 4.88657 9.30416 4.59316 9.57541L4.55932 9.60691C4.37324 9.77958 4.22799 9.99133 4.13349 10.2276L3.94916 10.6937"
            stroke="currentcolor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.31015 4.62583C9.03348 5.34917 9.03348 6.52225 8.31015 7.24617C7.58681 7.97008 6.41373 7.9695 5.68981 7.24617C4.9659 6.52283 4.96648 5.34975 5.68981 4.62583C6.41315 3.90192 7.58623 3.9025 8.31015 4.62583"
            stroke="currentcolor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0833 12.25H2.91667C2.27208 12.25 1.75 11.7279 1.75 11.0833V2.91667C1.75 2.27208 2.27208 1.75 2.91667 1.75H11.0833C11.7279 1.75 12.25 2.27208 12.25 2.91667V11.0833C12.25 11.7279 11.7279 12.25 11.0833 12.25Z"
            stroke="currentcolor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const FranceIcon = (props: any) => (
    <svg width="18" height="12" {...props} viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 1C0 0.447715 0.447715 0 1 0H6V12H1C0.447715 12 0 11.5523 0 11V1Z" fill="#307ADE" />
        <path
            d="M0 1C0 0.447715 0.447715 0 1 0H6V12H1C0.447715 12 0 11.5523 0 11V1Z"
            fill="#154492"
            fillOpacity="0.5"
        />
        <rect x="6" width="6" height="12" fill="white" />
        <path d="M12 0H17C17.5523 0 18 0.447715 18 1V11C18 11.5523 17.5523 12 17 12H12V0Z" fill="#C21818" />
    </svg>
)
export const MoreBtnIcon = (props: any) => (
    <svg width="12" height="2" viewBox="0 0 12 2" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.9997 1C10.9997 1.21242 10.8275 1.38462 10.6151 1.38462C10.4027 1.38462 10.2305 1.21242 10.2305 1C10.2305 0.787585 10.4027 0.615387 10.6151 0.615387C10.8275 0.615387 10.9997 0.787585 10.9997 1"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9997 1C10.9997 1.21242 10.8275 1.38462 10.6151 1.38462C10.4027 1.38462 10.2305 1.21242 10.2305 1C10.2305 0.787585 10.4027 0.615387 10.6151 0.615387C10.8275 0.615387 10.9997 0.787585 10.9997 1"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.38471 1C6.38471 1.21242 6.21251 1.38462 6.00009 1.38462C5.78768 1.38462 5.61548 1.21242 5.61548 1C5.61548 0.787585 5.78768 0.615387 6.00009 0.615387C6.21251 0.615387 6.38471 0.787585 6.38471 1"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.38471 1C6.38471 1.21242 6.21251 1.38462 6.00009 1.38462C5.78768 1.38462 5.61548 1.21242 5.61548 1C5.61548 0.787585 5.78768 0.615387 6.00009 0.615387C6.21251 0.615387 6.38471 0.787585 6.38471 1"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.76923 1C1.76923 1.21242 1.59703 1.38462 1.38462 1.38462C1.1722 1.38462 1 1.21242 1 1C1 0.787585 1.1722 0.615387 1.38462 0.615387C1.59703 0.615387 1.76923 0.787585 1.76923 1"
            stroke="black"
            strokeOpacity="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.76923 1C1.76923 1.21242 1.59703 1.38462 1.38462 1.38462C1.1722 1.38462 1 1.21242 1 1C1 0.787585 1.1722 0.615387 1.38462 0.615387C1.59703 0.615387 1.76923 0.787585 1.76923 1"
            stroke="black"
            strokeOpacity="0.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ShildIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.1112 11.3261C19.1112 15.2088 16.305 18.848 12.4622 19.936C12.1618 20.0213 11.8382 20.0213 11.5378 19.936C7.69506 18.8489 4.88879 15.2088 4.88879 11.3261V7.74561C4.88879 7.02382 5.32524 6.37314 5.9937 6.10025L10.3173 4.33134C11.3964 3.88955 12.6053 3.88955 13.6836 4.33134L18.0072 6.10025C18.6748 6.37314 19.1112 7.02382 19.1112 7.74561V11.3261Z"
            fill="none"
            fillOpacity="0.3"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3671 11.9331C13.7546 11.4985 13.9377 10.8789 13.7644 10.222C13.6035 9.61045 13.1022 9.11177 12.4906 8.95266C11.2684 8.63443 10.1697 9.54822 10.1697 10.7189C10.1697 11.1856 10.3448 11.6105 10.6319 11.9331C10.8381 12.1643 10.9217 12.478 10.8372 12.7758L10.4941 13.9785C10.3315 14.5465 10.7581 15.1119 11.3492 15.1119H12.6524C13.2426 15.1119 13.6693 14.5465 13.5075 13.9785L13.1644 12.7758C13.0773 12.478 13.1617 12.1643 13.3671 11.9331V11.9331Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const GraandeBretagneIcon = (props: any) => (
    <svg
        width="18"
        height="12"
        {...props}
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect width="18" height="12" rx="1" fill="url(#pattern0)" />
        <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlinkHref="#image0_3998_11955" transform="matrix(0.00195312 0 0 0.00292969 0 -0.25)" />
            </pattern>
            <image
                id="image0_3998_11955"
                width="512"
                height="512"
                xlinkHref="data:image/png;base64,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"
            />
        </defs>
    </svg>
)
export const StarFav = (props: any) => (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.85572 14.508C4.48224 14.7029 4.03041 14.6686 3.69066 14.4194C3.35092 14.1703 3.18235 13.7497 3.25601 13.3349L3.85213 9.91809L1.3424 7.51299C1.03563 7.22044 0.923202 6.77821 1.05301 6.37467C1.18281 5.97113 1.53198 5.67738 1.95178 5.61854L5.43636 5.12043L7.00955 1.98216C7.19607 1.60579 7.57982 1.36769 7.99988 1.36769C8.41993 1.36769 8.80368 1.60579 8.99021 1.98216L10.5634 5.12043L14.048 5.61854C14.4678 5.67738 14.8169 5.97113 14.9467 6.37467C15.0766 6.77821 14.9641 7.22044 14.6574 7.51299L12.1476 9.91809L12.7437 13.3356C12.8174 13.7504 12.6488 14.171 12.3091 14.4202C11.9693 14.6693 11.5175 14.7036 11.144 14.5087L7.99988 12.8839L4.85572 14.508Z"
            fill="#9747FF"
            fillOpacity="0.3"
            stroke="#9747FF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChorusB2GConfigIcon = (props: any) => (
    <svg width="18" height="16" {...props} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.33329 13V5.5V13Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M2.33329 13V5.5" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M15.6667 5.5V13V5.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M15.6667 5.5V13" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M5.66667 5.5V13V5.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M5.66667 5.5V13" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M8.99992 5.5V13V5.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M8.99992 5.5V13" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.3333 5.5V13V5.5Z" fill="#CE8E5F" fillOpacity="0.3" />
        <path d="M12.3333 5.5V13" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99995 3.22916C8.94245 3.22916 8.89578 3.27582 8.89661 3.33332C8.89661 3.39082 8.94328 3.43749 9.00078 3.43749C9.05828 3.43749 9.10495 3.39082 9.10495 3.33332C9.10411 3.27582 9.05745 3.22916 8.99995 3.22916Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
        />
        <path
            d="M8.99995 3.22916C8.94245 3.22916 8.89578 3.27582 8.89661 3.33332C8.89661 3.39082 8.94328 3.43749 9.00078 3.43749C9.05828 3.43749 9.10495 3.39082 9.10495 3.33332C9.10411 3.27582 9.05745 3.22916 8.99995 3.22916"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9166 5.5H1.08325V3.30083L8.99992 0.5L16.9166 3.30083V5.5Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 13H1.49996L0.666626 13.8333V15.5H17.3333V13.8333L16.5 13Z"
            fill="#CE8E5F"
            fillOpacity="0.3"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DefaultConfigIcon = (props: any) => (
    <svg width="24" height="24" {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91469 14.8969L6.38225 15.9484C6.66621 16.588 7.30031 17 8.00003 17V17C8.69975 17 9.33384 16.588 9.61781 15.9484L10.0854 14.8969C10.2518 14.5238 10.5318 14.2127 10.8854 14.008V14.008C11.2412 13.8027 11.6528 13.7153 12.0614 13.7582L13.2054 13.88C13.9011 13.9536 14.5749 13.6104 14.9245 13.0044V13.0044C15.2745 12.3988 15.2348 11.6438 14.8231 11.0782L14.1458 10.1476C13.9046 9.8137 13.7758 9.41185 13.7778 9V9C13.7777 8.58927 13.9078 8.18908 14.1494 7.85689L14.8267 6.92622C15.2384 6.36067 15.2781 5.60563 14.928 5V5C14.5784 4.39401 13.9046 4.05085 13.2089 4.12444L12.0649 4.24622C11.6564 4.28913 11.2447 4.2017 10.8889 3.99644V3.99644C10.5346 3.7906 10.2546 3.47789 10.0889 3.10311L9.61781 2.05156C9.33384 1.41205 8.69975 1 8.00003 1V1C7.30031 1 6.66621 1.41205 6.38225 2.05156L5.91469 3.10311C5.74904 3.47789 5.46899 3.7906 5.11469 3.99644V3.99644C4.75887 4.2017 4.34723 4.28913 3.93869 4.24622L2.79114 4.12444C2.09542 4.05085 1.42164 4.39401 1.07203 5V5C0.721964 5.60563 0.761684 6.36067 1.17336 6.92622L1.85069 7.85689C2.09225 8.18908 2.22232 8.58927 2.22225 9V9C2.22232 9.41073 2.09225 9.81092 1.85069 10.1431L1.17336 11.0738C0.761684 11.6393 0.721964 12.3944 1.07203 13V13C1.42197 13.6056 2.0955 13.9487 2.79114 13.8756L3.93514 13.7538C4.34367 13.7109 4.75531 13.7983 5.11114 14.0036V14.0036C5.46676 14.2088 5.74811 14.5216 5.91469 14.8969V14.8969Z"
            stroke="#307ADE"
        />
        <circle cx="7.99998" cy="9.00001" r="2.35289" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const EmailConfigIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3332 4.00732V8.66666"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M13.9998 12.6667H9.99976"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M12.6665 11.3333L13.9998 12.6666L12.6665 14"
            stroke="#307ADE"
            fill="#307ADE"
            fillOpacity="0.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.33309 11.3333H3.33309C2.59642 11.3333 1.99976 10.7367 1.99976 9.99999V4.00732"
            stroke="#307ADE"
            fill="#307ADE"
            fillOpacity="0.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.34054 2.66666H11.9932C12.7332 2.66666 13.3339 3.26666 13.3339 4.00732V4.00732C13.3339 4.45199 13.1132 4.86732 12.7452 5.11666L9.17388 7.53732C8.26388 8.15399 7.06921 8.15399 6.15921 7.53732L2.58854 5.11732C2.22054 4.86799 1.99988 4.45199 1.99988 4.00799V4.00732C1.99988 3.26666 2.59988 2.66666 3.34054 2.66666Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#307ADE"
            fillOpacity="0.3"
        />
    </svg>
)
export const PostalConfigIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.811 16.9999V6.02698C16.811 4.56417 15.6251 3.37833 14.1623 3.37833C12.6995 3.37833 11.5137 4.56417 11.5137 6.02698V16.9999"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M16.811 16.9999V6.02698C16.811 4.56417 15.6251 3.37833 14.1623 3.37833V3.37833C12.6995 3.37833 11.5137 4.56417 11.5137 6.02698V16.9999"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.21624 3.37833C4.54445 3.37833 3.18921 4.73357 3.18921 6.40535V16.9999"
            fill="#307ADE"
            fillOpacity="0.3"
        />
        <path
            d="M6.21624 3.37833V3.37833C4.54445 3.37833 3.18921 4.73357 3.18921 6.40535V16.9999"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.21631 3.37838H13.7839" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.8108 16.2432H3.18921" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="5.45947"
            y="10.9459"
            width="3.78378"
            height="2.27027"
            rx="0.5"
            fill="#307ADE"
            fillOpacity="0.3"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.83765 8.67562H8.86467" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const InValidCheckIcon = (props: any) => (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 1C8.76167 1 11 3.23833 11 6C11 8.76167 8.76167 11 6 11C3.23833 11 1 8.76167 1 6C1 3.23833 3.23833 1 6 1Z"
            fill="#DA4FA3"
            fillOpacity="0.3"
            stroke="#DA4FA3"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.00019 6.27778V3.5V6.27778Z"
            fill="#DA4FA3"
            fillOpacity="0.3"
        />
        <path
            d="M6.00019 6.27778V3.5"
            stroke="#DA4FA3"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.99964 8.22214C5.92297 8.22214 5.86075 8.28436 5.8613 8.36103C5.8613 8.4377 5.92353 8.49992 6.00019 8.49992C6.07686 8.49992 6.13908 8.4377 6.13908 8.36103C6.13908 8.28436 6.07686 8.22214 5.99964 8.22214Z"
            fill="#DA4FA3"
            fillOpacity="0.3"
        />
        <path
            d="M5.99964 8.22214C5.92297 8.22214 5.86075 8.28436 5.8613 8.36103C5.8613 8.4377 5.92353 8.49992 6.00019 8.49992C6.07686 8.49992 6.13908 8.4377 6.13908 8.36103C6.13908 8.28436 6.07686 8.22214 5.99964 8.22214"
            stroke="#DA4FA3"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ValidCheckIcon = (props: any) => (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.60095 10.3002C4.76483 10.2785 4.93037 10.3229 5.06091 10.4235L5.66253 10.8851C5.8614 11.0379 6.13804 11.0379 6.33636 10.8851L6.96075 10.4057C7.07741 10.3163 7.22462 10.2768 7.37016 10.2963L8.15121 10.399C8.39952 10.4318 8.63895 10.2935 8.73505 10.0618L9.03558 9.33524C9.09169 9.19914 9.19946 9.09138 9.33556 9.03527L10.0622 8.73474C10.2938 8.63919 10.4321 8.39921 10.3994 8.1509L10.3005 7.39818C10.2788 7.23431 10.3233 7.06877 10.4238 6.93822L10.8854 6.3366C11.0382 6.13773 11.0382 5.86109 10.8854 5.66277L10.406 5.03838C10.3166 4.92172 10.2771 4.77451 10.2966 4.62897L10.3994 3.84792C10.4321 3.59961 10.2938 3.36019 10.0622 3.26408L9.33556 2.96355C9.19946 2.90745 9.09169 2.79968 9.03558 2.66358L8.73505 1.93697C8.6395 1.70532 8.39952 1.567 8.15121 1.59978L7.37016 1.70255C7.22462 1.72255 7.07741 1.6831 6.96131 1.59422L6.33692 1.11482C6.13804 0.962053 5.8614 0.962053 5.66308 1.11482L5.03869 1.59422C4.92203 1.6831 4.77482 1.72255 4.62928 1.70366L3.84823 1.60089C3.59992 1.56811 3.3605 1.70644 3.26439 1.93808L2.96442 2.66469C2.90776 2.80023 2.79999 2.908 2.66444 2.96466L1.93784 3.26464C1.70619 3.36074 1.56787 3.60017 1.60064 3.84848L1.70341 4.62952C1.7223 4.77507 1.68286 4.92228 1.59398 5.03838L1.11457 5.66277C0.961809 5.86164 0.961809 6.13829 1.11457 6.3366L1.59398 6.961C1.68342 7.07765 1.72286 7.22486 1.70341 7.37041L1.60064 8.15145C1.56787 8.39977 1.70619 8.63919 1.93784 8.73529L2.66444 9.03582C2.80054 9.09193 2.90831 9.1997 2.96442 9.3358L3.26495 10.0624C3.3605 10.2941 3.60048 10.4324 3.84879 10.3996L4.60095 10.3002Z"
            fill="#27AE60"
            fillOpacity="0.3"
        />
        <path
            d="M4.60095 10.3002C4.76483 10.2785 4.93037 10.3229 5.06091 10.4235L5.66253 10.8851C5.8614 11.0379 6.13804 11.0379 6.33636 10.8851L6.96075 10.4057C7.07741 10.3163 7.22462 10.2768 7.37016 10.2963L8.15121 10.399C8.39952 10.4318 8.63895 10.2935 8.73505 10.0618L9.03558 9.33524C9.09169 9.19914 9.19946 9.09138 9.33556 9.03527L10.0622 8.73474C10.2938 8.63919 10.4321 8.39921 10.3994 8.1509L10.3005 7.39818C10.2788 7.23431 10.3233 7.06877 10.4238 6.93822L10.8854 6.3366C11.0382 6.13773 11.0382 5.86109 10.8854 5.66277L10.406 5.03838C10.3166 4.92172 10.2771 4.77451 10.2966 4.62897L10.3994 3.84792C10.4321 3.59961 10.2938 3.36019 10.0622 3.26408L9.33556 2.96355C9.19946 2.90745 9.09169 2.79968 9.03558 2.66358L8.73505 1.93697C8.6395 1.70532 8.39952 1.567 8.15121 1.59978L7.37016 1.70255C7.22462 1.72255 7.07741 1.6831 6.96131 1.59422L6.33692 1.11482C6.13804 0.962053 5.8614 0.962053 5.66308 1.11482L5.03869 1.59422C4.92203 1.6831 4.77482 1.72255 4.62928 1.70366L3.84823 1.60089C3.59992 1.56811 3.3605 1.70644 3.26439 1.93808L2.96442 2.66469C2.90776 2.80023 2.79999 2.908 2.66444 2.96466L1.93784 3.26464C1.70619 3.36074 1.56787 3.60017 1.60064 3.84848L1.70341 4.62952C1.7223 4.77507 1.68286 4.92228 1.59398 5.03838L1.11457 5.66277C0.961809 5.86164 0.961809 6.13829 1.11457 6.3366L1.59398 6.961C1.68342 7.07765 1.72286 7.22486 1.70341 7.37041L1.60064 8.15145C1.56787 8.39977 1.70619 8.63919 1.93784 8.73529L2.66444 9.03582C2.80054 9.09193 2.90831 9.1997 2.96442 9.3358L3.26495 10.0624C3.3605 10.2941 3.60048 10.4324 3.84879 10.3996L4.60095 10.3002"
            stroke="#27AE60"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.55458 5.22266L5.60974 7.16749L4.44373 6.00092"
            fill="#27AE60"
            fillOpacity="0.3"
        />
        <path
            d="M7.55458 5.22266L5.60974 7.16749L4.44373 6.00092"
            stroke="#27AE60"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChorusLongIcon = (props: any) => (
    <svg
        width="41"
        height="14"
        viewBox="0 0 41 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect y="2" width="40.5" height="10" fill="url(#pattern0_6188_3289)" />
        <defs>
            <pattern id="pattern0_6188_3289" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlinkHref="#image0_6188_3289" transform="matrix(0.00222222 0 0 0.009 0 -0.4)" />
            </pattern>
            <image
                id="image0_6188_3289"
                width="450"
                height="200"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAADICAMAAABMKhGlAAAACXBIWXMAAAWPAAAFjwHta9lhAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAMAUExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFpusyYzdeMGE1pus1pusyYzdSYzdSYzdT1LmlpusyYzdVpusyYzdSYzdSYzdVpus1pusyYzdSYzdSYzdVpus0ZVoiYzdVpusyYzdSYzdeMGE+MGE2h5ueMGEyYzdVpus+MGE3iFweMGE1pus1pus1pus+MGE1pus+MGE1pus+MGE+MGE+MGE52dnJ2dnJ2dnJ2dnEJQnuMGE+MGE2p7unyIwmd4uZ2dnOMGE0BOnElZpHmFwT5LmkRToEpcpmR2uGp6um18uz5LmneEwFNlreMGE52dnJ2dnJ2dnJ2dnJ2dnJ2dnAAAAOMGEyYzdVpuszVClH2Jw1BiqlxwtJ2dnE5fqFJlrFZor2N0t2FztWpqamtra2xsbG1tbW5ubm9vb3BwcHFxcXJycnNzc3R0dHV1dXZ2dnd3d3h4eHl5eXp6ent7e3x8fH19fX5+fn9/f4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///0AjLUoAAAABdFJOUwBA5thmAAAJEElEQVR42uycyW/kNhaHqYUSSW0FlA82fLAPDnwxYBjthtHHBpIAM8lMlpmjAMVpZJn//x+YQ5WrJPFxU6nKLfv3nRJ3LeL7KJLvkSrGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFE+ZYIsVgost0iEYuvE1HJOs/zPJeV4FB4eq6uVxtu1+vbm9B3J1XeDiiq5K0rjOSIRtBd90RcXHY9Li/C7r+6JcjF21aYU42OVfRaGlfdgFXIHUi2hZD4HhS2bZuqZGEKZWuh5O9PYdumckkKedFaibN3qLBtc74YhVnaOkjFe1TYFnwhCt0G27aN3qPCtl6GQi+DbZu9R4VtswSFPNaGj7yUuda0NHmPCuNXVvg4oQ1q1++ESqklzZtVWIkNkXrN23CkcO3xlsqcPjDeSzVq/tYH0v2KLest0NVXr5D377RYaPNkrPl6BwpZkh5pJL1YrVarp/V6vTYVQMMVlo4l9CZj7OUUmkIuhPApKwrP182BEEKIZLrCfqWDT/hqUzNv3AXQkcJb903oTIJ40bZFYqrOZOrlNi2kJWTN7mVtWlfuoGSyzGs5bRriVbH7Ko9KJ60wa8k/70VJlSuZ2ZpJffft0M+1U6FHmVvqK059qFX0W+S4rlrSAeNynLUQ5cddQYQxLl8CMfq3lpkupP/XdFgk45MUsrFCMbjAdPffYc1cuzOGp67rusftftPHK3eXjYncXVNgilylZSMZtV6i0k7FjQpFPFYWoFCvFKbR3AqjtKfT0HUMnfrRrfBD192H7DD1xovc9z27yBHXnGoOuSHvGr9ydxlR70XBCslar5pjIN0rVFTMTM2Ms8C8/brrLq9C5o3SMeQ7xl7ikkfdLivcFbuBpkG/CFZIB1LNsJwRZBncXeAaDgJOhR8vu+4paOovJqydrQpH4eKpT9V1OHAdoDAyfFN1QFKRMrdCa4my8VZ4c33fdV13FqSwN2rPpLBNGLOPa3rVdTaF8YT9BldqX7sV2pvZnzJ2Cr/88vDw8PB9RxE0jmYTxlGXQmVIOh2j7hwK981RGeONCpwLXwpsjSLGCpvC2t7MXg96Ufi/756fn5+f70iFYWloa4iOt8JUNUKIqt/9OfXxbRuXQggRDZpbzquwGv1hczOpWcrcFoWN3sxq0Ew5VvhlY3AOhXI84ocq3BVOS2rsz6lZPanJUVfbLMnzNFShHPciXlhyJT+FkUFhnuf5VmGv/8b7ZuZUxr1V+O3zERTmkxSW1JhZEjfhYDaqqFF3EJ5tIJJDFTJeOI+ce275DhTWTe8CI0MzFXEbbhX+Z6vw51dXqMi15+6jatN6onfzc12hnosHKwwpwHsevBDkIRRrM5U+xl1vJD1sFX5LKrw4ncKCTjFj3UpmDFujvVivDoTPhSEOPY8/CZMobq5QFlozry77Cn/4Qiq8maawmPAmaVgaaX9Q5mWU0jQJNllhRk1KByiU1CWPu1hk7jdCn1w2p+2/v7u7u/vpb9pgWF7YHLQiHV5yMv4oSaaKo/5ZEGXuyQoHeWGqssMUDovUwnSBpWVXKja8ad3ZCFIozGNdsEIt0LXlDpealVkUjlLWIpqqUN8qMirMLVdeGq58RoXcrwY1TWFuKfwIrevOopCNyyRpFaBQbR6LqcgNW7dCaRvljqawN/LUx1MobWUhMatCvdRVZN4KhdeAlZsuTtp66vEUqtYyYR1RITuSQmq/MDuRwuh1FEYTTmrNoVAcSyGxw+xweKjC9JXvQt6G34bBCpXPJDGbwt65Da+E6VCFtik/OoFCpjy27ctskkJl2Yos51BYGvv/sJhuL5POprCwRDf1UPjnP7/Z8N/twRnPKo1onVuGcrRc9VUoLQmLnjB5KeR08IiTbkn/KEt9TIW29DcNyAs///bC7y+n1zzLNLmrt0aDHYkAhZbqTKR3G5vCmHaVWmPPPbdhDlXY+DRTOhX++zdNYfch/DakZq1SW5v7KtyHeByc3oM4jY9CelYVrllceJWeDlXIjeWR3qmTzKnwR0Khb7W0tmVRWa7vH3grVKZFIVHCtyqkx6qcmmuz/nihTqGw15rYMNBrqwFC4Tml0HNhMzqhpHoNyRR1i3orzOiFPac20qwKyV2Ciho7srT/f/IkCgV95JDX5tLX7bwKtf3oWFVCCFGVMX0Uy1vhYJ7dnaqOeh+73y60KuwNycU2zpw8JpClg3k7P4nCoGYOdn5nU8gqr4d8dysPf4XJcANcNuN+IZmfwn75upCNqPpPPu5HqSYdPJ8VeSWGhyvM9Gaq2JrU2BX+MSFDVD4GVfBc6DzsVjBPhYntnCZxirSQg3No5XEVupqpv8Ou8JspSb4KMBii0H48b7DLbS8wSI9+ILyOth5DIbOfI+WnUGg8Bk115BCFtkOyw2Wqo0ZUuM8TG79ryjMVYQr9m3msgZT1nualL6Nh0xQaHxfRmuZQaAxS5HxNzI+u0OKQLLJ/sir8a2rB2zJWDZ8kC1JoPNGdJyxEoSFIo9NuyjeGcys0N5PuPx8sCv81ueDNEsOMOP4pxECFTBDB13fTncV2TgRJ289ttHVP4dqAmUlh/7FI97ONwwe2Bwo/T9+zYIwllRbtuNRCYPph55c/622MRqNpTDx6+/Jmy+px/GOb1Cm10U6Txy/hlbvrtt6umfsCo1H0YssT6Rfj7P7X8/Pz8/Pzf/zeHaSQMZZEar97UlcZm4ekqrehTXOZHfdjmnLbgrg+9a+HH9BMcv/p0/RL4b4/FxHGTJ/q8zGZeJ1fE90Eb8LPepAKVwwsB1LhI+KyIJ4Of7wCvC4fSYXrK0RmOdySDu8/ITILug9XA57W2/x/vefxBmFaFhercQXgEpPj4iTed+5fbQNfNWfIFBfPByh8Yyk/FC6PFRRCIYBCAIVQCIVQCKAQHMI1CmxL52pQJb3H/uESHX5crVar67Ozs7OzM4QDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4Jj8fwAaNvMObnogTAAAAABJRU5ErkJggg=="
            />
        </defs>
    </svg>
)
export const SendSubIcon = (props: any) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.12287 5.52209L5.1175 9.99764C5.24162 10.5553 5.9824 10.6755 6.27612 10.1858L10.9089 2.46407C11.1622 2.04285 10.8589 1.50706 10.3675 1.50706H1.63377C1.07046 1.50706 0.788529 2.18775 1.18672 2.58594L4.12287 5.52209Z"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.12287 5.52209L5.1175 9.99764C5.24162 10.5553 5.9824 10.6755 6.27612 10.1858L10.9089 2.46407C11.1622 2.04285 10.8589 1.50706 10.3675 1.50706H1.63377C1.07046 1.50706 0.788529 2.18775 1.18672 2.58594L4.12287 5.52209Z"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9108 1.82148L4.12077 5.52256"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.9108 1.82148L4.12077 5.52256"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChorusIconBuilding = (props: any) => (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.40017 11.2V4.90004V11.2Z" fill="#CE8E5F" fillOpacity="0.1" />
        <path d="M2.40017 11.2V4.90004" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M13.6 4.90004V11.2V4.90004Z" fill="#CE8E5F" fillOpacity="0.1" />
        <path d="M13.6 4.90004V11.2" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.19991 4.90004V11.2V4.90004Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
        />
        <path d="M5.19991 4.90004V11.2" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00009 4.90004V11.2V4.90004Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
        />
        <path d="M8.00009 4.90004V11.2" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7998 4.90004V11.2V4.90004Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
        />
        <path d="M10.7998 4.90004V11.2" stroke="#CE8E5F" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99982 2.99235C7.95152 2.99235 7.91232 3.03155 7.91302 3.07985C7.91302 3.12815 7.95222 3.16735 8.00052 3.16735C8.04882 3.16735 8.08802 3.12815 8.08802 3.07985C8.08732 3.03155 8.04812 2.99235 7.99982 2.99235Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
        />
        <path
            d="M7.99982 2.99235C7.95152 2.99235 7.91232 3.03155 7.91302 3.07985C7.91302 3.12815 7.95222 3.16735 8.00052 3.16735C8.04882 3.16735 8.08802 3.12815 8.08802 3.07985C8.08732 3.03155 8.04812 2.99235 7.99982 2.99235"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6499 4.9H1.34991V3.0527L7.99991 0.700001L14.6499 3.0527V4.9Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3 11.2H1.7L1 11.9V13.3H15V11.9L14.3 11.2Z"
            fill="#CE8E5F"
            fillOpacity="0.1"
            stroke="#CE8E5F"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const MainDocIcon = (props: any) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.50005 11C3.50005 9.77273 2.50513 8.77781 1.27783 8.77781C2.50513 8.77781 3.50005 7.78289 3.50005 6.55559C3.50005 7.78289 4.49498 8.77781 5.72228 8.77781C4.49498 8.77781 3.50005 9.77273 3.50005 11Z"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.38904 11H9.33348C10.1005 11 10.7224 10.3782 10.7224 9.61111V3.98426C10.7224 3.54223 10.5468 3.11831 10.2342 2.80575L8.91662 1.48816C8.60406 1.17559 8.18014 1 7.73811 1H3.77793C3.01086 1 2.38904 1.62183 2.38904 2.38889V4.33333"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.7089 3.77773H8.77755C8.31731 3.77773 7.94421 3.40464 7.94421 2.9444V1.01308"
            stroke="currentColor"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
